/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type {DocumentNode} from "graphql/language/ast";
import type * as Types from './CimSchemaGenerated';

import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BaseVoltagesQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface BaseVoltagesQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection' }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type BusbarSectionsByIdsQueryVariables = Exact<{
  modelName: string;
  ids: Array<string | number> | string | number;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface BusbarSectionsByIdsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type BusbarSectionsBySubstationsQueryVariables = Exact<{
  modelName: string;
  substationIds?: Array<string | number> | string | number | null | undefined;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface BusbarSectionsBySubstationsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection' }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation', id: string, name: string, Region: { __typename: 'SubGeographicalRegion', id: string, name: string }, voltageLevels: Array<{ __typename: 'VoltageLevel', busbars: Array<
            | { __typename: 'ACLineSegment' }
            | { __typename: 'AsynchronousMachine' }
            | { __typename: 'BatteryUnit' }
            | { __typename: 'BusbarSection', id: string, name: string }
            | { __typename: 'Clamp' }
            | { __typename: 'CompositeSwitch' }
            | { __typename: 'Cut' }
            | { __typename: 'DisconnectingCircuitBreaker' }
            | { __typename: 'Disconnector' }
            | { __typename: 'EnergyConsumer' }
            | { __typename: 'EnergySource' }
            | { __typename: 'EquivalentBranch' }
            | { __typename: 'EquivalentInjection' }
            | { __typename: 'EquivalentShunt' }
            | { __typename: 'ExternalNetworkInjection' }
            | { __typename: 'FrequencyConverter' }
            | { __typename: 'Fuse' }
            | { __typename: 'Ground' }
            | { __typename: 'GroundDisconnector' }
            | { __typename: 'GroundingImpedance' }
            | { __typename: 'HydroGeneratingUnit' }
            | { __typename: 'HydroPump' }
            | { __typename: 'Jumper' }
            | { __typename: 'Junction' }
            | { __typename: 'LinearShuntCompensator' }
            | { __typename: 'LoadBreakSwitch' }
            | { __typename: 'NonlinearShuntCompensator' }
            | { __typename: 'NuclearGeneratingUnit' }
            | { __typename: 'PetersenCoil' }
            | { __typename: 'PhotoVoltaicUnit' }
            | { __typename: 'PowerElectronicsConnection' }
            | { __typename: 'PowerElectronicsWindUnit' }
            | { __typename: 'PowerTransformer' }
            | { __typename: 'Recloser' }
            | { __typename: 'Sectionaliser' }
            | { __typename: 'SeriesCompensator' }
            | { __typename: 'SolarGeneratingUnit' }
            | { __typename: 'StaticVarCompensator' }
            | { __typename: 'SynchronousMachine' }
            | { __typename: 'ThermalGeneratingUnit' }
            | { __typename: 'TransformerTank' }
            | { __typename: 'WindGeneratingUnit' }
            | { __typename: 'WireSegment' }
          >, baseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }> }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type NextPageInfoFragment = { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string } };

type Identification_AcLineSegment_Fragment = { __typename: 'ACLineSegment', id: string, name: string };

type Identification_AcLineSegmentPhase_Fragment = { __typename: 'ACLineSegmentPhase', id: string, name: string };

type Identification_ActivePowerLimit_Fragment = { __typename: 'ActivePowerLimit', id: string, name: string };

type Identification_Agreement_Fragment = { __typename: 'Agreement', id: string, name: string };

type Identification_AirCompressor_Fragment = { __typename: 'AirCompressor', id: string, name: string };

type Identification_ApparentPowerLimit_Fragment = { __typename: 'ApparentPowerLimit', id: string, name: string };

type Identification_Appointment_Fragment = { __typename: 'Appointment', id: string, name: string };

type Identification_Approver_Fragment = { __typename: 'Approver', id: string, name: string };

type Identification_AsynchronousMachine_Fragment = { __typename: 'AsynchronousMachine', id: string, name: string };

type Identification_Author_Fragment = { __typename: 'Author', id: string, name: string };

type Identification_BaseFrequency_Fragment = { __typename: 'BaseFrequency', id: string, name: string };

type Identification_BasePower_Fragment = { __typename: 'BasePower', id: string, name: string };

type Identification_BaseVoltage_Fragment = { __typename: 'BaseVoltage', id: string, name: string };

type Identification_BatteryUnit_Fragment = { __typename: 'BatteryUnit', id: string, name: string };

type Identification_Bay_Fragment = { __typename: 'Bay', id: string, name: string };

type Identification_BranchGroup_Fragment = { __typename: 'BranchGroup', id: string, name: string };

type Identification_BusNameMarker_Fragment = { __typename: 'BusNameMarker', id: string, name: string };

type Identification_BusbarSection_Fragment = { __typename: 'BusbarSection', id: string, name: string };

type Identification_BusbarSectionInfo_Fragment = { __typename: 'BusbarSectionInfo', id: string, name: string };

type Identification_BushingInfo_Fragment = { __typename: 'BushingInfo', id: string, name: string };

type Identification_CaesPlant_Fragment = { __typename: 'CAESPlant', id: string, name: string };

type Identification_Clamp_Fragment = { __typename: 'Clamp', id: string, name: string };

type Identification_CogenerationPlant_Fragment = { __typename: 'CogenerationPlant', id: string, name: string };

type Identification_CombinedCyclePlant_Fragment = { __typename: 'CombinedCyclePlant', id: string, name: string };

type Identification_CompositeSwitch_Fragment = { __typename: 'CompositeSwitch', id: string, name: string };

type Identification_ConcentricNeutralCableInfo_Fragment = { __typename: 'ConcentricNeutralCableInfo', id: string, name: string };

type Identification_ConfigurationEvent_Fragment = { __typename: 'ConfigurationEvent', id: string, name: string };

type Identification_ConnectivityNode_Fragment = { __typename: 'ConnectivityNode', id: string, name: string };

type Identification_CoordinateSystem_Fragment = { __typename: 'CoordinateSystem', id: string, name: string };

type Identification_Crew_Fragment = { __typename: 'Crew', id: string, name: string };

type Identification_CrewMember_Fragment = { __typename: 'CrewMember', id: string, name: string };

type Identification_CrewType_Fragment = { __typename: 'CrewType', id: string, name: string };

type Identification_CurrentLimit_Fragment = { __typename: 'CurrentLimit', id: string, name: string };

type Identification_Cut_Fragment = { __typename: 'Cut', id: string, name: string };

type Identification_DisconnectingCircuitBreaker_Fragment = { __typename: 'DisconnectingCircuitBreaker', id: string, name: string };

type Identification_Disconnector_Fragment = { __typename: 'Disconnector', id: string, name: string };

type Identification_Editor_Fragment = { __typename: 'Editor', id: string, name: string };

type Identification_EmissionAccount_Fragment = { __typename: 'EmissionAccount', id: string, name: string };

type Identification_EmissionCurve_Fragment = { __typename: 'EmissionCurve', id: string, name: string };

type Identification_EnergyConsumer_Fragment = { __typename: 'EnergyConsumer', id: string, name: string };

type Identification_EnergyConsumerPhase_Fragment = { __typename: 'EnergyConsumerPhase', id: string, name: string };

type Identification_EnergySchedulingType_Fragment = { __typename: 'EnergySchedulingType', id: string, name: string };

type Identification_EnergySource_Fragment = { __typename: 'EnergySource', id: string, name: string };

type Identification_EnergySourcePhase_Fragment = { __typename: 'EnergySourcePhase', id: string, name: string };

type Identification_EquivalentBranch_Fragment = { __typename: 'EquivalentBranch', id: string, name: string };

type Identification_EquivalentInjection_Fragment = { __typename: 'EquivalentInjection', id: string, name: string };

type Identification_EquivalentNetwork_Fragment = { __typename: 'EquivalentNetwork', id: string, name: string };

type Identification_EquivalentShunt_Fragment = { __typename: 'EquivalentShunt', id: string, name: string };

type Identification_ExternalNetworkInjection_Fragment = { __typename: 'ExternalNetworkInjection', id: string, name: string };

type Identification_Feeder_Fragment = { __typename: 'Feeder', id: string, name: string };

type Identification_FieldDispatchHistory_Fragment = { __typename: 'FieldDispatchHistory', id: string, name: string };

type Identification_FossilFuel_Fragment = { __typename: 'FossilFuel', id: string, name: string };

type Identification_FrequencyConverter_Fragment = { __typename: 'FrequencyConverter', id: string, name: string };

type Identification_FuelAllocationSchedule_Fragment = { __typename: 'FuelAllocationSchedule', id: string, name: string };

type Identification_Fuse_Fragment = { __typename: 'Fuse', id: string, name: string };

type Identification_GenUnitOpCostCurve_Fragment = { __typename: 'GenUnitOpCostCurve', id: string, name: string };

type Identification_GenUnitOpSchedule_Fragment = { __typename: 'GenUnitOpSchedule', id: string, name: string };

type Identification_GeographicalRegion_Fragment = { __typename: 'GeographicalRegion', id: string, name: string };

type Identification_GrossToNetActivePowerCurve_Fragment = { __typename: 'GrossToNetActivePowerCurve', id: string, name: string };

type Identification_Ground_Fragment = { __typename: 'Ground', id: string, name: string };

type Identification_GroundDisconnector_Fragment = { __typename: 'GroundDisconnector', id: string, name: string };

type Identification_GroundingImpedance_Fragment = { __typename: 'GroundingImpedance', id: string, name: string };

type Identification_Hazard_Fragment = { __typename: 'Hazard', id: string, name: string };

type Identification_HeatInputCurve_Fragment = { __typename: 'HeatInputCurve', id: string, name: string };

type Identification_HeatRateCurve_Fragment = { __typename: 'HeatRateCurve', id: string, name: string };

type Identification_HydroGeneratingEfficiencyCurve_Fragment = { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string };

type Identification_HydroGeneratingUnit_Fragment = { __typename: 'HydroGeneratingUnit', id: string, name: string };

type Identification_HydroPowerPlant_Fragment = { __typename: 'HydroPowerPlant', id: string, name: string };

type Identification_HydroPump_Fragment = { __typename: 'HydroPump', id: string, name: string };

type Identification_HydroPumpOpSchedule_Fragment = { __typename: 'HydroPumpOpSchedule', id: string, name: string };

type Identification_IncrementalHeatRateCurve_Fragment = { __typename: 'IncrementalHeatRateCurve', id: string, name: string };

type Identification_InflowForecast_Fragment = { __typename: 'InflowForecast', id: string, name: string };

type Identification_InterrupterUnitInfo_Fragment = { __typename: 'InterrupterUnitInfo', id: string, name: string };

type Identification_IrregularIntervalSchedule_Fragment = { __typename: 'IrregularIntervalSchedule', id: string, name: string };

type Identification_Issuer_Fragment = { __typename: 'Issuer', id: string, name: string };

type Identification_Jumper_Fragment = { __typename: 'Jumper', id: string, name: string };

type Identification_Junction_Fragment = { __typename: 'Junction', id: string, name: string };

type Identification_LevelVsVolumeCurve_Fragment = { __typename: 'LevelVsVolumeCurve', id: string, name: string };

type Identification_Line_Fragment = { __typename: 'Line', id: string, name: string };

type Identification_LinearShuntCompensator_Fragment = { __typename: 'LinearShuntCompensator', id: string, name: string };

type Identification_LinearShuntCompensatorPhase_Fragment = { __typename: 'LinearShuntCompensatorPhase', id: string, name: string };

type Identification_LoadBreakSwitch_Fragment = { __typename: 'LoadBreakSwitch', id: string, name: string };

type Identification_Location_Fragment = { __typename: 'Location', id: string, name: string };

type Identification_MutualCoupling_Fragment = { __typename: 'MutualCoupling', id: string, name: string };

type Identification_NoLoadTest_Fragment = { __typename: 'NoLoadTest', id: string, name: string };

type Identification_NonlinearShuntCompensator_Fragment = { __typename: 'NonlinearShuntCompensator', id: string, name: string };

type Identification_NonlinearShuntCompensatorPhase_Fragment = { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string };

type Identification_NuclearGeneratingUnit_Fragment = { __typename: 'NuclearGeneratingUnit', id: string, name: string };

type Identification_OpenCircuitTest_Fragment = { __typename: 'OpenCircuitTest', id: string, name: string };

type Identification_OperatingMechanismInfo_Fragment = { __typename: 'OperatingMechanismInfo', id: string, name: string };

type Identification_OperatingParticipant_Fragment = { __typename: 'OperatingParticipant', id: string, name: string };

type Identification_OperationalLimitSet_Fragment = { __typename: 'OperationalLimitSet', id: string, name: string };

type Identification_OperationalLimitType_Fragment = { __typename: 'OperationalLimitType', id: string, name: string };

type Identification_Operator_Fragment = { __typename: 'Operator', id: string, name: string };

type Identification_OrganisationRole_Fragment = { __typename: 'OrganisationRole', id: string, name: string };

type Identification_OverheadWireInfo_Fragment = { __typename: 'OverheadWireInfo', id: string, name: string };

type Identification_Ownership_Fragment = { __typename: 'Ownership', id: string, name: string };

type Identification_PsrType_Fragment = { __typename: 'PSRType', id: string, name: string };

type Identification_ParentOrganization_Fragment = { __typename: 'ParentOrganization', id: string, name: string };

type Identification_PenstockLossCurve_Fragment = { __typename: 'PenstockLossCurve', id: string, name: string };

type Identification_PerLengthPhaseImpedance_Fragment = { __typename: 'PerLengthPhaseImpedance', id: string, name: string };

type Identification_PerLengthSequenceImpedance_Fragment = { __typename: 'PerLengthSequenceImpedance', id: string, name: string };

type Identification_Person_Fragment = { __typename: 'Person', id: string, name: string };

type Identification_PetersenCoil_Fragment = { __typename: 'PetersenCoil', id: string, name: string };

type Identification_PhaseTapChangerAsymmetrical_Fragment = { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string };

type Identification_PhaseTapChangerLinear_Fragment = { __typename: 'PhaseTapChangerLinear', id: string, name: string };

type Identification_PhaseTapChangerSymmetrical_Fragment = { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string };

type Identification_PhaseTapChangerTable_Fragment = { __typename: 'PhaseTapChangerTable', id: string, name: string };

type Identification_PhaseTapChangerTabular_Fragment = { __typename: 'PhaseTapChangerTabular', id: string, name: string };

type Identification_PhotoVoltaicUnit_Fragment = { __typename: 'PhotoVoltaicUnit', id: string, name: string };

type Identification_Plant_Fragment = { __typename: 'Plant', id: string, name: string };

type Identification_PowerElectronicsConnection_Fragment = { __typename: 'PowerElectronicsConnection', id: string, name: string };

type Identification_PowerElectronicsConnectionPhase_Fragment = { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string };

type Identification_PowerElectronicsWindUnit_Fragment = { __typename: 'PowerElectronicsWindUnit', id: string, name: string };

type Identification_PowerTransformer_Fragment = { __typename: 'PowerTransformer', id: string, name: string };

type Identification_PowerTransformerEnd_Fragment = { __typename: 'PowerTransformerEnd', id: string, name: string };

type Identification_PowerTransformerInfo_Fragment = { __typename: 'PowerTransformerInfo', id: string, name: string };

type Identification_RatioTapChanger_Fragment = { __typename: 'RatioTapChanger', id: string, name: string };

type Identification_RatioTapChangerTable_Fragment = { __typename: 'RatioTapChangerTable', id: string, name: string };

type Identification_ReactiveCapabilityCurve_Fragment = { __typename: 'ReactiveCapabilityCurve', id: string, name: string };

type Identification_Recloser_Fragment = { __typename: 'Recloser', id: string, name: string };

type Identification_RegulationSchedule_Fragment = { __typename: 'RegulationSchedule', id: string, name: string };

type Identification_ReportingGroup_Fragment = { __typename: 'ReportingGroup', id: string, name: string };

type Identification_ReportingSuperGroup_Fragment = { __typename: 'ReportingSuperGroup', id: string, name: string };

type Identification_Reservoir_Fragment = { __typename: 'Reservoir', id: string, name: string };

type Identification_ScheduledEvent_Fragment = { __typename: 'ScheduledEvent', id: string, name: string };

type Identification_Sectionaliser_Fragment = { __typename: 'Sectionaliser', id: string, name: string };

type Identification_SeriesCompensator_Fragment = { __typename: 'SeriesCompensator', id: string, name: string };

type Identification_ShortCircuitTest_Fragment = { __typename: 'ShortCircuitTest', id: string, name: string };

type Identification_ShuntCompensatorInfo_Fragment = { __typename: 'ShuntCompensatorInfo', id: string, name: string };

type Identification_ShutdownCurve_Fragment = { __typename: 'ShutdownCurve', id: string, name: string };

type Identification_SolarGeneratingUnit_Fragment = { __typename: 'SolarGeneratingUnit', id: string, name: string };

type Identification_StartIgnFuelCurve_Fragment = { __typename: 'StartIgnFuelCurve', id: string, name: string };

type Identification_StartMainFuelCurve_Fragment = { __typename: 'StartMainFuelCurve', id: string, name: string };

type Identification_StartRampCurve_Fragment = { __typename: 'StartRampCurve', id: string, name: string };

type Identification_StartupModel_Fragment = { __typename: 'StartupModel', id: string, name: string };

type Identification_StaticVarCompensator_Fragment = { __typename: 'StaticVarCompensator', id: string, name: string };

type Identification_SteamSendoutSchedule_Fragment = { __typename: 'SteamSendoutSchedule', id: string, name: string };

type Identification_SubGeographicalRegion_Fragment = { __typename: 'SubGeographicalRegion', id: string, name: string };

type Identification_Substation_Fragment = { __typename: 'Substation', id: string, name: string };

type Identification_SwitchInfo_Fragment = { __typename: 'SwitchInfo', id: string, name: string };

type Identification_SwitchPhase_Fragment = { __typename: 'SwitchPhase', id: string, name: string };

type Identification_SwitchSchedule_Fragment = { __typename: 'SwitchSchedule', id: string, name: string };

type Identification_SynchronousMachine_Fragment = { __typename: 'SynchronousMachine', id: string, name: string };

type Identification_TailbayLossCurve_Fragment = { __typename: 'TailbayLossCurve', id: string, name: string };

type Identification_TapChangerControl_Fragment = { __typename: 'TapChangerControl', id: string, name: string };

type Identification_TapChangerInfo_Fragment = { __typename: 'TapChangerInfo', id: string, name: string };

type Identification_TapSchedule_Fragment = { __typename: 'TapSchedule', id: string, name: string };

type Identification_TapeShieldCableInfo_Fragment = { __typename: 'TapeShieldCableInfo', id: string, name: string };

type Identification_TargetLevelSchedule_Fragment = { __typename: 'TargetLevelSchedule', id: string, name: string };

type Identification_Terminal_Fragment = { __typename: 'Terminal', id: string, name: string };

type Identification_ThermalGeneratingUnit_Fragment = { __typename: 'ThermalGeneratingUnit', id: string, name: string };

type Identification_TimePoint_Fragment = { __typename: 'TimePoint', id: string, name: string };

type Identification_TimeSchedule_Fragment = { __typename: 'TimeSchedule', id: string, name: string };

type Identification_TopologicalIsland_Fragment = { __typename: 'TopologicalIsland', id: string, name: string };

type Identification_TopologicalNode_Fragment = { __typename: 'TopologicalNode', id: string, name: string };

type Identification_TransformerCoreAdmittance_Fragment = { __typename: 'TransformerCoreAdmittance', id: string, name: string };

type Identification_TransformerEndInfo_Fragment = { __typename: 'TransformerEndInfo', id: string, name: string };

type Identification_TransformerMeshImpedance_Fragment = { __typename: 'TransformerMeshImpedance', id: string, name: string };

type Identification_TransformerStarImpedance_Fragment = { __typename: 'TransformerStarImpedance', id: string, name: string };

type Identification_TransformerTank_Fragment = { __typename: 'TransformerTank', id: string, name: string };

type Identification_TransformerTankEnd_Fragment = { __typename: 'TransformerTankEnd', id: string, name: string };

type Identification_TransformerTankInfo_Fragment = { __typename: 'TransformerTankInfo', id: string, name: string };

type Identification_VoltageControlZone_Fragment = { __typename: 'VoltageControlZone', id: string, name: string };

type Identification_VoltageLevel_Fragment = { __typename: 'VoltageLevel', id: string, name: string };

type Identification_VoltageLimit_Fragment = { __typename: 'VoltageLimit', id: string, name: string };

type Identification_WindGeneratingUnit_Fragment = { __typename: 'WindGeneratingUnit', id: string, name: string };

type Identification_WireAssemblyInfo_Fragment = { __typename: 'WireAssemblyInfo', id: string, name: string };

type Identification_WirePosition_Fragment = { __typename: 'WirePosition', id: string, name: string };

type Identification_WireSegment_Fragment = { __typename: 'WireSegment', id: string, name: string };

type Identification_WireSegmentPhase_Fragment = { __typename: 'WireSegmentPhase', id: string, name: string };

type Identification_WireSpacingInfo_Fragment = { __typename: 'WireSpacingInfo', id: string, name: string };

export type IdentificationFragment =
  | Identification_AcLineSegment_Fragment
  | Identification_AcLineSegmentPhase_Fragment
  | Identification_ActivePowerLimit_Fragment
  | Identification_Agreement_Fragment
  | Identification_AirCompressor_Fragment
  | Identification_ApparentPowerLimit_Fragment
  | Identification_Appointment_Fragment
  | Identification_Approver_Fragment
  | Identification_AsynchronousMachine_Fragment
  | Identification_Author_Fragment
  | Identification_BaseFrequency_Fragment
  | Identification_BasePower_Fragment
  | Identification_BaseVoltage_Fragment
  | Identification_BatteryUnit_Fragment
  | Identification_Bay_Fragment
  | Identification_BranchGroup_Fragment
  | Identification_BusNameMarker_Fragment
  | Identification_BusbarSection_Fragment
  | Identification_BusbarSectionInfo_Fragment
  | Identification_BushingInfo_Fragment
  | Identification_CaesPlant_Fragment
  | Identification_Clamp_Fragment
  | Identification_CogenerationPlant_Fragment
  | Identification_CombinedCyclePlant_Fragment
  | Identification_CompositeSwitch_Fragment
  | Identification_ConcentricNeutralCableInfo_Fragment
  | Identification_ConfigurationEvent_Fragment
  | Identification_ConnectivityNode_Fragment
  | Identification_CoordinateSystem_Fragment
  | Identification_Crew_Fragment
  | Identification_CrewMember_Fragment
  | Identification_CrewType_Fragment
  | Identification_CurrentLimit_Fragment
  | Identification_Cut_Fragment
  | Identification_DisconnectingCircuitBreaker_Fragment
  | Identification_Disconnector_Fragment
  | Identification_Editor_Fragment
  | Identification_EmissionAccount_Fragment
  | Identification_EmissionCurve_Fragment
  | Identification_EnergyConsumer_Fragment
  | Identification_EnergyConsumerPhase_Fragment
  | Identification_EnergySchedulingType_Fragment
  | Identification_EnergySource_Fragment
  | Identification_EnergySourcePhase_Fragment
  | Identification_EquivalentBranch_Fragment
  | Identification_EquivalentInjection_Fragment
  | Identification_EquivalentNetwork_Fragment
  | Identification_EquivalentShunt_Fragment
  | Identification_ExternalNetworkInjection_Fragment
  | Identification_Feeder_Fragment
  | Identification_FieldDispatchHistory_Fragment
  | Identification_FossilFuel_Fragment
  | Identification_FrequencyConverter_Fragment
  | Identification_FuelAllocationSchedule_Fragment
  | Identification_Fuse_Fragment
  | Identification_GenUnitOpCostCurve_Fragment
  | Identification_GenUnitOpSchedule_Fragment
  | Identification_GeographicalRegion_Fragment
  | Identification_GrossToNetActivePowerCurve_Fragment
  | Identification_Ground_Fragment
  | Identification_GroundDisconnector_Fragment
  | Identification_GroundingImpedance_Fragment
  | Identification_Hazard_Fragment
  | Identification_HeatInputCurve_Fragment
  | Identification_HeatRateCurve_Fragment
  | Identification_HydroGeneratingEfficiencyCurve_Fragment
  | Identification_HydroGeneratingUnit_Fragment
  | Identification_HydroPowerPlant_Fragment
  | Identification_HydroPump_Fragment
  | Identification_HydroPumpOpSchedule_Fragment
  | Identification_IncrementalHeatRateCurve_Fragment
  | Identification_InflowForecast_Fragment
  | Identification_InterrupterUnitInfo_Fragment
  | Identification_IrregularIntervalSchedule_Fragment
  | Identification_Issuer_Fragment
  | Identification_Jumper_Fragment
  | Identification_Junction_Fragment
  | Identification_LevelVsVolumeCurve_Fragment
  | Identification_Line_Fragment
  | Identification_LinearShuntCompensator_Fragment
  | Identification_LinearShuntCompensatorPhase_Fragment
  | Identification_LoadBreakSwitch_Fragment
  | Identification_Location_Fragment
  | Identification_MutualCoupling_Fragment
  | Identification_NoLoadTest_Fragment
  | Identification_NonlinearShuntCompensator_Fragment
  | Identification_NonlinearShuntCompensatorPhase_Fragment
  | Identification_NuclearGeneratingUnit_Fragment
  | Identification_OpenCircuitTest_Fragment
  | Identification_OperatingMechanismInfo_Fragment
  | Identification_OperatingParticipant_Fragment
  | Identification_OperationalLimitSet_Fragment
  | Identification_OperationalLimitType_Fragment
  | Identification_Operator_Fragment
  | Identification_OrganisationRole_Fragment
  | Identification_OverheadWireInfo_Fragment
  | Identification_Ownership_Fragment
  | Identification_PsrType_Fragment
  | Identification_ParentOrganization_Fragment
  | Identification_PenstockLossCurve_Fragment
  | Identification_PerLengthPhaseImpedance_Fragment
  | Identification_PerLengthSequenceImpedance_Fragment
  | Identification_Person_Fragment
  | Identification_PetersenCoil_Fragment
  | Identification_PhaseTapChangerAsymmetrical_Fragment
  | Identification_PhaseTapChangerLinear_Fragment
  | Identification_PhaseTapChangerSymmetrical_Fragment
  | Identification_PhaseTapChangerTable_Fragment
  | Identification_PhaseTapChangerTabular_Fragment
  | Identification_PhotoVoltaicUnit_Fragment
  | Identification_Plant_Fragment
  | Identification_PowerElectronicsConnection_Fragment
  | Identification_PowerElectronicsConnectionPhase_Fragment
  | Identification_PowerElectronicsWindUnit_Fragment
  | Identification_PowerTransformer_Fragment
  | Identification_PowerTransformerEnd_Fragment
  | Identification_PowerTransformerInfo_Fragment
  | Identification_RatioTapChanger_Fragment
  | Identification_RatioTapChangerTable_Fragment
  | Identification_ReactiveCapabilityCurve_Fragment
  | Identification_Recloser_Fragment
  | Identification_RegulationSchedule_Fragment
  | Identification_ReportingGroup_Fragment
  | Identification_ReportingSuperGroup_Fragment
  | Identification_Reservoir_Fragment
  | Identification_ScheduledEvent_Fragment
  | Identification_Sectionaliser_Fragment
  | Identification_SeriesCompensator_Fragment
  | Identification_ShortCircuitTest_Fragment
  | Identification_ShuntCompensatorInfo_Fragment
  | Identification_ShutdownCurve_Fragment
  | Identification_SolarGeneratingUnit_Fragment
  | Identification_StartIgnFuelCurve_Fragment
  | Identification_StartMainFuelCurve_Fragment
  | Identification_StartRampCurve_Fragment
  | Identification_StartupModel_Fragment
  | Identification_StaticVarCompensator_Fragment
  | Identification_SteamSendoutSchedule_Fragment
  | Identification_SubGeographicalRegion_Fragment
  | Identification_Substation_Fragment
  | Identification_SwitchInfo_Fragment
  | Identification_SwitchPhase_Fragment
  | Identification_SwitchSchedule_Fragment
  | Identification_SynchronousMachine_Fragment
  | Identification_TailbayLossCurve_Fragment
  | Identification_TapChangerControl_Fragment
  | Identification_TapChangerInfo_Fragment
  | Identification_TapSchedule_Fragment
  | Identification_TapeShieldCableInfo_Fragment
  | Identification_TargetLevelSchedule_Fragment
  | Identification_Terminal_Fragment
  | Identification_ThermalGeneratingUnit_Fragment
  | Identification_TimePoint_Fragment
  | Identification_TimeSchedule_Fragment
  | Identification_TopologicalIsland_Fragment
  | Identification_TopologicalNode_Fragment
  | Identification_TransformerCoreAdmittance_Fragment
  | Identification_TransformerEndInfo_Fragment
  | Identification_TransformerMeshImpedance_Fragment
  | Identification_TransformerStarImpedance_Fragment
  | Identification_TransformerTank_Fragment
  | Identification_TransformerTankEnd_Fragment
  | Identification_TransformerTankInfo_Fragment
  | Identification_VoltageControlZone_Fragment
  | Identification_VoltageLevel_Fragment
  | Identification_VoltageLimit_Fragment
  | Identification_WindGeneratingUnit_Fragment
  | Identification_WireAssemblyInfo_Fragment
  | Identification_WirePosition_Fragment
  | Identification_WireSegment_Fragment
  | Identification_WireSegmentPhase_Fragment
  | Identification_WireSpacingInfo_Fragment
;

type BaseVoltage_AcLineSegment_Fragment = { __typename: 'ACLineSegment', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_AsynchronousMachine_Fragment = { __typename: 'AsynchronousMachine', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_BusbarSection_Fragment = { __typename: 'BusbarSection', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Clamp_Fragment = { __typename: 'Clamp', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Cut_Fragment = { __typename: 'Cut', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_DisconnectingCircuitBreaker_Fragment = { __typename: 'DisconnectingCircuitBreaker', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Disconnector_Fragment = { __typename: 'Disconnector', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_EnergyConsumer_Fragment = { __typename: 'EnergyConsumer', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_EnergySource_Fragment = { __typename: 'EnergySource', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_EquivalentBranch_Fragment = { __typename: 'EquivalentBranch', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_EquivalentInjection_Fragment = { __typename: 'EquivalentInjection', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_EquivalentShunt_Fragment = { __typename: 'EquivalentShunt', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_ExternalNetworkInjection_Fragment = { __typename: 'ExternalNetworkInjection', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_FrequencyConverter_Fragment = { __typename: 'FrequencyConverter', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Fuse_Fragment = { __typename: 'Fuse', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Ground_Fragment = { __typename: 'Ground', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_GroundDisconnector_Fragment = { __typename: 'GroundDisconnector', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_GroundingImpedance_Fragment = { __typename: 'GroundingImpedance', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Jumper_Fragment = { __typename: 'Jumper', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Junction_Fragment = { __typename: 'Junction', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_LinearShuntCompensator_Fragment = { __typename: 'LinearShuntCompensator', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_LoadBreakSwitch_Fragment = { __typename: 'LoadBreakSwitch', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_NonlinearShuntCompensator_Fragment = { __typename: 'NonlinearShuntCompensator', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_PetersenCoil_Fragment = { __typename: 'PetersenCoil', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_PowerElectronicsConnection_Fragment = { __typename: 'PowerElectronicsConnection', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_PowerTransformer_Fragment = { __typename: 'PowerTransformer', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Recloser_Fragment = { __typename: 'Recloser', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_Sectionaliser_Fragment = { __typename: 'Sectionaliser', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_SeriesCompensator_Fragment = { __typename: 'SeriesCompensator', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_StaticVarCompensator_Fragment = { __typename: 'StaticVarCompensator', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_SynchronousMachine_Fragment = { __typename: 'SynchronousMachine', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type BaseVoltage_WireSegment_Fragment = { __typename: 'WireSegment', BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

export type BaseVoltageFragment =
  | BaseVoltage_AcLineSegment_Fragment
  | BaseVoltage_AsynchronousMachine_Fragment
  | BaseVoltage_BusbarSection_Fragment
  | BaseVoltage_Clamp_Fragment
  | BaseVoltage_Cut_Fragment
  | BaseVoltage_DisconnectingCircuitBreaker_Fragment
  | BaseVoltage_Disconnector_Fragment
  | BaseVoltage_EnergyConsumer_Fragment
  | BaseVoltage_EnergySource_Fragment
  | BaseVoltage_EquivalentBranch_Fragment
  | BaseVoltage_EquivalentInjection_Fragment
  | BaseVoltage_EquivalentShunt_Fragment
  | BaseVoltage_ExternalNetworkInjection_Fragment
  | BaseVoltage_FrequencyConverter_Fragment
  | BaseVoltage_Fuse_Fragment
  | BaseVoltage_Ground_Fragment
  | BaseVoltage_GroundDisconnector_Fragment
  | BaseVoltage_GroundingImpedance_Fragment
  | BaseVoltage_Jumper_Fragment
  | BaseVoltage_Junction_Fragment
  | BaseVoltage_LinearShuntCompensator_Fragment
  | BaseVoltage_LoadBreakSwitch_Fragment
  | BaseVoltage_NonlinearShuntCompensator_Fragment
  | BaseVoltage_PetersenCoil_Fragment
  | BaseVoltage_PowerElectronicsConnection_Fragment
  | BaseVoltage_PowerTransformer_Fragment
  | BaseVoltage_Recloser_Fragment
  | BaseVoltage_Sectionaliser_Fragment
  | BaseVoltage_SeriesCompensator_Fragment
  | BaseVoltage_StaticVarCompensator_Fragment
  | BaseVoltage_SynchronousMachine_Fragment
  | BaseVoltage_WireSegment_Fragment
;

export type FetchMapTypedObjectsQueryVariables = Exact<{
  modelName: string;
  geoBoundary?: Types.GeoBoundary | null | undefined;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchMapTypedObjectsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AirCompressor', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BatteryUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Bay', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarSection', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CAESPlant', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Clamp', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Cut', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Disconnector', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySource', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Feeder', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Fuse', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Ground', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPump', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Jumper', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Junction', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Line', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PetersenCoil', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Plant', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformer', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Recloser', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Reservoir', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Sectionaliser', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Substation', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapChangerControl', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTank', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageLevel', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSegment', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string, index: number }> }, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
    > } }

export type FetchViewObjectsByIdQueryVariables = Exact<{
  modelName: string;
  ids: Array<string | number> | string | number;
}>;


export interface FetchViewObjectsByIdQuery { __typename: 'Query', viewObjects: { __typename: 'ViewObjectsPage', viewObjects: Array<{ __typename: 'ViewObject', iri: string, types: Array<string>, name: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, location: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', positionPoints: Array<{ __typename: 'ViewObjectProperty', value:
                  | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', x: Array<{ __typename: 'ViewObjectProperty', value:
                          | { __typename: 'ReferenceValue' }
                          | { __typename: 'StringValue', values: Array<string> }
                         }>, y: Array<{ __typename: 'ViewObjectProperty', value:
                          | { __typename: 'ReferenceValue' }
                          | { __typename: 'StringValue', values: Array<string> }
                         }>, sequenceNumber: Array<{ __typename: 'ViewObjectProperty', value:
                          | { __typename: 'ReferenceValue' }
                          | { __typename: 'StringValue', values: Array<string> }
                         }> }> }
                  | { __typename: 'StringValue' }
                 }> }> }
          | { __typename: 'StringValue' }
         }>, baseVoltage: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', name: Array<{ __typename: 'ViewObjectProperty', value:
                  | { __typename: 'ReferenceValue' }
                  | { __typename: 'StringValue', values: Array<string> }
                 }> }> }
          | { __typename: 'StringValue' }
         }>, properties: Array<{ __typename: 'ViewObjectProperty', iri: string, value:
          | { __typename: 'ReferenceValue', reference_values: Array<{ __typename: 'ViewObject', iri: string }> }
          | { __typename: 'StringValue', string_values: Array<string> }
         }> }> } }

export type GeneratorsByBusbarSectionsQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface GeneratorsByBusbarSectionsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string, Terminals: Array<{ __typename: 'Terminal', ConnectivityNode: { __typename: 'ConnectivityNode', Terminals: Array<{ __typename: 'Terminal', ConductingEquipment:
                | { __typename: 'ACLineSegment' }
                | { __typename: 'AsynchronousMachine', GeneratingUnit:
                    | { __typename: 'HydroGeneratingUnit', id: string, name: string, HydroPowerPlant: { __typename: 'HydroPowerPlant', hydroPlantStorageType: { __typename: 'HydroPlantStorageKind', id: string } } }
                    | { __typename: 'NuclearGeneratingUnit' }
                    | { __typename: 'SolarGeneratingUnit' }
                    | { __typename: 'ThermalGeneratingUnit' }
                    | { __typename: 'WindGeneratingUnit' }
                   }
                | { __typename: 'BusbarSection' }
                | { __typename: 'Clamp' }
                | { __typename: 'Cut' }
                | { __typename: 'DisconnectingCircuitBreaker' }
                | { __typename: 'Disconnector' }
                | { __typename: 'EnergyConsumer' }
                | { __typename: 'EnergySource' }
                | { __typename: 'EquivalentBranch' }
                | { __typename: 'EquivalentInjection' }
                | { __typename: 'EquivalentShunt' }
                | { __typename: 'ExternalNetworkInjection' }
                | { __typename: 'FrequencyConverter' }
                | { __typename: 'Fuse' }
                | { __typename: 'Ground' }
                | { __typename: 'GroundDisconnector' }
                | { __typename: 'GroundingImpedance' }
                | { __typename: 'Jumper' }
                | { __typename: 'Junction' }
                | { __typename: 'LinearShuntCompensator' }
                | { __typename: 'LoadBreakSwitch' }
                | { __typename: 'NonlinearShuntCompensator' }
                | { __typename: 'PetersenCoil' }
                | { __typename: 'PowerElectronicsConnection', PowerElectronicsUnit: Array<
                    | { __typename: 'BatteryUnit' }
                    | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
                    | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
                  > }
                | { __typename: 'PowerTransformer' }
                | { __typename: 'Recloser' }
                | { __typename: 'Sectionaliser' }
                | { __typename: 'SeriesCompensator' }
                | { __typename: 'StaticVarCompensator' }
                | { __typename: 'SynchronousMachine', GeneratingUnit:
                    | { __typename: 'HydroGeneratingUnit', id: string, name: string, HydroPowerPlant: { __typename: 'HydroPowerPlant', hydroPlantStorageType: { __typename: 'HydroPlantStorageKind', id: string } } }
                    | { __typename: 'NuclearGeneratingUnit' }
                    | { __typename: 'SolarGeneratingUnit' }
                    | { __typename: 'ThermalGeneratingUnit' }
                    | { __typename: 'WindGeneratingUnit' }
                   }
                | { __typename: 'WireSegment' }
               }> } }> }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type GetAcLineSegmentByIriQueryVariables = Exact<{
  modelName: string;
  iri: string | number;
}>;


export interface GetAcLineSegmentByIriQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', entities: Array<
      | { __typename: 'ACLineSegment', name: string, x: { __typename: 'Reactance', value: number }, r: { __typename: 'Resistance', value: number }, length: { __typename: 'Length', value: number }, OperationalLimitSet: Array<{ __typename: 'OperationalLimitSet', OperationalLimitValue: Array<
            | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
            | { __typename: 'ApparentPowerLimit' }
            | { __typename: 'CurrentLimit' }
            | { __typename: 'VoltageLimit' }
          > }> }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection' }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type FetchAssetLimitsDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  fulltext?: string | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchAssetLimitsDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, inService: boolean, Terminals: Array<{ __typename: 'Terminal', sequenceNumber: number, opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
              | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
              | { __typename: 'ApparentPowerLimit', value: { __typename: 'ApparentPower', value: number } }
              | { __typename: 'CurrentLimit', value: { __typename: 'CurrentFlow', value: number } }
              | { __typename: 'VoltageLimit' }
            > }>, cNode: { __typename: 'ConnectivityNode', container:
              | { __typename: 'Bay' }
              | { __typename: 'EquivalentNetwork' }
              | { __typename: 'Feeder' }
              | { __typename: 'Line' }
              | { __typename: 'Plant' }
              | { __typename: 'Substation' }
              | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
             }, tNode: { __typename: 'TopologicalNode', container:
              | { __typename: 'Bay' }
              | { __typename: 'EquivalentNetwork' }
              | { __typename: 'Feeder' }
              | { __typename: 'Line' }
              | { __typename: 'Plant' }
              | { __typename: 'Substation' }
              | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
             } }>, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AirCompressor', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Bay', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSection', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CAESPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Clamp', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Cut', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Disconnector', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySource', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Feeder', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Fuse', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ground', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPump', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Jumper', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Junction', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Line', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoil', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Plant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformer', id: string, name: string, inService: boolean, container:
          | { __typename: 'Bay' }
          | { __typename: 'Feeder' }
          | { __typename: 'Line' }
          | { __typename: 'Plant' }
          | { __typename: 'Substation', name: string, VoltageLevels: Array<{ __typename: 'VoltageLevel', name: string }> }
          | { __typename: 'VoltageLevel' }
        , PowerTransformerEnd: Array<{ __typename: 'PowerTransformerEnd', endNumber: number, Terminal: { __typename: 'Terminal', sequenceNumber: number, opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
                | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
                | { __typename: 'ApparentPowerLimit', value: { __typename: 'ApparentPower', value: number } }
                | { __typename: 'CurrentLimit', value: { __typename: 'CurrentFlow', value: number } }
                | { __typename: 'VoltageLimit' }
              > }>, cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } } }>, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Recloser', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reservoir', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Sectionaliser', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Substation', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerControl', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTank', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLevel', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegment', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
    > } }

export type FetchEnergyStorageDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchEnergyStorageDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', storage: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AirCompressor', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryUnit', name: string, inService: boolean, id: string, maxP: { __typename: 'ActivePower', value: number }, ratedE: { __typename: 'RealEnergy', value: number }, storedE: { __typename: 'RealEnergy', value: number }, connection: { __typename: 'PowerElectronicsConnection', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } }> }, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Bay', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CAESPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Clamp', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Cut', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Disconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySource', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Feeder', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Fuse', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ground', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPump', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Jumper', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Junction', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Line', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoil', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Plant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformer', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Recloser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reservoir', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Sectionaliser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Substation', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerControl', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTank', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLevel', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

type ActivePowerLimit_AcLineSegment_Fragment = { __typename: 'ACLineSegment', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_AsynchronousMachine_Fragment = { __typename: 'AsynchronousMachine', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_BatteryUnit_Fragment = { __typename: 'BatteryUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_BusbarSection_Fragment = { __typename: 'BusbarSection', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Clamp_Fragment = { __typename: 'Clamp', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_CompositeSwitch_Fragment = { __typename: 'CompositeSwitch', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Cut_Fragment = { __typename: 'Cut', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_DisconnectingCircuitBreaker_Fragment = { __typename: 'DisconnectingCircuitBreaker', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Disconnector_Fragment = { __typename: 'Disconnector', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_EnergyConsumer_Fragment = { __typename: 'EnergyConsumer', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_EnergySource_Fragment = { __typename: 'EnergySource', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_EquivalentBranch_Fragment = { __typename: 'EquivalentBranch', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_EquivalentInjection_Fragment = { __typename: 'EquivalentInjection', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_EquivalentShunt_Fragment = { __typename: 'EquivalentShunt', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_ExternalNetworkInjection_Fragment = { __typename: 'ExternalNetworkInjection', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_FrequencyConverter_Fragment = { __typename: 'FrequencyConverter', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Fuse_Fragment = { __typename: 'Fuse', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Ground_Fragment = { __typename: 'Ground', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_GroundDisconnector_Fragment = { __typename: 'GroundDisconnector', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_GroundingImpedance_Fragment = { __typename: 'GroundingImpedance', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_HydroGeneratingUnit_Fragment = { __typename: 'HydroGeneratingUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_HydroPump_Fragment = { __typename: 'HydroPump', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Jumper_Fragment = { __typename: 'Jumper', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Junction_Fragment = { __typename: 'Junction', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_LinearShuntCompensator_Fragment = { __typename: 'LinearShuntCompensator', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_LoadBreakSwitch_Fragment = { __typename: 'LoadBreakSwitch', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_NonlinearShuntCompensator_Fragment = { __typename: 'NonlinearShuntCompensator', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_NuclearGeneratingUnit_Fragment = { __typename: 'NuclearGeneratingUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_PetersenCoil_Fragment = { __typename: 'PetersenCoil', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_PhotoVoltaicUnit_Fragment = { __typename: 'PhotoVoltaicUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_PowerElectronicsConnection_Fragment = { __typename: 'PowerElectronicsConnection', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_PowerElectronicsWindUnit_Fragment = { __typename: 'PowerElectronicsWindUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_PowerTransformer_Fragment = { __typename: 'PowerTransformer', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Recloser_Fragment = { __typename: 'Recloser', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_Sectionaliser_Fragment = { __typename: 'Sectionaliser', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_SeriesCompensator_Fragment = { __typename: 'SeriesCompensator', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_SolarGeneratingUnit_Fragment = { __typename: 'SolarGeneratingUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_StaticVarCompensator_Fragment = { __typename: 'StaticVarCompensator', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_SynchronousMachine_Fragment = { __typename: 'SynchronousMachine', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_ThermalGeneratingUnit_Fragment = { __typename: 'ThermalGeneratingUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_TransformerTank_Fragment = { __typename: 'TransformerTank', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_WindGeneratingUnit_Fragment = { __typename: 'WindGeneratingUnit', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

type ActivePowerLimit_WireSegment_Fragment = { __typename: 'WireSegment', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
      | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'VoltageLimit' }
    > }> };

export type ActivePowerLimitFragment =
  | ActivePowerLimit_AcLineSegment_Fragment
  | ActivePowerLimit_AsynchronousMachine_Fragment
  | ActivePowerLimit_BatteryUnit_Fragment
  | ActivePowerLimit_BusbarSection_Fragment
  | ActivePowerLimit_Clamp_Fragment
  | ActivePowerLimit_CompositeSwitch_Fragment
  | ActivePowerLimit_Cut_Fragment
  | ActivePowerLimit_DisconnectingCircuitBreaker_Fragment
  | ActivePowerLimit_Disconnector_Fragment
  | ActivePowerLimit_EnergyConsumer_Fragment
  | ActivePowerLimit_EnergySource_Fragment
  | ActivePowerLimit_EquivalentBranch_Fragment
  | ActivePowerLimit_EquivalentInjection_Fragment
  | ActivePowerLimit_EquivalentShunt_Fragment
  | ActivePowerLimit_ExternalNetworkInjection_Fragment
  | ActivePowerLimit_FrequencyConverter_Fragment
  | ActivePowerLimit_Fuse_Fragment
  | ActivePowerLimit_Ground_Fragment
  | ActivePowerLimit_GroundDisconnector_Fragment
  | ActivePowerLimit_GroundingImpedance_Fragment
  | ActivePowerLimit_HydroGeneratingUnit_Fragment
  | ActivePowerLimit_HydroPump_Fragment
  | ActivePowerLimit_Jumper_Fragment
  | ActivePowerLimit_Junction_Fragment
  | ActivePowerLimit_LinearShuntCompensator_Fragment
  | ActivePowerLimit_LoadBreakSwitch_Fragment
  | ActivePowerLimit_NonlinearShuntCompensator_Fragment
  | ActivePowerLimit_NuclearGeneratingUnit_Fragment
  | ActivePowerLimit_PetersenCoil_Fragment
  | ActivePowerLimit_PhotoVoltaicUnit_Fragment
  | ActivePowerLimit_PowerElectronicsConnection_Fragment
  | ActivePowerLimit_PowerElectronicsWindUnit_Fragment
  | ActivePowerLimit_PowerTransformer_Fragment
  | ActivePowerLimit_Recloser_Fragment
  | ActivePowerLimit_Sectionaliser_Fragment
  | ActivePowerLimit_SeriesCompensator_Fragment
  | ActivePowerLimit_SolarGeneratingUnit_Fragment
  | ActivePowerLimit_StaticVarCompensator_Fragment
  | ActivePowerLimit_SynchronousMachine_Fragment
  | ActivePowerLimit_ThermalGeneratingUnit_Fragment
  | ActivePowerLimit_TransformerTank_Fragment
  | ActivePowerLimit_WindGeneratingUnit_Fragment
  | ActivePowerLimit_WireSegment_Fragment
;

export type AssetLifecycleFragment = { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue' }
                      | { __typename: 'StringValue', values: Array<string> }
                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue' }
                      | { __typename: 'StringValue', values: Array<string> }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }> }
      | { __typename: 'StringValue' }
     }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }> }
      | { __typename: 'StringValue' }
     }> };

export type ConnectionTerminalsFragment = { __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
      | { __typename: 'Bay' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'Feeder' }
      | { __typename: 'Line' }
      | { __typename: 'Plant' }
      | { __typename: 'Substation' }
      | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
     }, tNode: { __typename: 'TopologicalNode', container:
      | { __typename: 'Bay' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'Feeder' }
      | { __typename: 'Line' }
      | { __typename: 'Plant' }
      | { __typename: 'Substation' }
      | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
     } };

type GeneratingUnitCommonFields_HydroGeneratingUnit_Fragment = { __typename: 'HydroGeneratingUnit', name: string, id: string, inService: boolean, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
    | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
    | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
  > };

type GeneratingUnitCommonFields_NuclearGeneratingUnit_Fragment = { __typename: 'NuclearGeneratingUnit', name: string, id: string, inService: boolean, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
    | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
    | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
  > };

type GeneratingUnitCommonFields_SolarGeneratingUnit_Fragment = { __typename: 'SolarGeneratingUnit', name: string, id: string, inService: boolean, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
    | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
    | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
  > };

type GeneratingUnitCommonFields_ThermalGeneratingUnit_Fragment = { __typename: 'ThermalGeneratingUnit', name: string, id: string, inService: boolean, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
    | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
    | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
  > };

type GeneratingUnitCommonFields_WindGeneratingUnit_Fragment = { __typename: 'WindGeneratingUnit', name: string, id: string, inService: boolean, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
    | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
    | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           }, tNode: { __typename: 'TopologicalNode', container:
            | { __typename: 'Bay' }
            | { __typename: 'EquivalentNetwork' }
            | { __typename: 'Feeder' }
            | { __typename: 'Line' }
            | { __typename: 'Plant' }
            | { __typename: 'Substation' }
            | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
           } }> }
  > };

export type GeneratingUnitCommonFieldsFragment =
  | GeneratingUnitCommonFields_HydroGeneratingUnit_Fragment
  | GeneratingUnitCommonFields_NuclearGeneratingUnit_Fragment
  | GeneratingUnitCommonFields_SolarGeneratingUnit_Fragment
  | GeneratingUnitCommonFields_ThermalGeneratingUnit_Fragment
  | GeneratingUnitCommonFields_WindGeneratingUnit_Fragment
;

export type FetchGeneratorDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchGeneratorDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', generator: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AirCompressor', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryUnit', id: string, name: string, maxP: { __typename: 'ActivePower', value: number }, minP: { __typename: 'ActivePower', value: number }, peConnection: { __typename: 'PowerElectronicsConnection', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } }> }, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Bay', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CAESPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Clamp', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Cut', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Disconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySource', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Feeder', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Fuse', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ground', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
          | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
          | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
        > }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, HydroGeneratingUnits: Array<{ __typename: 'HydroGeneratingUnit', name: string, id: string, inService: boolean, rotatingMachines: Array<
            | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                    | { __typename: 'Bay' }
                    | { __typename: 'EquivalentNetwork' }
                    | { __typename: 'Feeder' }
                    | { __typename: 'Line' }
                    | { __typename: 'Plant' }
                    | { __typename: 'Substation' }
                    | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                   }, tNode: { __typename: 'TopologicalNode', container:
                    | { __typename: 'Bay' }
                    | { __typename: 'EquivalentNetwork' }
                    | { __typename: 'Feeder' }
                    | { __typename: 'Line' }
                    | { __typename: 'Plant' }
                    | { __typename: 'Substation' }
                    | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                   } }> }
            | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                    | { __typename: 'Bay' }
                    | { __typename: 'EquivalentNetwork' }
                    | { __typename: 'Feeder' }
                    | { __typename: 'Line' }
                    | { __typename: 'Plant' }
                    | { __typename: 'Substation' }
                    | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                   }, tNode: { __typename: 'TopologicalNode', container:
                    | { __typename: 'Bay' }
                    | { __typename: 'EquivalentNetwork' }
                    | { __typename: 'Feeder' }
                    | { __typename: 'Line' }
                    | { __typename: 'Plant' }
                    | { __typename: 'Substation' }
                    | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                   } }> }
          >, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number } }>, hydroPlantStorageType: { __typename: 'HydroPlantStorageKind', id: string }, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPump', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Jumper', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Junction', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Line', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
          | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
          | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
        > }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoil', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhotoVoltaicUnit', name: string, inService: boolean, id: string, maxP: { __typename: 'ActivePower', value: number }, minP: { __typename: 'ActivePower', value: number }, peConnection: { __typename: 'PowerElectronicsConnection', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } }> }, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Plant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, maxP: { __typename: 'ActivePower', value: number }, minP: { __typename: 'ActivePower', value: number }, peConnection: { __typename: 'PowerElectronicsConnection', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } }> }, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformer', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Recloser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reservoir', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Sectionaliser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
          | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
          | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
        > }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Substation', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerControl', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, inService: boolean, FossilFuels: Array<{ __typename: 'FossilFuel', fossilFuelType: { __typename: 'FuelType', id: string } }>, rotatingMachines: Array<
          | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
          | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
        >, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTank', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLevel', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, inService: boolean, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, maxOperatingP: { __typename: 'ActivePower', value: number }, minOperatingP: { __typename: 'ActivePower', value: number }, rotatingMachines: Array<
          | { __typename: 'AsynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
          | { __typename: 'SynchronousMachine', Terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } }> }
        > }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

type ReducedBranchDetails_AcLineSegment_Fragment = { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_AcLineSegmentPhase_Fragment = { __typename: 'ACLineSegmentPhase', id: string, name: string };

type ReducedBranchDetails_ActivePower_Fragment = { __typename: 'ActivePower' };

type ReducedBranchDetails_ActivePowerChangeRate_Fragment = { __typename: 'ActivePowerChangeRate' };

type ReducedBranchDetails_ActivePowerLimit_Fragment = { __typename: 'ActivePowerLimit', id: string, name: string };

type ReducedBranchDetails_ActivePowerPerCurrentFlow_Fragment = { __typename: 'ActivePowerPerCurrentFlow' };

type ReducedBranchDetails_ActivePowerPerFrequency_Fragment = { __typename: 'ActivePowerPerFrequency' };

type ReducedBranchDetails_Admittance_Fragment = { __typename: 'Admittance' };

type ReducedBranchDetails_Agreement_Fragment = { __typename: 'Agreement', id: string, name: string };

type ReducedBranchDetails_AirCompressor_Fragment = { __typename: 'AirCompressor', id: string, name: string };

type ReducedBranchDetails_AngleDegrees_Fragment = { __typename: 'AngleDegrees' };

type ReducedBranchDetails_AngleRadians_Fragment = { __typename: 'AngleRadians' };

type ReducedBranchDetails_ApparentPower_Fragment = { __typename: 'ApparentPower' };

type ReducedBranchDetails_ApparentPowerLimit_Fragment = { __typename: 'ApparentPowerLimit', id: string, name: string };

type ReducedBranchDetails_Appointment_Fragment = { __typename: 'Appointment', id: string, name: string };

type ReducedBranchDetails_Approver_Fragment = { __typename: 'Approver', id: string, name: string };

type ReducedBranchDetails_Area_Fragment = { __typename: 'Area' };

type ReducedBranchDetails_AsynchronousMachine_Fragment = { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_AsynchronousMachineKind_Fragment = { __typename: 'AsynchronousMachineKind' };

type ReducedBranchDetails_Author_Fragment = { __typename: 'Author', id: string, name: string };

type ReducedBranchDetails_BaseFrequency_Fragment = { __typename: 'BaseFrequency', id: string, name: string };

type ReducedBranchDetails_BasePower_Fragment = { __typename: 'BasePower', id: string, name: string };

type ReducedBranchDetails_BaseVoltage_Fragment = { __typename: 'BaseVoltage', id: string, name: string };

type ReducedBranchDetails_BatteryStateKind_Fragment = { __typename: 'BatteryStateKind' };

type ReducedBranchDetails_BatteryUnit_Fragment = { __typename: 'BatteryUnit', id: string, name: string };

type ReducedBranchDetails_Bay_Fragment = { __typename: 'Bay', id: string, name: string };

type ReducedBranchDetails_BranchGroup_Fragment = { __typename: 'BranchGroup', id: string, name: string };

type ReducedBranchDetails_BranchGroupTerminal_Fragment = { __typename: 'BranchGroupTerminal' };

type ReducedBranchDetails_BreakerConfiguration_Fragment = { __typename: 'BreakerConfiguration' };

type ReducedBranchDetails_BusNameMarker_Fragment = { __typename: 'BusNameMarker', id: string, name: string };

type ReducedBranchDetails_BusbarConfiguration_Fragment = { __typename: 'BusbarConfiguration' };

type ReducedBranchDetails_BusbarSection_Fragment = { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_BusbarSectionInfo_Fragment = { __typename: 'BusbarSectionInfo', id: string, name: string };

type ReducedBranchDetails_BushingInfo_Fragment = { __typename: 'BushingInfo', id: string, name: string };

type ReducedBranchDetails_BushingInsulationKind_Fragment = { __typename: 'BushingInsulationKind' };

type ReducedBranchDetails_CaesPlant_Fragment = { __typename: 'CAESPlant', id: string, name: string };

type ReducedBranchDetails_CableConstructionKind_Fragment = { __typename: 'CableConstructionKind' };

type ReducedBranchDetails_CableOuterJacketKind_Fragment = { __typename: 'CableOuterJacketKind' };

type ReducedBranchDetails_CableShieldMaterialKind_Fragment = { __typename: 'CableShieldMaterialKind' };

type ReducedBranchDetails_Capacitance_Fragment = { __typename: 'Capacitance' };

type ReducedBranchDetails_CapacitancePerLength_Fragment = { __typename: 'CapacitancePerLength' };

type ReducedBranchDetails_Clamp_Fragment = { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Classification_Fragment = { __typename: 'Classification' };

type ReducedBranchDetails_CogenerationPlant_Fragment = { __typename: 'CogenerationPlant', id: string, name: string };

type ReducedBranchDetails_CombinedCyclePlant_Fragment = { __typename: 'CombinedCyclePlant', id: string, name: string };

type ReducedBranchDetails_CompositeSwitch_Fragment = { __typename: 'CompositeSwitch', id: string, name: string };

type ReducedBranchDetails_ConcentricNeutralCableInfo_Fragment = { __typename: 'ConcentricNeutralCableInfo', id: string, name: string };

type ReducedBranchDetails_Conductance_Fragment = { __typename: 'Conductance' };

type ReducedBranchDetails_ConductancePerLength_Fragment = { __typename: 'ConductancePerLength' };

type ReducedBranchDetails_ConfigurationEvent_Fragment = { __typename: 'ConfigurationEvent', id: string, name: string };

type ReducedBranchDetails_ConnectivityNode_Fragment = { __typename: 'ConnectivityNode', id: string, name: string };

type ReducedBranchDetails_CoolantType_Fragment = { __typename: 'CoolantType' };

type ReducedBranchDetails_CoordinateSystem_Fragment = { __typename: 'CoordinateSystem', id: string, name: string };

type ReducedBranchDetails_CostPerEnergyUnit_Fragment = { __typename: 'CostPerEnergyUnit' };

type ReducedBranchDetails_CostPerHeatUnit_Fragment = { __typename: 'CostPerHeatUnit' };

type ReducedBranchDetails_CostPerVolume_Fragment = { __typename: 'CostPerVolume' };

type ReducedBranchDetails_CostRate_Fragment = { __typename: 'CostRate' };

type ReducedBranchDetails_Crew_Fragment = { __typename: 'Crew', id: string, name: string };

type ReducedBranchDetails_CrewMember_Fragment = { __typename: 'CrewMember', id: string, name: string };

type ReducedBranchDetails_CrewStatusKind_Fragment = { __typename: 'CrewStatusKind' };

type ReducedBranchDetails_CrewType_Fragment = { __typename: 'CrewType', id: string, name: string };

type ReducedBranchDetails_Currency_Fragment = { __typename: 'Currency' };

type ReducedBranchDetails_CurrentFlow_Fragment = { __typename: 'CurrentFlow' };

type ReducedBranchDetails_CurrentLimit_Fragment = { __typename: 'CurrentLimit', id: string, name: string };

type ReducedBranchDetails_CurveData_Fragment = { __typename: 'CurveData' };

type ReducedBranchDetails_CurveStyle_Fragment = { __typename: 'CurveStyle' };

type ReducedBranchDetails_Cut_Fragment = { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Damping_Fragment = { __typename: 'Damping' };

type ReducedBranchDetails_Date_Fragment = { __typename: 'Date' };

type ReducedBranchDetails_DateInterval_Fragment = { __typename: 'DateInterval' };

type ReducedBranchDetails_DateTime_Fragment = { __typename: 'DateTime' };

type ReducedBranchDetails_DateTimeInterval_Fragment = { __typename: 'DateTimeInterval' };

type ReducedBranchDetails_DecimalQuantity_Fragment = { __typename: 'DecimalQuantity' };

type ReducedBranchDetails_DisconnectingCircuitBreaker_Fragment = { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Disconnector_Fragment = { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Displacement_Fragment = { __typename: 'Displacement' };

type ReducedBranchDetails_Duration_Fragment = { __typename: 'Duration' };

type ReducedBranchDetails_Editor_Fragment = { __typename: 'Editor', id: string, name: string };

type ReducedBranchDetails_ElectronicAddress_Fragment = { __typename: 'ElectronicAddress' };

type ReducedBranchDetails_Emission_Fragment = { __typename: 'Emission' };

type ReducedBranchDetails_EmissionAccount_Fragment = { __typename: 'EmissionAccount', id: string, name: string };

type ReducedBranchDetails_EmissionCurve_Fragment = { __typename: 'EmissionCurve', id: string, name: string };

type ReducedBranchDetails_EmissionType_Fragment = { __typename: 'EmissionType' };

type ReducedBranchDetails_EmissionValueSource_Fragment = { __typename: 'EmissionValueSource' };

type ReducedBranchDetails_EnergyConsumer_Fragment = { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_EnergyConsumerPhase_Fragment = { __typename: 'EnergyConsumerPhase', id: string, name: string };

type ReducedBranchDetails_EnergySchedulingType_Fragment = { __typename: 'EnergySchedulingType', id: string, name: string };

type ReducedBranchDetails_EnergySource_Fragment = { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_EnergySourcePhase_Fragment = { __typename: 'EnergySourcePhase', id: string, name: string };

type ReducedBranchDetails_EquivalentBranch_Fragment = { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_EquivalentInjection_Fragment = { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_EquivalentNetwork_Fragment = { __typename: 'EquivalentNetwork', id: string, name: string };

type ReducedBranchDetails_EquivalentShunt_Fragment = { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_ExtensionItem_Fragment = { __typename: 'ExtensionItem' };

type ReducedBranchDetails_ExtensionsList_Fragment = { __typename: 'ExtensionsList' };

type ReducedBranchDetails_ExternalNetworkInjection_Fragment = { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Feeder_Fragment = { __typename: 'Feeder', id: string, name: string };

type ReducedBranchDetails_FieldDispatchHistory_Fragment = { __typename: 'FieldDispatchHistory', id: string, name: string };

type ReducedBranchDetails_FieldDispatchStep_Fragment = { __typename: 'FieldDispatchStep' };

type ReducedBranchDetails_FloatQuantity_Fragment = { __typename: 'FloatQuantity' };

type ReducedBranchDetails_FossilFuel_Fragment = { __typename: 'FossilFuel', id: string, name: string };

type ReducedBranchDetails_Frequency_Fragment = { __typename: 'Frequency' };

type ReducedBranchDetails_FrequencyConverter_Fragment = { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_FuelAllocationSchedule_Fragment = { __typename: 'FuelAllocationSchedule', id: string, name: string };

type ReducedBranchDetails_FuelType_Fragment = { __typename: 'FuelType' };

type ReducedBranchDetails_Fuse_Fragment = { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_GenUnitOpCostCurve_Fragment = { __typename: 'GenUnitOpCostCurve', id: string, name: string };

type ReducedBranchDetails_GenUnitOpSchedule_Fragment = { __typename: 'GenUnitOpSchedule', id: string, name: string };

type ReducedBranchDetails_GeneratorControlMode_Fragment = { __typename: 'GeneratorControlMode' };

type ReducedBranchDetails_GeneratorControlSource_Fragment = { __typename: 'GeneratorControlSource' };

type ReducedBranchDetails_GeographicalRegion_Fragment = { __typename: 'GeographicalRegion', id: string, name: string };

type ReducedBranchDetails_GrossToNetActivePowerCurve_Fragment = { __typename: 'GrossToNetActivePowerCurve', id: string, name: string };

type ReducedBranchDetails_Ground_Fragment = { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_GroundDisconnector_Fragment = { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_GroundingImpedance_Fragment = { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Hazard_Fragment = { __typename: 'Hazard', id: string, name: string };

type ReducedBranchDetails_HeatInputCurve_Fragment = { __typename: 'HeatInputCurve', id: string, name: string };

type ReducedBranchDetails_HeatRate_Fragment = { __typename: 'HeatRate' };

type ReducedBranchDetails_HeatRateCurve_Fragment = { __typename: 'HeatRateCurve', id: string, name: string };

type ReducedBranchDetails_Hours_Fragment = { __typename: 'Hours' };

type ReducedBranchDetails_HydroEnergyConversionKind_Fragment = { __typename: 'HydroEnergyConversionKind' };

type ReducedBranchDetails_HydroGeneratingEfficiencyCurve_Fragment = { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string };

type ReducedBranchDetails_HydroGeneratingUnit_Fragment = { __typename: 'HydroGeneratingUnit', id: string, name: string };

type ReducedBranchDetails_HydroPlantStorageKind_Fragment = { __typename: 'HydroPlantStorageKind' };

type ReducedBranchDetails_HydroPowerPlant_Fragment = { __typename: 'HydroPowerPlant', id: string, name: string };

type ReducedBranchDetails_HydroPump_Fragment = { __typename: 'HydroPump', id: string, name: string };

type ReducedBranchDetails_HydroPumpOpSchedule_Fragment = { __typename: 'HydroPumpOpSchedule', id: string, name: string };

type ReducedBranchDetails_Impedance_Fragment = { __typename: 'Impedance' };

type ReducedBranchDetails_IncrementalHeatRateCurve_Fragment = { __typename: 'IncrementalHeatRateCurve', id: string, name: string };

type ReducedBranchDetails_Inductance_Fragment = { __typename: 'Inductance' };

type ReducedBranchDetails_InductancePerLength_Fragment = { __typename: 'InductancePerLength' };

type ReducedBranchDetails_InflowForecast_Fragment = { __typename: 'InflowForecast', id: string, name: string };

type ReducedBranchDetails_IntegerQuantity_Fragment = { __typename: 'IntegerQuantity' };

type ReducedBranchDetails_InterrupterUnitInfo_Fragment = { __typename: 'InterrupterUnitInfo', id: string, name: string };

type ReducedBranchDetails_InterruptingMediumKind_Fragment = { __typename: 'InterruptingMediumKind' };

type ReducedBranchDetails_IrregularIntervalSchedule_Fragment = { __typename: 'IrregularIntervalSchedule', id: string, name: string };

type ReducedBranchDetails_IrregularTimePoint_Fragment = { __typename: 'IrregularTimePoint' };

type ReducedBranchDetails_Issuer_Fragment = { __typename: 'Issuer', id: string, name: string };

type ReducedBranchDetails_Jumper_Fragment = { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Junction_Fragment = { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_KiloActivePower_Fragment = { __typename: 'KiloActivePower' };

type ReducedBranchDetails_Length_Fragment = { __typename: 'Length' };

type ReducedBranchDetails_LevelVsVolumeCurve_Fragment = { __typename: 'LevelVsVolumeCurve', id: string, name: string };

type ReducedBranchDetails_Line_Fragment = { __typename: 'Line', id: string, name: string };

type ReducedBranchDetails_LinearShuntCompensator_Fragment = { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_LinearShuntCompensatorPhase_Fragment = { __typename: 'LinearShuntCompensatorPhase', id: string, name: string };

type ReducedBranchDetails_LoadBreakSwitch_Fragment = { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Location_Fragment = { __typename: 'Location', id: string, name: string };

type ReducedBranchDetails_Mass_Fragment = { __typename: 'Mass' };

type ReducedBranchDetails_Minutes_Fragment = { __typename: 'Minutes' };

type ReducedBranchDetails_Money_Fragment = { __typename: 'Money' };

type ReducedBranchDetails_MonthDay_Fragment = { __typename: 'MonthDay' };

type ReducedBranchDetails_MonthDayInterval_Fragment = { __typename: 'MonthDayInterval' };

type ReducedBranchDetails_MutualCoupling_Fragment = { __typename: 'MutualCoupling', id: string, name: string };

type ReducedBranchDetails_Name_Fragment = { __typename: 'Name' };

type ReducedBranchDetails_NameType_Fragment = { __typename: 'NameType' };

type ReducedBranchDetails_NameTypeAuthority_Fragment = { __typename: 'NameTypeAuthority' };

type ReducedBranchDetails_NoLoadTest_Fragment = { __typename: 'NoLoadTest', id: string, name: string };

type ReducedBranchDetails_NonlinearShuntCompensator_Fragment = { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_NonlinearShuntCompensatorPhase_Fragment = { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string };

type ReducedBranchDetails_NonlinearShuntCompensatorPhasePoint_Fragment = { __typename: 'NonlinearShuntCompensatorPhasePoint' };

type ReducedBranchDetails_NonlinearShuntCompensatorPoint_Fragment = { __typename: 'NonlinearShuntCompensatorPoint' };

type ReducedBranchDetails_NuclearGeneratingUnit_Fragment = { __typename: 'NuclearGeneratingUnit', id: string, name: string };

type ReducedBranchDetails_OpenCircuitTest_Fragment = { __typename: 'OpenCircuitTest', id: string, name: string };

type ReducedBranchDetails_OperatingMechanismInfo_Fragment = { __typename: 'OperatingMechanismInfo', id: string, name: string };

type ReducedBranchDetails_OperatingMechanismKind_Fragment = { __typename: 'OperatingMechanismKind' };

type ReducedBranchDetails_OperatingParticipant_Fragment = { __typename: 'OperatingParticipant', id: string, name: string };

type ReducedBranchDetails_OperatingShare_Fragment = { __typename: 'OperatingShare' };

type ReducedBranchDetails_OperationalLimitDirectionKind_Fragment = { __typename: 'OperationalLimitDirectionKind' };

type ReducedBranchDetails_OperationalLimitSet_Fragment = { __typename: 'OperationalLimitSet', id: string, name: string };

type ReducedBranchDetails_OperationalLimitType_Fragment = { __typename: 'OperationalLimitType', id: string, name: string };

type ReducedBranchDetails_Operator_Fragment = { __typename: 'Operator', id: string, name: string };

type ReducedBranchDetails_OrganisationRole_Fragment = { __typename: 'OrganisationRole', id: string, name: string };

type ReducedBranchDetails_OverheadWireInfo_Fragment = { __typename: 'OverheadWireInfo', id: string, name: string };

type ReducedBranchDetails_Ownership_Fragment = { __typename: 'Ownership', id: string, name: string };

type ReducedBranchDetails_PsrType_Fragment = { __typename: 'PSRType', id: string, name: string };

type ReducedBranchDetails_Pu_Fragment = { __typename: 'PU' };

type ReducedBranchDetails_ParentOrganization_Fragment = { __typename: 'ParentOrganization', id: string, name: string };

type ReducedBranchDetails_PenstockLossCurve_Fragment = { __typename: 'PenstockLossCurve', id: string, name: string };

type ReducedBranchDetails_PerCent_Fragment = { __typename: 'PerCent' };

type ReducedBranchDetails_PerLengthPhaseImpedance_Fragment = { __typename: 'PerLengthPhaseImpedance', id: string, name: string };

type ReducedBranchDetails_PerLengthSequenceImpedance_Fragment = { __typename: 'PerLengthSequenceImpedance', id: string, name: string };

type ReducedBranchDetails_Person_Fragment = { __typename: 'Person', id: string, name: string };

type ReducedBranchDetails_PetersenCoil_Fragment = { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_PetersenCoilModeKind_Fragment = { __typename: 'PetersenCoilModeKind' };

type ReducedBranchDetails_PhaseCode_Fragment = { __typename: 'PhaseCode' };

type ReducedBranchDetails_PhaseImpedanceData_Fragment = { __typename: 'PhaseImpedanceData' };

type ReducedBranchDetails_PhaseShuntConnectionKind_Fragment = { __typename: 'PhaseShuntConnectionKind' };

type ReducedBranchDetails_PhaseTapChangerAsymmetrical_Fragment = { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string };

type ReducedBranchDetails_PhaseTapChangerLinear_Fragment = { __typename: 'PhaseTapChangerLinear', id: string, name: string };

type ReducedBranchDetails_PhaseTapChangerSymmetrical_Fragment = { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string };

type ReducedBranchDetails_PhaseTapChangerTable_Fragment = { __typename: 'PhaseTapChangerTable', id: string, name: string };

type ReducedBranchDetails_PhaseTapChangerTablePoint_Fragment = { __typename: 'PhaseTapChangerTablePoint' };

type ReducedBranchDetails_PhaseTapChangerTabular_Fragment = { __typename: 'PhaseTapChangerTabular', id: string, name: string };

type ReducedBranchDetails_PhotoVoltaicUnit_Fragment = { __typename: 'PhotoVoltaicUnit', id: string, name: string };

type ReducedBranchDetails_Plant_Fragment = { __typename: 'Plant', id: string, name: string };

type ReducedBranchDetails_PositionPoint_Fragment = { __typename: 'PositionPoint' };

type ReducedBranchDetails_PowerElectronicsConnection_Fragment = { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_PowerElectronicsConnectionPhase_Fragment = { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string };

type ReducedBranchDetails_PowerElectronicsWindUnit_Fragment = { __typename: 'PowerElectronicsWindUnit', id: string, name: string };

type ReducedBranchDetails_PowerTransformer_Fragment = { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_PowerTransformerEnd_Fragment = { __typename: 'PowerTransformerEnd', id: string, name: string };

type ReducedBranchDetails_PowerTransformerInfo_Fragment = { __typename: 'PowerTransformerInfo', id: string, name: string };

type ReducedBranchDetails_Pressure_Fragment = { __typename: 'Pressure' };

type ReducedBranchDetails_Priority_Fragment = { __typename: 'Priority' };

type ReducedBranchDetails_RatioTapChanger_Fragment = { __typename: 'RatioTapChanger', id: string, name: string };

type ReducedBranchDetails_RatioTapChangerTable_Fragment = { __typename: 'RatioTapChangerTable', id: string, name: string };

type ReducedBranchDetails_RatioTapChangerTablePoint_Fragment = { __typename: 'RatioTapChangerTablePoint' };

type ReducedBranchDetails_Reactance_Fragment = { __typename: 'Reactance' };

type ReducedBranchDetails_ReactancePerLength_Fragment = { __typename: 'ReactancePerLength' };

type ReducedBranchDetails_ReactiveCapabilityCurve_Fragment = { __typename: 'ReactiveCapabilityCurve', id: string, name: string };

type ReducedBranchDetails_ReactivePower_Fragment = { __typename: 'ReactivePower' };

type ReducedBranchDetails_RealEnergy_Fragment = { __typename: 'RealEnergy' };

type ReducedBranchDetails_Recloser_Fragment = { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_RegularTimePoint_Fragment = { __typename: 'RegularTimePoint' };

type ReducedBranchDetails_RegulatingControlModeKind_Fragment = { __typename: 'RegulatingControlModeKind' };

type ReducedBranchDetails_RegulationSchedule_Fragment = { __typename: 'RegulationSchedule', id: string, name: string };

type ReducedBranchDetails_ReportingGroup_Fragment = { __typename: 'ReportingGroup', id: string, name: string };

type ReducedBranchDetails_ReportingSuperGroup_Fragment = { __typename: 'ReportingSuperGroup', id: string, name: string };

type ReducedBranchDetails_Reservoir_Fragment = { __typename: 'Reservoir', id: string, name: string };

type ReducedBranchDetails_Resistance_Fragment = { __typename: 'Resistance' };

type ReducedBranchDetails_ResistancePerLength_Fragment = { __typename: 'ResistancePerLength' };

type ReducedBranchDetails_RotationSpeed_Fragment = { __typename: 'RotationSpeed' };

type ReducedBranchDetails_SvcControlMode_Fragment = { __typename: 'SVCControlMode' };

type ReducedBranchDetails_ScheduledEvent_Fragment = { __typename: 'ScheduledEvent', id: string, name: string };

type ReducedBranchDetails_ScheduledEventData_Fragment = { __typename: 'ScheduledEventData' };

type ReducedBranchDetails_Seconds_Fragment = { __typename: 'Seconds' };

type ReducedBranchDetails_Sectionaliser_Fragment = { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_SeriesCompensator_Fragment = { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_ShortCircuitRotorKind_Fragment = { __typename: 'ShortCircuitRotorKind' };

type ReducedBranchDetails_ShortCircuitTest_Fragment = { __typename: 'ShortCircuitTest', id: string, name: string };

type ReducedBranchDetails_ShuntCompensatorInfo_Fragment = { __typename: 'ShuntCompensatorInfo', id: string, name: string };

type ReducedBranchDetails_ShutdownCurve_Fragment = { __typename: 'ShutdownCurve', id: string, name: string };

type ReducedBranchDetails_SinglePhaseKind_Fragment = { __typename: 'SinglePhaseKind' };

type ReducedBranchDetails_SolarGeneratingUnit_Fragment = { __typename: 'SolarGeneratingUnit', id: string, name: string };

type ReducedBranchDetails_Speed_Fragment = { __typename: 'Speed' };

type ReducedBranchDetails_StartIgnFuelCurve_Fragment = { __typename: 'StartIgnFuelCurve', id: string, name: string };

type ReducedBranchDetails_StartMainFuelCurve_Fragment = { __typename: 'StartMainFuelCurve', id: string, name: string };

type ReducedBranchDetails_StartRampCurve_Fragment = { __typename: 'StartRampCurve', id: string, name: string };

type ReducedBranchDetails_StartupModel_Fragment = { __typename: 'StartupModel', id: string, name: string };

type ReducedBranchDetails_StaticVarCompensator_Fragment = { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_Status_Fragment = { __typename: 'Status' };

type ReducedBranchDetails_SteamSendoutSchedule_Fragment = { __typename: 'SteamSendoutSchedule', id: string, name: string };

type ReducedBranchDetails_StreetAddress_Fragment = { __typename: 'StreetAddress' };

type ReducedBranchDetails_StreetDetail_Fragment = { __typename: 'StreetDetail' };

type ReducedBranchDetails_StringQuantity_Fragment = { __typename: 'StringQuantity' };

type ReducedBranchDetails_SubGeographicalRegion_Fragment = { __typename: 'SubGeographicalRegion', id: string, name: string };

type ReducedBranchDetails_Substation_Fragment = { __typename: 'Substation', id: string, name: string };

type ReducedBranchDetails_Susceptance_Fragment = { __typename: 'Susceptance' };

type ReducedBranchDetails_SusceptancePerLength_Fragment = { __typename: 'SusceptancePerLength' };

type ReducedBranchDetails_SwitchInfo_Fragment = { __typename: 'SwitchInfo', id: string, name: string };

type ReducedBranchDetails_SwitchPhase_Fragment = { __typename: 'SwitchPhase', id: string, name: string };

type ReducedBranchDetails_SwitchSchedule_Fragment = { __typename: 'SwitchSchedule', id: string, name: string };

type ReducedBranchDetails_SynchronousMachine_Fragment = { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_SynchronousMachineKind_Fragment = { __typename: 'SynchronousMachineKind' };

type ReducedBranchDetails_SynchronousMachineOperatingMode_Fragment = { __typename: 'SynchronousMachineOperatingMode' };

type ReducedBranchDetails_TailbayLossCurve_Fragment = { __typename: 'TailbayLossCurve', id: string, name: string };

type ReducedBranchDetails_TapChangerControl_Fragment = { __typename: 'TapChangerControl', id: string, name: string };

type ReducedBranchDetails_TapChangerInfo_Fragment = { __typename: 'TapChangerInfo', id: string, name: string };

type ReducedBranchDetails_TapSchedule_Fragment = { __typename: 'TapSchedule', id: string, name: string };

type ReducedBranchDetails_TapeShieldCableInfo_Fragment = { __typename: 'TapeShieldCableInfo', id: string, name: string };

type ReducedBranchDetails_TargetLevelSchedule_Fragment = { __typename: 'TargetLevelSchedule', id: string, name: string };

type ReducedBranchDetails_TelephoneNumber_Fragment = { __typename: 'TelephoneNumber' };

type ReducedBranchDetails_Temperature_Fragment = { __typename: 'Temperature' };

type ReducedBranchDetails_Terminal_Fragment = { __typename: 'Terminal', id: string, name: string };

type ReducedBranchDetails_ThermalGeneratingUnit_Fragment = { __typename: 'ThermalGeneratingUnit', id: string, name: string };

type ReducedBranchDetails_Time_Fragment = { __typename: 'Time' };

type ReducedBranchDetails_TimeInterval_Fragment = { __typename: 'TimeInterval' };

type ReducedBranchDetails_TimePoint_Fragment = { __typename: 'TimePoint', id: string, name: string };

type ReducedBranchDetails_TimeSchedule_Fragment = { __typename: 'TimeSchedule', id: string, name: string };

type ReducedBranchDetails_TopologicalIsland_Fragment = { __typename: 'TopologicalIsland', id: string, name: string };

type ReducedBranchDetails_TopologicalNode_Fragment = { __typename: 'TopologicalNode', id: string, name: string };

type ReducedBranchDetails_TownDetail_Fragment = { __typename: 'TownDetail' };

type ReducedBranchDetails_TransformerControlMode_Fragment = { __typename: 'TransformerControlMode' };

type ReducedBranchDetails_TransformerCoreAdmittance_Fragment = { __typename: 'TransformerCoreAdmittance', id: string, name: string };

type ReducedBranchDetails_TransformerEndInfo_Fragment = { __typename: 'TransformerEndInfo', id: string, name: string };

type ReducedBranchDetails_TransformerMeshImpedance_Fragment = { __typename: 'TransformerMeshImpedance', id: string, name: string };

type ReducedBranchDetails_TransformerStarImpedance_Fragment = { __typename: 'TransformerStarImpedance', id: string, name: string };

type ReducedBranchDetails_TransformerTank_Fragment = { __typename: 'TransformerTank', id: string, name: string };

type ReducedBranchDetails_TransformerTankEnd_Fragment = { __typename: 'TransformerTankEnd', id: string, name: string };

type ReducedBranchDetails_TransformerTankInfo_Fragment = { __typename: 'TransformerTankInfo', id: string, name: string };

type ReducedBranchDetails_UnitMultiplier_Fragment = { __typename: 'UnitMultiplier' };

type ReducedBranchDetails_UnitSymbol_Fragment = { __typename: 'UnitSymbol' };

type ReducedBranchDetails_UserAttribute_Fragment = { __typename: 'UserAttribute' };

type ReducedBranchDetails_Version_Fragment = { __typename: 'Version' };

type ReducedBranchDetails_Voltage_Fragment = { __typename: 'Voltage' };

type ReducedBranchDetails_VoltageControlZone_Fragment = { __typename: 'VoltageControlZone', id: string, name: string };

type ReducedBranchDetails_VoltageLevel_Fragment = { __typename: 'VoltageLevel', id: string, name: string };

type ReducedBranchDetails_VoltageLimit_Fragment = { __typename: 'VoltageLimit', id: string, name: string };

type ReducedBranchDetails_VoltagePerReactivePower_Fragment = { __typename: 'VoltagePerReactivePower' };

type ReducedBranchDetails_Volume_Fragment = { __typename: 'Volume' };

type ReducedBranchDetails_VolumeFlowRate_Fragment = { __typename: 'VolumeFlowRate' };

type ReducedBranchDetails_WaterLevel_Fragment = { __typename: 'WaterLevel' };

type ReducedBranchDetails_WindGenUnitKind_Fragment = { __typename: 'WindGenUnitKind' };

type ReducedBranchDetails_WindGeneratingUnit_Fragment = { __typename: 'WindGeneratingUnit', id: string, name: string };

type ReducedBranchDetails_WindingConnection_Fragment = { __typename: 'WindingConnection' };

type ReducedBranchDetails_WireAssemblyInfo_Fragment = { __typename: 'WireAssemblyInfo', id: string, name: string };

type ReducedBranchDetails_WireInsulationKind_Fragment = { __typename: 'WireInsulationKind' };

type ReducedBranchDetails_WireMaterialKind_Fragment = { __typename: 'WireMaterialKind' };

type ReducedBranchDetails_WirePhaseInfo_Fragment = { __typename: 'WirePhaseInfo' };

type ReducedBranchDetails_WirePosition_Fragment = { __typename: 'WirePosition', id: string, name: string };

type ReducedBranchDetails_WireSegment_Fragment = { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBranchDetails_WireSegmentPhase_Fragment = { __typename: 'WireSegmentPhase', id: string, name: string };

type ReducedBranchDetails_WireSpacingInfo_Fragment = { __typename: 'WireSpacingInfo', id: string, name: string };

type ReducedBranchDetails_WireUsageKind_Fragment = { __typename: 'WireUsageKind' };

export type ReducedBranchDetailsFragment =
  | ReducedBranchDetails_AcLineSegment_Fragment
  | ReducedBranchDetails_AcLineSegmentPhase_Fragment
  | ReducedBranchDetails_ActivePower_Fragment
  | ReducedBranchDetails_ActivePowerChangeRate_Fragment
  | ReducedBranchDetails_ActivePowerLimit_Fragment
  | ReducedBranchDetails_ActivePowerPerCurrentFlow_Fragment
  | ReducedBranchDetails_ActivePowerPerFrequency_Fragment
  | ReducedBranchDetails_Admittance_Fragment
  | ReducedBranchDetails_Agreement_Fragment
  | ReducedBranchDetails_AirCompressor_Fragment
  | ReducedBranchDetails_AngleDegrees_Fragment
  | ReducedBranchDetails_AngleRadians_Fragment
  | ReducedBranchDetails_ApparentPower_Fragment
  | ReducedBranchDetails_ApparentPowerLimit_Fragment
  | ReducedBranchDetails_Appointment_Fragment
  | ReducedBranchDetails_Approver_Fragment
  | ReducedBranchDetails_Area_Fragment
  | ReducedBranchDetails_AsynchronousMachine_Fragment
  | ReducedBranchDetails_AsynchronousMachineKind_Fragment
  | ReducedBranchDetails_Author_Fragment
  | ReducedBranchDetails_BaseFrequency_Fragment
  | ReducedBranchDetails_BasePower_Fragment
  | ReducedBranchDetails_BaseVoltage_Fragment
  | ReducedBranchDetails_BatteryStateKind_Fragment
  | ReducedBranchDetails_BatteryUnit_Fragment
  | ReducedBranchDetails_Bay_Fragment
  | ReducedBranchDetails_BranchGroup_Fragment
  | ReducedBranchDetails_BranchGroupTerminal_Fragment
  | ReducedBranchDetails_BreakerConfiguration_Fragment
  | ReducedBranchDetails_BusNameMarker_Fragment
  | ReducedBranchDetails_BusbarConfiguration_Fragment
  | ReducedBranchDetails_BusbarSection_Fragment
  | ReducedBranchDetails_BusbarSectionInfo_Fragment
  | ReducedBranchDetails_BushingInfo_Fragment
  | ReducedBranchDetails_BushingInsulationKind_Fragment
  | ReducedBranchDetails_CaesPlant_Fragment
  | ReducedBranchDetails_CableConstructionKind_Fragment
  | ReducedBranchDetails_CableOuterJacketKind_Fragment
  | ReducedBranchDetails_CableShieldMaterialKind_Fragment
  | ReducedBranchDetails_Capacitance_Fragment
  | ReducedBranchDetails_CapacitancePerLength_Fragment
  | ReducedBranchDetails_Clamp_Fragment
  | ReducedBranchDetails_Classification_Fragment
  | ReducedBranchDetails_CogenerationPlant_Fragment
  | ReducedBranchDetails_CombinedCyclePlant_Fragment
  | ReducedBranchDetails_CompositeSwitch_Fragment
  | ReducedBranchDetails_ConcentricNeutralCableInfo_Fragment
  | ReducedBranchDetails_Conductance_Fragment
  | ReducedBranchDetails_ConductancePerLength_Fragment
  | ReducedBranchDetails_ConfigurationEvent_Fragment
  | ReducedBranchDetails_ConnectivityNode_Fragment
  | ReducedBranchDetails_CoolantType_Fragment
  | ReducedBranchDetails_CoordinateSystem_Fragment
  | ReducedBranchDetails_CostPerEnergyUnit_Fragment
  | ReducedBranchDetails_CostPerHeatUnit_Fragment
  | ReducedBranchDetails_CostPerVolume_Fragment
  | ReducedBranchDetails_CostRate_Fragment
  | ReducedBranchDetails_Crew_Fragment
  | ReducedBranchDetails_CrewMember_Fragment
  | ReducedBranchDetails_CrewStatusKind_Fragment
  | ReducedBranchDetails_CrewType_Fragment
  | ReducedBranchDetails_Currency_Fragment
  | ReducedBranchDetails_CurrentFlow_Fragment
  | ReducedBranchDetails_CurrentLimit_Fragment
  | ReducedBranchDetails_CurveData_Fragment
  | ReducedBranchDetails_CurveStyle_Fragment
  | ReducedBranchDetails_Cut_Fragment
  | ReducedBranchDetails_Damping_Fragment
  | ReducedBranchDetails_Date_Fragment
  | ReducedBranchDetails_DateInterval_Fragment
  | ReducedBranchDetails_DateTime_Fragment
  | ReducedBranchDetails_DateTimeInterval_Fragment
  | ReducedBranchDetails_DecimalQuantity_Fragment
  | ReducedBranchDetails_DisconnectingCircuitBreaker_Fragment
  | ReducedBranchDetails_Disconnector_Fragment
  | ReducedBranchDetails_Displacement_Fragment
  | ReducedBranchDetails_Duration_Fragment
  | ReducedBranchDetails_Editor_Fragment
  | ReducedBranchDetails_ElectronicAddress_Fragment
  | ReducedBranchDetails_Emission_Fragment
  | ReducedBranchDetails_EmissionAccount_Fragment
  | ReducedBranchDetails_EmissionCurve_Fragment
  | ReducedBranchDetails_EmissionType_Fragment
  | ReducedBranchDetails_EmissionValueSource_Fragment
  | ReducedBranchDetails_EnergyConsumer_Fragment
  | ReducedBranchDetails_EnergyConsumerPhase_Fragment
  | ReducedBranchDetails_EnergySchedulingType_Fragment
  | ReducedBranchDetails_EnergySource_Fragment
  | ReducedBranchDetails_EnergySourcePhase_Fragment
  | ReducedBranchDetails_EquivalentBranch_Fragment
  | ReducedBranchDetails_EquivalentInjection_Fragment
  | ReducedBranchDetails_EquivalentNetwork_Fragment
  | ReducedBranchDetails_EquivalentShunt_Fragment
  | ReducedBranchDetails_ExtensionItem_Fragment
  | ReducedBranchDetails_ExtensionsList_Fragment
  | ReducedBranchDetails_ExternalNetworkInjection_Fragment
  | ReducedBranchDetails_Feeder_Fragment
  | ReducedBranchDetails_FieldDispatchHistory_Fragment
  | ReducedBranchDetails_FieldDispatchStep_Fragment
  | ReducedBranchDetails_FloatQuantity_Fragment
  | ReducedBranchDetails_FossilFuel_Fragment
  | ReducedBranchDetails_Frequency_Fragment
  | ReducedBranchDetails_FrequencyConverter_Fragment
  | ReducedBranchDetails_FuelAllocationSchedule_Fragment
  | ReducedBranchDetails_FuelType_Fragment
  | ReducedBranchDetails_Fuse_Fragment
  | ReducedBranchDetails_GenUnitOpCostCurve_Fragment
  | ReducedBranchDetails_GenUnitOpSchedule_Fragment
  | ReducedBranchDetails_GeneratorControlMode_Fragment
  | ReducedBranchDetails_GeneratorControlSource_Fragment
  | ReducedBranchDetails_GeographicalRegion_Fragment
  | ReducedBranchDetails_GrossToNetActivePowerCurve_Fragment
  | ReducedBranchDetails_Ground_Fragment
  | ReducedBranchDetails_GroundDisconnector_Fragment
  | ReducedBranchDetails_GroundingImpedance_Fragment
  | ReducedBranchDetails_Hazard_Fragment
  | ReducedBranchDetails_HeatInputCurve_Fragment
  | ReducedBranchDetails_HeatRate_Fragment
  | ReducedBranchDetails_HeatRateCurve_Fragment
  | ReducedBranchDetails_Hours_Fragment
  | ReducedBranchDetails_HydroEnergyConversionKind_Fragment
  | ReducedBranchDetails_HydroGeneratingEfficiencyCurve_Fragment
  | ReducedBranchDetails_HydroGeneratingUnit_Fragment
  | ReducedBranchDetails_HydroPlantStorageKind_Fragment
  | ReducedBranchDetails_HydroPowerPlant_Fragment
  | ReducedBranchDetails_HydroPump_Fragment
  | ReducedBranchDetails_HydroPumpOpSchedule_Fragment
  | ReducedBranchDetails_Impedance_Fragment
  | ReducedBranchDetails_IncrementalHeatRateCurve_Fragment
  | ReducedBranchDetails_Inductance_Fragment
  | ReducedBranchDetails_InductancePerLength_Fragment
  | ReducedBranchDetails_InflowForecast_Fragment
  | ReducedBranchDetails_IntegerQuantity_Fragment
  | ReducedBranchDetails_InterrupterUnitInfo_Fragment
  | ReducedBranchDetails_InterruptingMediumKind_Fragment
  | ReducedBranchDetails_IrregularIntervalSchedule_Fragment
  | ReducedBranchDetails_IrregularTimePoint_Fragment
  | ReducedBranchDetails_Issuer_Fragment
  | ReducedBranchDetails_Jumper_Fragment
  | ReducedBranchDetails_Junction_Fragment
  | ReducedBranchDetails_KiloActivePower_Fragment
  | ReducedBranchDetails_Length_Fragment
  | ReducedBranchDetails_LevelVsVolumeCurve_Fragment
  | ReducedBranchDetails_Line_Fragment
  | ReducedBranchDetails_LinearShuntCompensator_Fragment
  | ReducedBranchDetails_LinearShuntCompensatorPhase_Fragment
  | ReducedBranchDetails_LoadBreakSwitch_Fragment
  | ReducedBranchDetails_Location_Fragment
  | ReducedBranchDetails_Mass_Fragment
  | ReducedBranchDetails_Minutes_Fragment
  | ReducedBranchDetails_Money_Fragment
  | ReducedBranchDetails_MonthDay_Fragment
  | ReducedBranchDetails_MonthDayInterval_Fragment
  | ReducedBranchDetails_MutualCoupling_Fragment
  | ReducedBranchDetails_Name_Fragment
  | ReducedBranchDetails_NameType_Fragment
  | ReducedBranchDetails_NameTypeAuthority_Fragment
  | ReducedBranchDetails_NoLoadTest_Fragment
  | ReducedBranchDetails_NonlinearShuntCompensator_Fragment
  | ReducedBranchDetails_NonlinearShuntCompensatorPhase_Fragment
  | ReducedBranchDetails_NonlinearShuntCompensatorPhasePoint_Fragment
  | ReducedBranchDetails_NonlinearShuntCompensatorPoint_Fragment
  | ReducedBranchDetails_NuclearGeneratingUnit_Fragment
  | ReducedBranchDetails_OpenCircuitTest_Fragment
  | ReducedBranchDetails_OperatingMechanismInfo_Fragment
  | ReducedBranchDetails_OperatingMechanismKind_Fragment
  | ReducedBranchDetails_OperatingParticipant_Fragment
  | ReducedBranchDetails_OperatingShare_Fragment
  | ReducedBranchDetails_OperationalLimitDirectionKind_Fragment
  | ReducedBranchDetails_OperationalLimitSet_Fragment
  | ReducedBranchDetails_OperationalLimitType_Fragment
  | ReducedBranchDetails_Operator_Fragment
  | ReducedBranchDetails_OrganisationRole_Fragment
  | ReducedBranchDetails_OverheadWireInfo_Fragment
  | ReducedBranchDetails_Ownership_Fragment
  | ReducedBranchDetails_PsrType_Fragment
  | ReducedBranchDetails_Pu_Fragment
  | ReducedBranchDetails_ParentOrganization_Fragment
  | ReducedBranchDetails_PenstockLossCurve_Fragment
  | ReducedBranchDetails_PerCent_Fragment
  | ReducedBranchDetails_PerLengthPhaseImpedance_Fragment
  | ReducedBranchDetails_PerLengthSequenceImpedance_Fragment
  | ReducedBranchDetails_Person_Fragment
  | ReducedBranchDetails_PetersenCoil_Fragment
  | ReducedBranchDetails_PetersenCoilModeKind_Fragment
  | ReducedBranchDetails_PhaseCode_Fragment
  | ReducedBranchDetails_PhaseImpedanceData_Fragment
  | ReducedBranchDetails_PhaseShuntConnectionKind_Fragment
  | ReducedBranchDetails_PhaseTapChangerAsymmetrical_Fragment
  | ReducedBranchDetails_PhaseTapChangerLinear_Fragment
  | ReducedBranchDetails_PhaseTapChangerSymmetrical_Fragment
  | ReducedBranchDetails_PhaseTapChangerTable_Fragment
  | ReducedBranchDetails_PhaseTapChangerTablePoint_Fragment
  | ReducedBranchDetails_PhaseTapChangerTabular_Fragment
  | ReducedBranchDetails_PhotoVoltaicUnit_Fragment
  | ReducedBranchDetails_Plant_Fragment
  | ReducedBranchDetails_PositionPoint_Fragment
  | ReducedBranchDetails_PowerElectronicsConnection_Fragment
  | ReducedBranchDetails_PowerElectronicsConnectionPhase_Fragment
  | ReducedBranchDetails_PowerElectronicsWindUnit_Fragment
  | ReducedBranchDetails_PowerTransformer_Fragment
  | ReducedBranchDetails_PowerTransformerEnd_Fragment
  | ReducedBranchDetails_PowerTransformerInfo_Fragment
  | ReducedBranchDetails_Pressure_Fragment
  | ReducedBranchDetails_Priority_Fragment
  | ReducedBranchDetails_RatioTapChanger_Fragment
  | ReducedBranchDetails_RatioTapChangerTable_Fragment
  | ReducedBranchDetails_RatioTapChangerTablePoint_Fragment
  | ReducedBranchDetails_Reactance_Fragment
  | ReducedBranchDetails_ReactancePerLength_Fragment
  | ReducedBranchDetails_ReactiveCapabilityCurve_Fragment
  | ReducedBranchDetails_ReactivePower_Fragment
  | ReducedBranchDetails_RealEnergy_Fragment
  | ReducedBranchDetails_Recloser_Fragment
  | ReducedBranchDetails_RegularTimePoint_Fragment
  | ReducedBranchDetails_RegulatingControlModeKind_Fragment
  | ReducedBranchDetails_RegulationSchedule_Fragment
  | ReducedBranchDetails_ReportingGroup_Fragment
  | ReducedBranchDetails_ReportingSuperGroup_Fragment
  | ReducedBranchDetails_Reservoir_Fragment
  | ReducedBranchDetails_Resistance_Fragment
  | ReducedBranchDetails_ResistancePerLength_Fragment
  | ReducedBranchDetails_RotationSpeed_Fragment
  | ReducedBranchDetails_SvcControlMode_Fragment
  | ReducedBranchDetails_ScheduledEvent_Fragment
  | ReducedBranchDetails_ScheduledEventData_Fragment
  | ReducedBranchDetails_Seconds_Fragment
  | ReducedBranchDetails_Sectionaliser_Fragment
  | ReducedBranchDetails_SeriesCompensator_Fragment
  | ReducedBranchDetails_ShortCircuitRotorKind_Fragment
  | ReducedBranchDetails_ShortCircuitTest_Fragment
  | ReducedBranchDetails_ShuntCompensatorInfo_Fragment
  | ReducedBranchDetails_ShutdownCurve_Fragment
  | ReducedBranchDetails_SinglePhaseKind_Fragment
  | ReducedBranchDetails_SolarGeneratingUnit_Fragment
  | ReducedBranchDetails_Speed_Fragment
  | ReducedBranchDetails_StartIgnFuelCurve_Fragment
  | ReducedBranchDetails_StartMainFuelCurve_Fragment
  | ReducedBranchDetails_StartRampCurve_Fragment
  | ReducedBranchDetails_StartupModel_Fragment
  | ReducedBranchDetails_StaticVarCompensator_Fragment
  | ReducedBranchDetails_Status_Fragment
  | ReducedBranchDetails_SteamSendoutSchedule_Fragment
  | ReducedBranchDetails_StreetAddress_Fragment
  | ReducedBranchDetails_StreetDetail_Fragment
  | ReducedBranchDetails_StringQuantity_Fragment
  | ReducedBranchDetails_SubGeographicalRegion_Fragment
  | ReducedBranchDetails_Substation_Fragment
  | ReducedBranchDetails_Susceptance_Fragment
  | ReducedBranchDetails_SusceptancePerLength_Fragment
  | ReducedBranchDetails_SwitchInfo_Fragment
  | ReducedBranchDetails_SwitchPhase_Fragment
  | ReducedBranchDetails_SwitchSchedule_Fragment
  | ReducedBranchDetails_SynchronousMachine_Fragment
  | ReducedBranchDetails_SynchronousMachineKind_Fragment
  | ReducedBranchDetails_SynchronousMachineOperatingMode_Fragment
  | ReducedBranchDetails_TailbayLossCurve_Fragment
  | ReducedBranchDetails_TapChangerControl_Fragment
  | ReducedBranchDetails_TapChangerInfo_Fragment
  | ReducedBranchDetails_TapSchedule_Fragment
  | ReducedBranchDetails_TapeShieldCableInfo_Fragment
  | ReducedBranchDetails_TargetLevelSchedule_Fragment
  | ReducedBranchDetails_TelephoneNumber_Fragment
  | ReducedBranchDetails_Temperature_Fragment
  | ReducedBranchDetails_Terminal_Fragment
  | ReducedBranchDetails_ThermalGeneratingUnit_Fragment
  | ReducedBranchDetails_Time_Fragment
  | ReducedBranchDetails_TimeInterval_Fragment
  | ReducedBranchDetails_TimePoint_Fragment
  | ReducedBranchDetails_TimeSchedule_Fragment
  | ReducedBranchDetails_TopologicalIsland_Fragment
  | ReducedBranchDetails_TopologicalNode_Fragment
  | ReducedBranchDetails_TownDetail_Fragment
  | ReducedBranchDetails_TransformerControlMode_Fragment
  | ReducedBranchDetails_TransformerCoreAdmittance_Fragment
  | ReducedBranchDetails_TransformerEndInfo_Fragment
  | ReducedBranchDetails_TransformerMeshImpedance_Fragment
  | ReducedBranchDetails_TransformerStarImpedance_Fragment
  | ReducedBranchDetails_TransformerTank_Fragment
  | ReducedBranchDetails_TransformerTankEnd_Fragment
  | ReducedBranchDetails_TransformerTankInfo_Fragment
  | ReducedBranchDetails_UnitMultiplier_Fragment
  | ReducedBranchDetails_UnitSymbol_Fragment
  | ReducedBranchDetails_UserAttribute_Fragment
  | ReducedBranchDetails_Version_Fragment
  | ReducedBranchDetails_Voltage_Fragment
  | ReducedBranchDetails_VoltageControlZone_Fragment
  | ReducedBranchDetails_VoltageLevel_Fragment
  | ReducedBranchDetails_VoltageLimit_Fragment
  | ReducedBranchDetails_VoltagePerReactivePower_Fragment
  | ReducedBranchDetails_Volume_Fragment
  | ReducedBranchDetails_VolumeFlowRate_Fragment
  | ReducedBranchDetails_WaterLevel_Fragment
  | ReducedBranchDetails_WindGenUnitKind_Fragment
  | ReducedBranchDetails_WindGeneratingUnit_Fragment
  | ReducedBranchDetails_WindingConnection_Fragment
  | ReducedBranchDetails_WireAssemblyInfo_Fragment
  | ReducedBranchDetails_WireInsulationKind_Fragment
  | ReducedBranchDetails_WireMaterialKind_Fragment
  | ReducedBranchDetails_WirePhaseInfo_Fragment
  | ReducedBranchDetails_WirePosition_Fragment
  | ReducedBranchDetails_WireSegment_Fragment
  | ReducedBranchDetails_WireSegmentPhase_Fragment
  | ReducedBranchDetails_WireSpacingInfo_Fragment
  | ReducedBranchDetails_WireUsageKind_Fragment
;

export type FetchReducedBranchDetailsByIdQueryVariables = Exact<{
  modelName: string;
  id: string | number;
}>;


export interface FetchReducedBranchDetailsByIdQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', reducedBranch: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit', id: string, name: string }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement', id: string, name: string }
      | { __typename: 'AirCompressor', id: string, name: string }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit', id: string, name: string }
      | { __typename: 'Appointment', id: string, name: string }
      | { __typename: 'Approver', id: string, name: string }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author', id: string, name: string }
      | { __typename: 'BaseFrequency', id: string, name: string }
      | { __typename: 'BasePower', id: string, name: string }
      | { __typename: 'BaseVoltage', id: string, name: string }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit', id: string, name: string }
      | { __typename: 'Bay', id: string, name: string }
      | { __typename: 'BranchGroup', id: string, name: string }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker', id: string, name: string }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'BusbarSectionInfo', id: string, name: string }
      | { __typename: 'BushingInfo', id: string, name: string }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant', id: string, name: string }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant', id: string, name: string }
      | { __typename: 'CombinedCyclePlant', id: string, name: string }
      | { __typename: 'CompositeSwitch', id: string, name: string }
      | { __typename: 'ConcentricNeutralCableInfo', id: string, name: string }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent', id: string, name: string }
      | { __typename: 'ConnectivityNode', id: string, name: string }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem', id: string, name: string }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew', id: string, name: string }
      | { __typename: 'CrewMember', id: string, name: string }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType', id: string, name: string }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit', id: string, name: string }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor', id: string, name: string }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount', id: string, name: string }
      | { __typename: 'EmissionCurve', id: string, name: string }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string }
      | { __typename: 'EnergySchedulingType', id: string, name: string }
      | { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergySourcePhase', id: string, name: string }
      | { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentNetwork', id: string, name: string }
      | { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Feeder', id: string, name: string }
      | { __typename: 'FieldDispatchHistory', id: string, name: string }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel', id: string, name: string }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'FuelAllocationSchedule', id: string, name: string }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GenUnitOpCostCurve', id: string, name: string }
      | { __typename: 'GenUnitOpSchedule', id: string, name: string }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion', id: string, name: string }
      | { __typename: 'GrossToNetActivePowerCurve', id: string, name: string }
      | { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Hazard', id: string, name: string }
      | { __typename: 'HeatInputCurve', id: string, name: string }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve', id: string, name: string }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant', id: string, name: string }
      | { __typename: 'HydroPump', id: string, name: string }
      | { __typename: 'HydroPumpOpSchedule', id: string, name: string }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve', id: string, name: string }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast', id: string, name: string }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo', id: string, name: string }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule', id: string, name: string }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer', id: string, name: string }
      | { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve', id: string, name: string }
      | { __typename: 'Line', id: string, name: string }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Location', id: string, name: string }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling', id: string, name: string }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string }
      | { __typename: 'OpenCircuitTest', id: string, name: string }
      | { __typename: 'OperatingMechanismInfo', id: string, name: string }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant', id: string, name: string }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet', id: string, name: string }
      | { __typename: 'OperationalLimitType', id: string, name: string }
      | { __typename: 'Operator', id: string, name: string }
      | { __typename: 'OrganisationRole', id: string, name: string }
      | { __typename: 'OverheadWireInfo', id: string, name: string }
      | { __typename: 'Ownership', id: string, name: string }
      | { __typename: 'PSRType', id: string, name: string }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization', id: string, name: string }
      | { __typename: 'PenstockLossCurve', id: string, name: string }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance', id: string, name: string }
      | { __typename: 'PerLengthSequenceImpedance', id: string, name: string }
      | { __typename: 'Person', id: string, name: string }
      | { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerTable', id: string, name: string }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
      | { __typename: 'Plant', id: string, name: string }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
      | { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerTransformerEnd', id: string, name: string }
      | { __typename: 'PowerTransformerInfo', id: string, name: string }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger', id: string, name: string }
      | { __typename: 'RatioTapChangerTable', id: string, name: string }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve', id: string, name: string }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule', id: string, name: string }
      | { __typename: 'ReportingGroup', id: string, name: string }
      | { __typename: 'ReportingSuperGroup', id: string, name: string }
      | { __typename: 'Reservoir', id: string, name: string }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent', id: string, name: string }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest', id: string, name: string }
      | { __typename: 'ShuntCompensatorInfo', id: string, name: string }
      | { __typename: 'ShutdownCurve', id: string, name: string }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve', id: string, name: string }
      | { __typename: 'StartMainFuelCurve', id: string, name: string }
      | { __typename: 'StartRampCurve', id: string, name: string }
      | { __typename: 'StartupModel', id: string, name: string }
      | { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule', id: string, name: string }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion', id: string, name: string }
      | { __typename: 'Substation', id: string, name: string }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo', id: string, name: string }
      | { __typename: 'SwitchPhase', id: string, name: string }
      | { __typename: 'SwitchSchedule', id: string, name: string }
      | { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve', id: string, name: string }
      | { __typename: 'TapChangerControl', id: string, name: string }
      | { __typename: 'TapChangerInfo', id: string, name: string }
      | { __typename: 'TapSchedule', id: string, name: string }
      | { __typename: 'TapeShieldCableInfo', id: string, name: string }
      | { __typename: 'TargetLevelSchedule', id: string, name: string }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal', id: string, name: string }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint', id: string, name: string }
      | { __typename: 'TimeSchedule', id: string, name: string }
      | { __typename: 'TopologicalIsland', id: string, name: string }
      | { __typename: 'TopologicalNode', id: string, name: string }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance', id: string, name: string }
      | { __typename: 'TransformerEndInfo', id: string, name: string }
      | { __typename: 'TransformerMeshImpedance', id: string, name: string }
      | { __typename: 'TransformerStarImpedance', id: string, name: string }
      | { __typename: 'TransformerTank', id: string, name: string }
      | { __typename: 'TransformerTankEnd', id: string, name: string }
      | { __typename: 'TransformerTankInfo', id: string, name: string }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone', id: string, name: string }
      | { __typename: 'VoltageLevel', id: string, name: string }
      | { __typename: 'VoltageLimit', id: string, name: string }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit', id: string, name: string }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo', id: string, name: string }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition', id: string, name: string }
      | { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'WireSegmentPhase', id: string, name: string }
      | { __typename: 'WireSpacingInfo', id: string, name: string }
      | { __typename: 'WireUsageKind' }
    > } }

export type FetchReducedBranchDetailsQueryVariables = Exact<{
  modelName: string;
  types: Array<Types.CimType> | Types.CimType;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchReducedBranchDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', reducedBranch: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit', id: string, name: string }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement', id: string, name: string }
      | { __typename: 'AirCompressor', id: string, name: string }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit', id: string, name: string }
      | { __typename: 'Appointment', id: string, name: string }
      | { __typename: 'Approver', id: string, name: string }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author', id: string, name: string }
      | { __typename: 'BaseFrequency', id: string, name: string }
      | { __typename: 'BasePower', id: string, name: string }
      | { __typename: 'BaseVoltage', id: string, name: string }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit', id: string, name: string }
      | { __typename: 'Bay', id: string, name: string }
      | { __typename: 'BranchGroup', id: string, name: string }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker', id: string, name: string }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'BusbarSectionInfo', id: string, name: string }
      | { __typename: 'BushingInfo', id: string, name: string }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant', id: string, name: string }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant', id: string, name: string }
      | { __typename: 'CombinedCyclePlant', id: string, name: string }
      | { __typename: 'CompositeSwitch', id: string, name: string }
      | { __typename: 'ConcentricNeutralCableInfo', id: string, name: string }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent', id: string, name: string }
      | { __typename: 'ConnectivityNode', id: string, name: string }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem', id: string, name: string }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew', id: string, name: string }
      | { __typename: 'CrewMember', id: string, name: string }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType', id: string, name: string }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit', id: string, name: string }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor', id: string, name: string }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount', id: string, name: string }
      | { __typename: 'EmissionCurve', id: string, name: string }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string }
      | { __typename: 'EnergySchedulingType', id: string, name: string }
      | { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergySourcePhase', id: string, name: string }
      | { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentNetwork', id: string, name: string }
      | { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Feeder', id: string, name: string }
      | { __typename: 'FieldDispatchHistory', id: string, name: string }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel', id: string, name: string }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'FuelAllocationSchedule', id: string, name: string }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GenUnitOpCostCurve', id: string, name: string }
      | { __typename: 'GenUnitOpSchedule', id: string, name: string }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion', id: string, name: string }
      | { __typename: 'GrossToNetActivePowerCurve', id: string, name: string }
      | { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Hazard', id: string, name: string }
      | { __typename: 'HeatInputCurve', id: string, name: string }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve', id: string, name: string }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant', id: string, name: string }
      | { __typename: 'HydroPump', id: string, name: string }
      | { __typename: 'HydroPumpOpSchedule', id: string, name: string }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve', id: string, name: string }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast', id: string, name: string }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo', id: string, name: string }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule', id: string, name: string }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer', id: string, name: string }
      | { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve', id: string, name: string }
      | { __typename: 'Line', id: string, name: string }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Location', id: string, name: string }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling', id: string, name: string }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string }
      | { __typename: 'OpenCircuitTest', id: string, name: string }
      | { __typename: 'OperatingMechanismInfo', id: string, name: string }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant', id: string, name: string }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet', id: string, name: string }
      | { __typename: 'OperationalLimitType', id: string, name: string }
      | { __typename: 'Operator', id: string, name: string }
      | { __typename: 'OrganisationRole', id: string, name: string }
      | { __typename: 'OverheadWireInfo', id: string, name: string }
      | { __typename: 'Ownership', id: string, name: string }
      | { __typename: 'PSRType', id: string, name: string }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization', id: string, name: string }
      | { __typename: 'PenstockLossCurve', id: string, name: string }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance', id: string, name: string }
      | { __typename: 'PerLengthSequenceImpedance', id: string, name: string }
      | { __typename: 'Person', id: string, name: string }
      | { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerTable', id: string, name: string }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
      | { __typename: 'Plant', id: string, name: string }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
      | { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerTransformerEnd', id: string, name: string }
      | { __typename: 'PowerTransformerInfo', id: string, name: string }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger', id: string, name: string }
      | { __typename: 'RatioTapChangerTable', id: string, name: string }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve', id: string, name: string }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule', id: string, name: string }
      | { __typename: 'ReportingGroup', id: string, name: string }
      | { __typename: 'ReportingSuperGroup', id: string, name: string }
      | { __typename: 'Reservoir', id: string, name: string }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent', id: string, name: string }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest', id: string, name: string }
      | { __typename: 'ShuntCompensatorInfo', id: string, name: string }
      | { __typename: 'ShutdownCurve', id: string, name: string }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve', id: string, name: string }
      | { __typename: 'StartMainFuelCurve', id: string, name: string }
      | { __typename: 'StartRampCurve', id: string, name: string }
      | { __typename: 'StartupModel', id: string, name: string }
      | { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule', id: string, name: string }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion', id: string, name: string }
      | { __typename: 'Substation', id: string, name: string }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo', id: string, name: string }
      | { __typename: 'SwitchPhase', id: string, name: string }
      | { __typename: 'SwitchSchedule', id: string, name: string }
      | { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve', id: string, name: string }
      | { __typename: 'TapChangerControl', id: string, name: string }
      | { __typename: 'TapChangerInfo', id: string, name: string }
      | { __typename: 'TapSchedule', id: string, name: string }
      | { __typename: 'TapeShieldCableInfo', id: string, name: string }
      | { __typename: 'TargetLevelSchedule', id: string, name: string }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal', id: string, name: string }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint', id: string, name: string }
      | { __typename: 'TimeSchedule', id: string, name: string }
      | { __typename: 'TopologicalIsland', id: string, name: string }
      | { __typename: 'TopologicalNode', id: string, name: string }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance', id: string, name: string }
      | { __typename: 'TransformerEndInfo', id: string, name: string }
      | { __typename: 'TransformerMeshImpedance', id: string, name: string }
      | { __typename: 'TransformerStarImpedance', id: string, name: string }
      | { __typename: 'TransformerTank', id: string, name: string }
      | { __typename: 'TransformerTankEnd', id: string, name: string }
      | { __typename: 'TransformerTankInfo', id: string, name: string }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone', id: string, name: string }
      | { __typename: 'VoltageLevel', id: string, name: string }
      | { __typename: 'VoltageLimit', id: string, name: string }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit', id: string, name: string }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo', id: string, name: string }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition', id: string, name: string }
      | { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'WireSegmentPhase', id: string, name: string }
      | { __typename: 'WireSpacingInfo', id: string, name: string }
      | { __typename: 'WireUsageKind' }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

type ReducedBusDetails_AcLineSegment_Fragment = { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_AcLineSegmentPhase_Fragment = { __typename: 'ACLineSegmentPhase', id: string, name: string };

type ReducedBusDetails_ActivePower_Fragment = { __typename: 'ActivePower' };

type ReducedBusDetails_ActivePowerChangeRate_Fragment = { __typename: 'ActivePowerChangeRate' };

type ReducedBusDetails_ActivePowerLimit_Fragment = { __typename: 'ActivePowerLimit', id: string, name: string };

type ReducedBusDetails_ActivePowerPerCurrentFlow_Fragment = { __typename: 'ActivePowerPerCurrentFlow' };

type ReducedBusDetails_ActivePowerPerFrequency_Fragment = { __typename: 'ActivePowerPerFrequency' };

type ReducedBusDetails_Admittance_Fragment = { __typename: 'Admittance' };

type ReducedBusDetails_Agreement_Fragment = { __typename: 'Agreement', id: string, name: string };

type ReducedBusDetails_AirCompressor_Fragment = { __typename: 'AirCompressor', id: string, name: string };

type ReducedBusDetails_AngleDegrees_Fragment = { __typename: 'AngleDegrees' };

type ReducedBusDetails_AngleRadians_Fragment = { __typename: 'AngleRadians' };

type ReducedBusDetails_ApparentPower_Fragment = { __typename: 'ApparentPower' };

type ReducedBusDetails_ApparentPowerLimit_Fragment = { __typename: 'ApparentPowerLimit', id: string, name: string };

type ReducedBusDetails_Appointment_Fragment = { __typename: 'Appointment', id: string, name: string };

type ReducedBusDetails_Approver_Fragment = { __typename: 'Approver', id: string, name: string };

type ReducedBusDetails_Area_Fragment = { __typename: 'Area' };

type ReducedBusDetails_AsynchronousMachine_Fragment = { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_AsynchronousMachineKind_Fragment = { __typename: 'AsynchronousMachineKind' };

type ReducedBusDetails_Author_Fragment = { __typename: 'Author', id: string, name: string };

type ReducedBusDetails_BaseFrequency_Fragment = { __typename: 'BaseFrequency', id: string, name: string };

type ReducedBusDetails_BasePower_Fragment = { __typename: 'BasePower', id: string, name: string };

type ReducedBusDetails_BaseVoltage_Fragment = { __typename: 'BaseVoltage', id: string, name: string };

type ReducedBusDetails_BatteryStateKind_Fragment = { __typename: 'BatteryStateKind' };

type ReducedBusDetails_BatteryUnit_Fragment = { __typename: 'BatteryUnit', id: string, name: string };

type ReducedBusDetails_Bay_Fragment = { __typename: 'Bay', id: string, name: string };

type ReducedBusDetails_BranchGroup_Fragment = { __typename: 'BranchGroup', id: string, name: string };

type ReducedBusDetails_BranchGroupTerminal_Fragment = { __typename: 'BranchGroupTerminal' };

type ReducedBusDetails_BreakerConfiguration_Fragment = { __typename: 'BreakerConfiguration' };

type ReducedBusDetails_BusNameMarker_Fragment = { __typename: 'BusNameMarker', id: string, name: string };

type ReducedBusDetails_BusbarConfiguration_Fragment = { __typename: 'BusbarConfiguration' };

type ReducedBusDetails_BusbarSection_Fragment = { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_BusbarSectionInfo_Fragment = { __typename: 'BusbarSectionInfo', id: string, name: string };

type ReducedBusDetails_BushingInfo_Fragment = { __typename: 'BushingInfo', id: string, name: string };

type ReducedBusDetails_BushingInsulationKind_Fragment = { __typename: 'BushingInsulationKind' };

type ReducedBusDetails_CaesPlant_Fragment = { __typename: 'CAESPlant', id: string, name: string };

type ReducedBusDetails_CableConstructionKind_Fragment = { __typename: 'CableConstructionKind' };

type ReducedBusDetails_CableOuterJacketKind_Fragment = { __typename: 'CableOuterJacketKind' };

type ReducedBusDetails_CableShieldMaterialKind_Fragment = { __typename: 'CableShieldMaterialKind' };

type ReducedBusDetails_Capacitance_Fragment = { __typename: 'Capacitance' };

type ReducedBusDetails_CapacitancePerLength_Fragment = { __typename: 'CapacitancePerLength' };

type ReducedBusDetails_Clamp_Fragment = { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Classification_Fragment = { __typename: 'Classification' };

type ReducedBusDetails_CogenerationPlant_Fragment = { __typename: 'CogenerationPlant', id: string, name: string };

type ReducedBusDetails_CombinedCyclePlant_Fragment = { __typename: 'CombinedCyclePlant', id: string, name: string };

type ReducedBusDetails_CompositeSwitch_Fragment = { __typename: 'CompositeSwitch', id: string, name: string };

type ReducedBusDetails_ConcentricNeutralCableInfo_Fragment = { __typename: 'ConcentricNeutralCableInfo', id: string, name: string };

type ReducedBusDetails_Conductance_Fragment = { __typename: 'Conductance' };

type ReducedBusDetails_ConductancePerLength_Fragment = { __typename: 'ConductancePerLength' };

type ReducedBusDetails_ConfigurationEvent_Fragment = { __typename: 'ConfigurationEvent', id: string, name: string };

type ReducedBusDetails_ConnectivityNode_Fragment = { __typename: 'ConnectivityNode', id: string, name: string };

type ReducedBusDetails_CoolantType_Fragment = { __typename: 'CoolantType' };

type ReducedBusDetails_CoordinateSystem_Fragment = { __typename: 'CoordinateSystem', id: string, name: string };

type ReducedBusDetails_CostPerEnergyUnit_Fragment = { __typename: 'CostPerEnergyUnit' };

type ReducedBusDetails_CostPerHeatUnit_Fragment = { __typename: 'CostPerHeatUnit' };

type ReducedBusDetails_CostPerVolume_Fragment = { __typename: 'CostPerVolume' };

type ReducedBusDetails_CostRate_Fragment = { __typename: 'CostRate' };

type ReducedBusDetails_Crew_Fragment = { __typename: 'Crew', id: string, name: string };

type ReducedBusDetails_CrewMember_Fragment = { __typename: 'CrewMember', id: string, name: string };

type ReducedBusDetails_CrewStatusKind_Fragment = { __typename: 'CrewStatusKind' };

type ReducedBusDetails_CrewType_Fragment = { __typename: 'CrewType', id: string, name: string };

type ReducedBusDetails_Currency_Fragment = { __typename: 'Currency' };

type ReducedBusDetails_CurrentFlow_Fragment = { __typename: 'CurrentFlow' };

type ReducedBusDetails_CurrentLimit_Fragment = { __typename: 'CurrentLimit', id: string, name: string };

type ReducedBusDetails_CurveData_Fragment = { __typename: 'CurveData' };

type ReducedBusDetails_CurveStyle_Fragment = { __typename: 'CurveStyle' };

type ReducedBusDetails_Cut_Fragment = { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Damping_Fragment = { __typename: 'Damping' };

type ReducedBusDetails_Date_Fragment = { __typename: 'Date' };

type ReducedBusDetails_DateInterval_Fragment = { __typename: 'DateInterval' };

type ReducedBusDetails_DateTime_Fragment = { __typename: 'DateTime' };

type ReducedBusDetails_DateTimeInterval_Fragment = { __typename: 'DateTimeInterval' };

type ReducedBusDetails_DecimalQuantity_Fragment = { __typename: 'DecimalQuantity' };

type ReducedBusDetails_DisconnectingCircuitBreaker_Fragment = { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Disconnector_Fragment = { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Displacement_Fragment = { __typename: 'Displacement' };

type ReducedBusDetails_Duration_Fragment = { __typename: 'Duration' };

type ReducedBusDetails_Editor_Fragment = { __typename: 'Editor', id: string, name: string };

type ReducedBusDetails_ElectronicAddress_Fragment = { __typename: 'ElectronicAddress' };

type ReducedBusDetails_Emission_Fragment = { __typename: 'Emission' };

type ReducedBusDetails_EmissionAccount_Fragment = { __typename: 'EmissionAccount', id: string, name: string };

type ReducedBusDetails_EmissionCurve_Fragment = { __typename: 'EmissionCurve', id: string, name: string };

type ReducedBusDetails_EmissionType_Fragment = { __typename: 'EmissionType' };

type ReducedBusDetails_EmissionValueSource_Fragment = { __typename: 'EmissionValueSource' };

type ReducedBusDetails_EnergyConsumer_Fragment = { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_EnergyConsumerPhase_Fragment = { __typename: 'EnergyConsumerPhase', id: string, name: string };

type ReducedBusDetails_EnergySchedulingType_Fragment = { __typename: 'EnergySchedulingType', id: string, name: string };

type ReducedBusDetails_EnergySource_Fragment = { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_EnergySourcePhase_Fragment = { __typename: 'EnergySourcePhase', id: string, name: string };

type ReducedBusDetails_EquivalentBranch_Fragment = { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_EquivalentInjection_Fragment = { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_EquivalentNetwork_Fragment = { __typename: 'EquivalentNetwork', id: string, name: string };

type ReducedBusDetails_EquivalentShunt_Fragment = { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_ExtensionItem_Fragment = { __typename: 'ExtensionItem' };

type ReducedBusDetails_ExtensionsList_Fragment = { __typename: 'ExtensionsList' };

type ReducedBusDetails_ExternalNetworkInjection_Fragment = { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Feeder_Fragment = { __typename: 'Feeder', id: string, name: string };

type ReducedBusDetails_FieldDispatchHistory_Fragment = { __typename: 'FieldDispatchHistory', id: string, name: string };

type ReducedBusDetails_FieldDispatchStep_Fragment = { __typename: 'FieldDispatchStep' };

type ReducedBusDetails_FloatQuantity_Fragment = { __typename: 'FloatQuantity' };

type ReducedBusDetails_FossilFuel_Fragment = { __typename: 'FossilFuel', id: string, name: string };

type ReducedBusDetails_Frequency_Fragment = { __typename: 'Frequency' };

type ReducedBusDetails_FrequencyConverter_Fragment = { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_FuelAllocationSchedule_Fragment = { __typename: 'FuelAllocationSchedule', id: string, name: string };

type ReducedBusDetails_FuelType_Fragment = { __typename: 'FuelType' };

type ReducedBusDetails_Fuse_Fragment = { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_GenUnitOpCostCurve_Fragment = { __typename: 'GenUnitOpCostCurve', id: string, name: string };

type ReducedBusDetails_GenUnitOpSchedule_Fragment = { __typename: 'GenUnitOpSchedule', id: string, name: string };

type ReducedBusDetails_GeneratorControlMode_Fragment = { __typename: 'GeneratorControlMode' };

type ReducedBusDetails_GeneratorControlSource_Fragment = { __typename: 'GeneratorControlSource' };

type ReducedBusDetails_GeographicalRegion_Fragment = { __typename: 'GeographicalRegion', id: string, name: string };

type ReducedBusDetails_GrossToNetActivePowerCurve_Fragment = { __typename: 'GrossToNetActivePowerCurve', id: string, name: string };

type ReducedBusDetails_Ground_Fragment = { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_GroundDisconnector_Fragment = { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_GroundingImpedance_Fragment = { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Hazard_Fragment = { __typename: 'Hazard', id: string, name: string };

type ReducedBusDetails_HeatInputCurve_Fragment = { __typename: 'HeatInputCurve', id: string, name: string };

type ReducedBusDetails_HeatRate_Fragment = { __typename: 'HeatRate' };

type ReducedBusDetails_HeatRateCurve_Fragment = { __typename: 'HeatRateCurve', id: string, name: string };

type ReducedBusDetails_Hours_Fragment = { __typename: 'Hours' };

type ReducedBusDetails_HydroEnergyConversionKind_Fragment = { __typename: 'HydroEnergyConversionKind' };

type ReducedBusDetails_HydroGeneratingEfficiencyCurve_Fragment = { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string };

type ReducedBusDetails_HydroGeneratingUnit_Fragment = { __typename: 'HydroGeneratingUnit', id: string, name: string };

type ReducedBusDetails_HydroPlantStorageKind_Fragment = { __typename: 'HydroPlantStorageKind' };

type ReducedBusDetails_HydroPowerPlant_Fragment = { __typename: 'HydroPowerPlant', id: string, name: string };

type ReducedBusDetails_HydroPump_Fragment = { __typename: 'HydroPump', id: string, name: string };

type ReducedBusDetails_HydroPumpOpSchedule_Fragment = { __typename: 'HydroPumpOpSchedule', id: string, name: string };

type ReducedBusDetails_Impedance_Fragment = { __typename: 'Impedance' };

type ReducedBusDetails_IncrementalHeatRateCurve_Fragment = { __typename: 'IncrementalHeatRateCurve', id: string, name: string };

type ReducedBusDetails_Inductance_Fragment = { __typename: 'Inductance' };

type ReducedBusDetails_InductancePerLength_Fragment = { __typename: 'InductancePerLength' };

type ReducedBusDetails_InflowForecast_Fragment = { __typename: 'InflowForecast', id: string, name: string };

type ReducedBusDetails_IntegerQuantity_Fragment = { __typename: 'IntegerQuantity' };

type ReducedBusDetails_InterrupterUnitInfo_Fragment = { __typename: 'InterrupterUnitInfo', id: string, name: string };

type ReducedBusDetails_InterruptingMediumKind_Fragment = { __typename: 'InterruptingMediumKind' };

type ReducedBusDetails_IrregularIntervalSchedule_Fragment = { __typename: 'IrregularIntervalSchedule', id: string, name: string };

type ReducedBusDetails_IrregularTimePoint_Fragment = { __typename: 'IrregularTimePoint' };

type ReducedBusDetails_Issuer_Fragment = { __typename: 'Issuer', id: string, name: string };

type ReducedBusDetails_Jumper_Fragment = { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Junction_Fragment = { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_KiloActivePower_Fragment = { __typename: 'KiloActivePower' };

type ReducedBusDetails_Length_Fragment = { __typename: 'Length' };

type ReducedBusDetails_LevelVsVolumeCurve_Fragment = { __typename: 'LevelVsVolumeCurve', id: string, name: string };

type ReducedBusDetails_Line_Fragment = { __typename: 'Line', id: string, name: string };

type ReducedBusDetails_LinearShuntCompensator_Fragment = { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_LinearShuntCompensatorPhase_Fragment = { __typename: 'LinearShuntCompensatorPhase', id: string, name: string };

type ReducedBusDetails_LoadBreakSwitch_Fragment = { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Location_Fragment = { __typename: 'Location', id: string, name: string };

type ReducedBusDetails_Mass_Fragment = { __typename: 'Mass' };

type ReducedBusDetails_Minutes_Fragment = { __typename: 'Minutes' };

type ReducedBusDetails_Money_Fragment = { __typename: 'Money' };

type ReducedBusDetails_MonthDay_Fragment = { __typename: 'MonthDay' };

type ReducedBusDetails_MonthDayInterval_Fragment = { __typename: 'MonthDayInterval' };

type ReducedBusDetails_MutualCoupling_Fragment = { __typename: 'MutualCoupling', id: string, name: string };

type ReducedBusDetails_Name_Fragment = { __typename: 'Name' };

type ReducedBusDetails_NameType_Fragment = { __typename: 'NameType' };

type ReducedBusDetails_NameTypeAuthority_Fragment = { __typename: 'NameTypeAuthority' };

type ReducedBusDetails_NoLoadTest_Fragment = { __typename: 'NoLoadTest', id: string, name: string };

type ReducedBusDetails_NonlinearShuntCompensator_Fragment = { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_NonlinearShuntCompensatorPhase_Fragment = { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string };

type ReducedBusDetails_NonlinearShuntCompensatorPhasePoint_Fragment = { __typename: 'NonlinearShuntCompensatorPhasePoint' };

type ReducedBusDetails_NonlinearShuntCompensatorPoint_Fragment = { __typename: 'NonlinearShuntCompensatorPoint' };

type ReducedBusDetails_NuclearGeneratingUnit_Fragment = { __typename: 'NuclearGeneratingUnit', id: string, name: string };

type ReducedBusDetails_OpenCircuitTest_Fragment = { __typename: 'OpenCircuitTest', id: string, name: string };

type ReducedBusDetails_OperatingMechanismInfo_Fragment = { __typename: 'OperatingMechanismInfo', id: string, name: string };

type ReducedBusDetails_OperatingMechanismKind_Fragment = { __typename: 'OperatingMechanismKind' };

type ReducedBusDetails_OperatingParticipant_Fragment = { __typename: 'OperatingParticipant', id: string, name: string };

type ReducedBusDetails_OperatingShare_Fragment = { __typename: 'OperatingShare' };

type ReducedBusDetails_OperationalLimitDirectionKind_Fragment = { __typename: 'OperationalLimitDirectionKind' };

type ReducedBusDetails_OperationalLimitSet_Fragment = { __typename: 'OperationalLimitSet', id: string, name: string };

type ReducedBusDetails_OperationalLimitType_Fragment = { __typename: 'OperationalLimitType', id: string, name: string };

type ReducedBusDetails_Operator_Fragment = { __typename: 'Operator', id: string, name: string };

type ReducedBusDetails_OrganisationRole_Fragment = { __typename: 'OrganisationRole', id: string, name: string };

type ReducedBusDetails_OverheadWireInfo_Fragment = { __typename: 'OverheadWireInfo', id: string, name: string };

type ReducedBusDetails_Ownership_Fragment = { __typename: 'Ownership', id: string, name: string };

type ReducedBusDetails_PsrType_Fragment = { __typename: 'PSRType', id: string, name: string };

type ReducedBusDetails_Pu_Fragment = { __typename: 'PU' };

type ReducedBusDetails_ParentOrganization_Fragment = { __typename: 'ParentOrganization', id: string, name: string };

type ReducedBusDetails_PenstockLossCurve_Fragment = { __typename: 'PenstockLossCurve', id: string, name: string };

type ReducedBusDetails_PerCent_Fragment = { __typename: 'PerCent' };

type ReducedBusDetails_PerLengthPhaseImpedance_Fragment = { __typename: 'PerLengthPhaseImpedance', id: string, name: string };

type ReducedBusDetails_PerLengthSequenceImpedance_Fragment = { __typename: 'PerLengthSequenceImpedance', id: string, name: string };

type ReducedBusDetails_Person_Fragment = { __typename: 'Person', id: string, name: string };

type ReducedBusDetails_PetersenCoil_Fragment = { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_PetersenCoilModeKind_Fragment = { __typename: 'PetersenCoilModeKind' };

type ReducedBusDetails_PhaseCode_Fragment = { __typename: 'PhaseCode' };

type ReducedBusDetails_PhaseImpedanceData_Fragment = { __typename: 'PhaseImpedanceData' };

type ReducedBusDetails_PhaseShuntConnectionKind_Fragment = { __typename: 'PhaseShuntConnectionKind' };

type ReducedBusDetails_PhaseTapChangerAsymmetrical_Fragment = { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string };

type ReducedBusDetails_PhaseTapChangerLinear_Fragment = { __typename: 'PhaseTapChangerLinear', id: string, name: string };

type ReducedBusDetails_PhaseTapChangerSymmetrical_Fragment = { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string };

type ReducedBusDetails_PhaseTapChangerTable_Fragment = { __typename: 'PhaseTapChangerTable', id: string, name: string };

type ReducedBusDetails_PhaseTapChangerTablePoint_Fragment = { __typename: 'PhaseTapChangerTablePoint' };

type ReducedBusDetails_PhaseTapChangerTabular_Fragment = { __typename: 'PhaseTapChangerTabular', id: string, name: string };

type ReducedBusDetails_PhotoVoltaicUnit_Fragment = { __typename: 'PhotoVoltaicUnit', id: string, name: string };

type ReducedBusDetails_Plant_Fragment = { __typename: 'Plant', id: string, name: string };

type ReducedBusDetails_PositionPoint_Fragment = { __typename: 'PositionPoint' };

type ReducedBusDetails_PowerElectronicsConnection_Fragment = { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_PowerElectronicsConnectionPhase_Fragment = { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string };

type ReducedBusDetails_PowerElectronicsWindUnit_Fragment = { __typename: 'PowerElectronicsWindUnit', id: string, name: string };

type ReducedBusDetails_PowerTransformer_Fragment = { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_PowerTransformerEnd_Fragment = { __typename: 'PowerTransformerEnd', id: string, name: string };

type ReducedBusDetails_PowerTransformerInfo_Fragment = { __typename: 'PowerTransformerInfo', id: string, name: string };

type ReducedBusDetails_Pressure_Fragment = { __typename: 'Pressure' };

type ReducedBusDetails_Priority_Fragment = { __typename: 'Priority' };

type ReducedBusDetails_RatioTapChanger_Fragment = { __typename: 'RatioTapChanger', id: string, name: string };

type ReducedBusDetails_RatioTapChangerTable_Fragment = { __typename: 'RatioTapChangerTable', id: string, name: string };

type ReducedBusDetails_RatioTapChangerTablePoint_Fragment = { __typename: 'RatioTapChangerTablePoint' };

type ReducedBusDetails_Reactance_Fragment = { __typename: 'Reactance' };

type ReducedBusDetails_ReactancePerLength_Fragment = { __typename: 'ReactancePerLength' };

type ReducedBusDetails_ReactiveCapabilityCurve_Fragment = { __typename: 'ReactiveCapabilityCurve', id: string, name: string };

type ReducedBusDetails_ReactivePower_Fragment = { __typename: 'ReactivePower' };

type ReducedBusDetails_RealEnergy_Fragment = { __typename: 'RealEnergy' };

type ReducedBusDetails_Recloser_Fragment = { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_RegularTimePoint_Fragment = { __typename: 'RegularTimePoint' };

type ReducedBusDetails_RegulatingControlModeKind_Fragment = { __typename: 'RegulatingControlModeKind' };

type ReducedBusDetails_RegulationSchedule_Fragment = { __typename: 'RegulationSchedule', id: string, name: string };

type ReducedBusDetails_ReportingGroup_Fragment = { __typename: 'ReportingGroup', id: string, name: string };

type ReducedBusDetails_ReportingSuperGroup_Fragment = { __typename: 'ReportingSuperGroup', id: string, name: string };

type ReducedBusDetails_Reservoir_Fragment = { __typename: 'Reservoir', id: string, name: string };

type ReducedBusDetails_Resistance_Fragment = { __typename: 'Resistance' };

type ReducedBusDetails_ResistancePerLength_Fragment = { __typename: 'ResistancePerLength' };

type ReducedBusDetails_RotationSpeed_Fragment = { __typename: 'RotationSpeed' };

type ReducedBusDetails_SvcControlMode_Fragment = { __typename: 'SVCControlMode' };

type ReducedBusDetails_ScheduledEvent_Fragment = { __typename: 'ScheduledEvent', id: string, name: string };

type ReducedBusDetails_ScheduledEventData_Fragment = { __typename: 'ScheduledEventData' };

type ReducedBusDetails_Seconds_Fragment = { __typename: 'Seconds' };

type ReducedBusDetails_Sectionaliser_Fragment = { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_SeriesCompensator_Fragment = { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_ShortCircuitRotorKind_Fragment = { __typename: 'ShortCircuitRotorKind' };

type ReducedBusDetails_ShortCircuitTest_Fragment = { __typename: 'ShortCircuitTest', id: string, name: string };

type ReducedBusDetails_ShuntCompensatorInfo_Fragment = { __typename: 'ShuntCompensatorInfo', id: string, name: string };

type ReducedBusDetails_ShutdownCurve_Fragment = { __typename: 'ShutdownCurve', id: string, name: string };

type ReducedBusDetails_SinglePhaseKind_Fragment = { __typename: 'SinglePhaseKind' };

type ReducedBusDetails_SolarGeneratingUnit_Fragment = { __typename: 'SolarGeneratingUnit', id: string, name: string };

type ReducedBusDetails_Speed_Fragment = { __typename: 'Speed' };

type ReducedBusDetails_StartIgnFuelCurve_Fragment = { __typename: 'StartIgnFuelCurve', id: string, name: string };

type ReducedBusDetails_StartMainFuelCurve_Fragment = { __typename: 'StartMainFuelCurve', id: string, name: string };

type ReducedBusDetails_StartRampCurve_Fragment = { __typename: 'StartRampCurve', id: string, name: string };

type ReducedBusDetails_StartupModel_Fragment = { __typename: 'StartupModel', id: string, name: string };

type ReducedBusDetails_StaticVarCompensator_Fragment = { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_Status_Fragment = { __typename: 'Status' };

type ReducedBusDetails_SteamSendoutSchedule_Fragment = { __typename: 'SteamSendoutSchedule', id: string, name: string };

type ReducedBusDetails_StreetAddress_Fragment = { __typename: 'StreetAddress' };

type ReducedBusDetails_StreetDetail_Fragment = { __typename: 'StreetDetail' };

type ReducedBusDetails_StringQuantity_Fragment = { __typename: 'StringQuantity' };

type ReducedBusDetails_SubGeographicalRegion_Fragment = { __typename: 'SubGeographicalRegion', id: string, name: string };

type ReducedBusDetails_Substation_Fragment = { __typename: 'Substation', id: string, name: string };

type ReducedBusDetails_Susceptance_Fragment = { __typename: 'Susceptance' };

type ReducedBusDetails_SusceptancePerLength_Fragment = { __typename: 'SusceptancePerLength' };

type ReducedBusDetails_SwitchInfo_Fragment = { __typename: 'SwitchInfo', id: string, name: string };

type ReducedBusDetails_SwitchPhase_Fragment = { __typename: 'SwitchPhase', id: string, name: string };

type ReducedBusDetails_SwitchSchedule_Fragment = { __typename: 'SwitchSchedule', id: string, name: string };

type ReducedBusDetails_SynchronousMachine_Fragment = { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_SynchronousMachineKind_Fragment = { __typename: 'SynchronousMachineKind' };

type ReducedBusDetails_SynchronousMachineOperatingMode_Fragment = { __typename: 'SynchronousMachineOperatingMode' };

type ReducedBusDetails_TailbayLossCurve_Fragment = { __typename: 'TailbayLossCurve', id: string, name: string };

type ReducedBusDetails_TapChangerControl_Fragment = { __typename: 'TapChangerControl', id: string, name: string };

type ReducedBusDetails_TapChangerInfo_Fragment = { __typename: 'TapChangerInfo', id: string, name: string };

type ReducedBusDetails_TapSchedule_Fragment = { __typename: 'TapSchedule', id: string, name: string };

type ReducedBusDetails_TapeShieldCableInfo_Fragment = { __typename: 'TapeShieldCableInfo', id: string, name: string };

type ReducedBusDetails_TargetLevelSchedule_Fragment = { __typename: 'TargetLevelSchedule', id: string, name: string };

type ReducedBusDetails_TelephoneNumber_Fragment = { __typename: 'TelephoneNumber' };

type ReducedBusDetails_Temperature_Fragment = { __typename: 'Temperature' };

type ReducedBusDetails_Terminal_Fragment = { __typename: 'Terminal', id: string, name: string };

type ReducedBusDetails_ThermalGeneratingUnit_Fragment = { __typename: 'ThermalGeneratingUnit', id: string, name: string };

type ReducedBusDetails_Time_Fragment = { __typename: 'Time' };

type ReducedBusDetails_TimeInterval_Fragment = { __typename: 'TimeInterval' };

type ReducedBusDetails_TimePoint_Fragment = { __typename: 'TimePoint', id: string, name: string };

type ReducedBusDetails_TimeSchedule_Fragment = { __typename: 'TimeSchedule', id: string, name: string };

type ReducedBusDetails_TopologicalIsland_Fragment = { __typename: 'TopologicalIsland', id: string, name: string };

type ReducedBusDetails_TopologicalNode_Fragment = { __typename: 'TopologicalNode', id: string, name: string };

type ReducedBusDetails_TownDetail_Fragment = { __typename: 'TownDetail' };

type ReducedBusDetails_TransformerControlMode_Fragment = { __typename: 'TransformerControlMode' };

type ReducedBusDetails_TransformerCoreAdmittance_Fragment = { __typename: 'TransformerCoreAdmittance', id: string, name: string };

type ReducedBusDetails_TransformerEndInfo_Fragment = { __typename: 'TransformerEndInfo', id: string, name: string };

type ReducedBusDetails_TransformerMeshImpedance_Fragment = { __typename: 'TransformerMeshImpedance', id: string, name: string };

type ReducedBusDetails_TransformerStarImpedance_Fragment = { __typename: 'TransformerStarImpedance', id: string, name: string };

type ReducedBusDetails_TransformerTank_Fragment = { __typename: 'TransformerTank', id: string, name: string };

type ReducedBusDetails_TransformerTankEnd_Fragment = { __typename: 'TransformerTankEnd', id: string, name: string };

type ReducedBusDetails_TransformerTankInfo_Fragment = { __typename: 'TransformerTankInfo', id: string, name: string };

type ReducedBusDetails_UnitMultiplier_Fragment = { __typename: 'UnitMultiplier' };

type ReducedBusDetails_UnitSymbol_Fragment = { __typename: 'UnitSymbol' };

type ReducedBusDetails_UserAttribute_Fragment = { __typename: 'UserAttribute' };

type ReducedBusDetails_Version_Fragment = { __typename: 'Version' };

type ReducedBusDetails_Voltage_Fragment = { __typename: 'Voltage' };

type ReducedBusDetails_VoltageControlZone_Fragment = { __typename: 'VoltageControlZone', id: string, name: string };

type ReducedBusDetails_VoltageLevel_Fragment = { __typename: 'VoltageLevel', id: string, name: string };

type ReducedBusDetails_VoltageLimit_Fragment = { __typename: 'VoltageLimit', id: string, name: string };

type ReducedBusDetails_VoltagePerReactivePower_Fragment = { __typename: 'VoltagePerReactivePower' };

type ReducedBusDetails_Volume_Fragment = { __typename: 'Volume' };

type ReducedBusDetails_VolumeFlowRate_Fragment = { __typename: 'VolumeFlowRate' };

type ReducedBusDetails_WaterLevel_Fragment = { __typename: 'WaterLevel' };

type ReducedBusDetails_WindGenUnitKind_Fragment = { __typename: 'WindGenUnitKind' };

type ReducedBusDetails_WindGeneratingUnit_Fragment = { __typename: 'WindGeneratingUnit', id: string, name: string };

type ReducedBusDetails_WindingConnection_Fragment = { __typename: 'WindingConnection' };

type ReducedBusDetails_WireAssemblyInfo_Fragment = { __typename: 'WireAssemblyInfo', id: string, name: string };

type ReducedBusDetails_WireInsulationKind_Fragment = { __typename: 'WireInsulationKind' };

type ReducedBusDetails_WireMaterialKind_Fragment = { __typename: 'WireMaterialKind' };

type ReducedBusDetails_WirePhaseInfo_Fragment = { __typename: 'WirePhaseInfo' };

type ReducedBusDetails_WirePosition_Fragment = { __typename: 'WirePosition', id: string, name: string };

type ReducedBusDetails_WireSegment_Fragment = { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } };

type ReducedBusDetails_WireSegmentPhase_Fragment = { __typename: 'WireSegmentPhase', id: string, name: string };

type ReducedBusDetails_WireSpacingInfo_Fragment = { __typename: 'WireSpacingInfo', id: string, name: string };

type ReducedBusDetails_WireUsageKind_Fragment = { __typename: 'WireUsageKind' };

export type ReducedBusDetailsFragment =
  | ReducedBusDetails_AcLineSegment_Fragment
  | ReducedBusDetails_AcLineSegmentPhase_Fragment
  | ReducedBusDetails_ActivePower_Fragment
  | ReducedBusDetails_ActivePowerChangeRate_Fragment
  | ReducedBusDetails_ActivePowerLimit_Fragment
  | ReducedBusDetails_ActivePowerPerCurrentFlow_Fragment
  | ReducedBusDetails_ActivePowerPerFrequency_Fragment
  | ReducedBusDetails_Admittance_Fragment
  | ReducedBusDetails_Agreement_Fragment
  | ReducedBusDetails_AirCompressor_Fragment
  | ReducedBusDetails_AngleDegrees_Fragment
  | ReducedBusDetails_AngleRadians_Fragment
  | ReducedBusDetails_ApparentPower_Fragment
  | ReducedBusDetails_ApparentPowerLimit_Fragment
  | ReducedBusDetails_Appointment_Fragment
  | ReducedBusDetails_Approver_Fragment
  | ReducedBusDetails_Area_Fragment
  | ReducedBusDetails_AsynchronousMachine_Fragment
  | ReducedBusDetails_AsynchronousMachineKind_Fragment
  | ReducedBusDetails_Author_Fragment
  | ReducedBusDetails_BaseFrequency_Fragment
  | ReducedBusDetails_BasePower_Fragment
  | ReducedBusDetails_BaseVoltage_Fragment
  | ReducedBusDetails_BatteryStateKind_Fragment
  | ReducedBusDetails_BatteryUnit_Fragment
  | ReducedBusDetails_Bay_Fragment
  | ReducedBusDetails_BranchGroup_Fragment
  | ReducedBusDetails_BranchGroupTerminal_Fragment
  | ReducedBusDetails_BreakerConfiguration_Fragment
  | ReducedBusDetails_BusNameMarker_Fragment
  | ReducedBusDetails_BusbarConfiguration_Fragment
  | ReducedBusDetails_BusbarSection_Fragment
  | ReducedBusDetails_BusbarSectionInfo_Fragment
  | ReducedBusDetails_BushingInfo_Fragment
  | ReducedBusDetails_BushingInsulationKind_Fragment
  | ReducedBusDetails_CaesPlant_Fragment
  | ReducedBusDetails_CableConstructionKind_Fragment
  | ReducedBusDetails_CableOuterJacketKind_Fragment
  | ReducedBusDetails_CableShieldMaterialKind_Fragment
  | ReducedBusDetails_Capacitance_Fragment
  | ReducedBusDetails_CapacitancePerLength_Fragment
  | ReducedBusDetails_Clamp_Fragment
  | ReducedBusDetails_Classification_Fragment
  | ReducedBusDetails_CogenerationPlant_Fragment
  | ReducedBusDetails_CombinedCyclePlant_Fragment
  | ReducedBusDetails_CompositeSwitch_Fragment
  | ReducedBusDetails_ConcentricNeutralCableInfo_Fragment
  | ReducedBusDetails_Conductance_Fragment
  | ReducedBusDetails_ConductancePerLength_Fragment
  | ReducedBusDetails_ConfigurationEvent_Fragment
  | ReducedBusDetails_ConnectivityNode_Fragment
  | ReducedBusDetails_CoolantType_Fragment
  | ReducedBusDetails_CoordinateSystem_Fragment
  | ReducedBusDetails_CostPerEnergyUnit_Fragment
  | ReducedBusDetails_CostPerHeatUnit_Fragment
  | ReducedBusDetails_CostPerVolume_Fragment
  | ReducedBusDetails_CostRate_Fragment
  | ReducedBusDetails_Crew_Fragment
  | ReducedBusDetails_CrewMember_Fragment
  | ReducedBusDetails_CrewStatusKind_Fragment
  | ReducedBusDetails_CrewType_Fragment
  | ReducedBusDetails_Currency_Fragment
  | ReducedBusDetails_CurrentFlow_Fragment
  | ReducedBusDetails_CurrentLimit_Fragment
  | ReducedBusDetails_CurveData_Fragment
  | ReducedBusDetails_CurveStyle_Fragment
  | ReducedBusDetails_Cut_Fragment
  | ReducedBusDetails_Damping_Fragment
  | ReducedBusDetails_Date_Fragment
  | ReducedBusDetails_DateInterval_Fragment
  | ReducedBusDetails_DateTime_Fragment
  | ReducedBusDetails_DateTimeInterval_Fragment
  | ReducedBusDetails_DecimalQuantity_Fragment
  | ReducedBusDetails_DisconnectingCircuitBreaker_Fragment
  | ReducedBusDetails_Disconnector_Fragment
  | ReducedBusDetails_Displacement_Fragment
  | ReducedBusDetails_Duration_Fragment
  | ReducedBusDetails_Editor_Fragment
  | ReducedBusDetails_ElectronicAddress_Fragment
  | ReducedBusDetails_Emission_Fragment
  | ReducedBusDetails_EmissionAccount_Fragment
  | ReducedBusDetails_EmissionCurve_Fragment
  | ReducedBusDetails_EmissionType_Fragment
  | ReducedBusDetails_EmissionValueSource_Fragment
  | ReducedBusDetails_EnergyConsumer_Fragment
  | ReducedBusDetails_EnergyConsumerPhase_Fragment
  | ReducedBusDetails_EnergySchedulingType_Fragment
  | ReducedBusDetails_EnergySource_Fragment
  | ReducedBusDetails_EnergySourcePhase_Fragment
  | ReducedBusDetails_EquivalentBranch_Fragment
  | ReducedBusDetails_EquivalentInjection_Fragment
  | ReducedBusDetails_EquivalentNetwork_Fragment
  | ReducedBusDetails_EquivalentShunt_Fragment
  | ReducedBusDetails_ExtensionItem_Fragment
  | ReducedBusDetails_ExtensionsList_Fragment
  | ReducedBusDetails_ExternalNetworkInjection_Fragment
  | ReducedBusDetails_Feeder_Fragment
  | ReducedBusDetails_FieldDispatchHistory_Fragment
  | ReducedBusDetails_FieldDispatchStep_Fragment
  | ReducedBusDetails_FloatQuantity_Fragment
  | ReducedBusDetails_FossilFuel_Fragment
  | ReducedBusDetails_Frequency_Fragment
  | ReducedBusDetails_FrequencyConverter_Fragment
  | ReducedBusDetails_FuelAllocationSchedule_Fragment
  | ReducedBusDetails_FuelType_Fragment
  | ReducedBusDetails_Fuse_Fragment
  | ReducedBusDetails_GenUnitOpCostCurve_Fragment
  | ReducedBusDetails_GenUnitOpSchedule_Fragment
  | ReducedBusDetails_GeneratorControlMode_Fragment
  | ReducedBusDetails_GeneratorControlSource_Fragment
  | ReducedBusDetails_GeographicalRegion_Fragment
  | ReducedBusDetails_GrossToNetActivePowerCurve_Fragment
  | ReducedBusDetails_Ground_Fragment
  | ReducedBusDetails_GroundDisconnector_Fragment
  | ReducedBusDetails_GroundingImpedance_Fragment
  | ReducedBusDetails_Hazard_Fragment
  | ReducedBusDetails_HeatInputCurve_Fragment
  | ReducedBusDetails_HeatRate_Fragment
  | ReducedBusDetails_HeatRateCurve_Fragment
  | ReducedBusDetails_Hours_Fragment
  | ReducedBusDetails_HydroEnergyConversionKind_Fragment
  | ReducedBusDetails_HydroGeneratingEfficiencyCurve_Fragment
  | ReducedBusDetails_HydroGeneratingUnit_Fragment
  | ReducedBusDetails_HydroPlantStorageKind_Fragment
  | ReducedBusDetails_HydroPowerPlant_Fragment
  | ReducedBusDetails_HydroPump_Fragment
  | ReducedBusDetails_HydroPumpOpSchedule_Fragment
  | ReducedBusDetails_Impedance_Fragment
  | ReducedBusDetails_IncrementalHeatRateCurve_Fragment
  | ReducedBusDetails_Inductance_Fragment
  | ReducedBusDetails_InductancePerLength_Fragment
  | ReducedBusDetails_InflowForecast_Fragment
  | ReducedBusDetails_IntegerQuantity_Fragment
  | ReducedBusDetails_InterrupterUnitInfo_Fragment
  | ReducedBusDetails_InterruptingMediumKind_Fragment
  | ReducedBusDetails_IrregularIntervalSchedule_Fragment
  | ReducedBusDetails_IrregularTimePoint_Fragment
  | ReducedBusDetails_Issuer_Fragment
  | ReducedBusDetails_Jumper_Fragment
  | ReducedBusDetails_Junction_Fragment
  | ReducedBusDetails_KiloActivePower_Fragment
  | ReducedBusDetails_Length_Fragment
  | ReducedBusDetails_LevelVsVolumeCurve_Fragment
  | ReducedBusDetails_Line_Fragment
  | ReducedBusDetails_LinearShuntCompensator_Fragment
  | ReducedBusDetails_LinearShuntCompensatorPhase_Fragment
  | ReducedBusDetails_LoadBreakSwitch_Fragment
  | ReducedBusDetails_Location_Fragment
  | ReducedBusDetails_Mass_Fragment
  | ReducedBusDetails_Minutes_Fragment
  | ReducedBusDetails_Money_Fragment
  | ReducedBusDetails_MonthDay_Fragment
  | ReducedBusDetails_MonthDayInterval_Fragment
  | ReducedBusDetails_MutualCoupling_Fragment
  | ReducedBusDetails_Name_Fragment
  | ReducedBusDetails_NameType_Fragment
  | ReducedBusDetails_NameTypeAuthority_Fragment
  | ReducedBusDetails_NoLoadTest_Fragment
  | ReducedBusDetails_NonlinearShuntCompensator_Fragment
  | ReducedBusDetails_NonlinearShuntCompensatorPhase_Fragment
  | ReducedBusDetails_NonlinearShuntCompensatorPhasePoint_Fragment
  | ReducedBusDetails_NonlinearShuntCompensatorPoint_Fragment
  | ReducedBusDetails_NuclearGeneratingUnit_Fragment
  | ReducedBusDetails_OpenCircuitTest_Fragment
  | ReducedBusDetails_OperatingMechanismInfo_Fragment
  | ReducedBusDetails_OperatingMechanismKind_Fragment
  | ReducedBusDetails_OperatingParticipant_Fragment
  | ReducedBusDetails_OperatingShare_Fragment
  | ReducedBusDetails_OperationalLimitDirectionKind_Fragment
  | ReducedBusDetails_OperationalLimitSet_Fragment
  | ReducedBusDetails_OperationalLimitType_Fragment
  | ReducedBusDetails_Operator_Fragment
  | ReducedBusDetails_OrganisationRole_Fragment
  | ReducedBusDetails_OverheadWireInfo_Fragment
  | ReducedBusDetails_Ownership_Fragment
  | ReducedBusDetails_PsrType_Fragment
  | ReducedBusDetails_Pu_Fragment
  | ReducedBusDetails_ParentOrganization_Fragment
  | ReducedBusDetails_PenstockLossCurve_Fragment
  | ReducedBusDetails_PerCent_Fragment
  | ReducedBusDetails_PerLengthPhaseImpedance_Fragment
  | ReducedBusDetails_PerLengthSequenceImpedance_Fragment
  | ReducedBusDetails_Person_Fragment
  | ReducedBusDetails_PetersenCoil_Fragment
  | ReducedBusDetails_PetersenCoilModeKind_Fragment
  | ReducedBusDetails_PhaseCode_Fragment
  | ReducedBusDetails_PhaseImpedanceData_Fragment
  | ReducedBusDetails_PhaseShuntConnectionKind_Fragment
  | ReducedBusDetails_PhaseTapChangerAsymmetrical_Fragment
  | ReducedBusDetails_PhaseTapChangerLinear_Fragment
  | ReducedBusDetails_PhaseTapChangerSymmetrical_Fragment
  | ReducedBusDetails_PhaseTapChangerTable_Fragment
  | ReducedBusDetails_PhaseTapChangerTablePoint_Fragment
  | ReducedBusDetails_PhaseTapChangerTabular_Fragment
  | ReducedBusDetails_PhotoVoltaicUnit_Fragment
  | ReducedBusDetails_Plant_Fragment
  | ReducedBusDetails_PositionPoint_Fragment
  | ReducedBusDetails_PowerElectronicsConnection_Fragment
  | ReducedBusDetails_PowerElectronicsConnectionPhase_Fragment
  | ReducedBusDetails_PowerElectronicsWindUnit_Fragment
  | ReducedBusDetails_PowerTransformer_Fragment
  | ReducedBusDetails_PowerTransformerEnd_Fragment
  | ReducedBusDetails_PowerTransformerInfo_Fragment
  | ReducedBusDetails_Pressure_Fragment
  | ReducedBusDetails_Priority_Fragment
  | ReducedBusDetails_RatioTapChanger_Fragment
  | ReducedBusDetails_RatioTapChangerTable_Fragment
  | ReducedBusDetails_RatioTapChangerTablePoint_Fragment
  | ReducedBusDetails_Reactance_Fragment
  | ReducedBusDetails_ReactancePerLength_Fragment
  | ReducedBusDetails_ReactiveCapabilityCurve_Fragment
  | ReducedBusDetails_ReactivePower_Fragment
  | ReducedBusDetails_RealEnergy_Fragment
  | ReducedBusDetails_Recloser_Fragment
  | ReducedBusDetails_RegularTimePoint_Fragment
  | ReducedBusDetails_RegulatingControlModeKind_Fragment
  | ReducedBusDetails_RegulationSchedule_Fragment
  | ReducedBusDetails_ReportingGroup_Fragment
  | ReducedBusDetails_ReportingSuperGroup_Fragment
  | ReducedBusDetails_Reservoir_Fragment
  | ReducedBusDetails_Resistance_Fragment
  | ReducedBusDetails_ResistancePerLength_Fragment
  | ReducedBusDetails_RotationSpeed_Fragment
  | ReducedBusDetails_SvcControlMode_Fragment
  | ReducedBusDetails_ScheduledEvent_Fragment
  | ReducedBusDetails_ScheduledEventData_Fragment
  | ReducedBusDetails_Seconds_Fragment
  | ReducedBusDetails_Sectionaliser_Fragment
  | ReducedBusDetails_SeriesCompensator_Fragment
  | ReducedBusDetails_ShortCircuitRotorKind_Fragment
  | ReducedBusDetails_ShortCircuitTest_Fragment
  | ReducedBusDetails_ShuntCompensatorInfo_Fragment
  | ReducedBusDetails_ShutdownCurve_Fragment
  | ReducedBusDetails_SinglePhaseKind_Fragment
  | ReducedBusDetails_SolarGeneratingUnit_Fragment
  | ReducedBusDetails_Speed_Fragment
  | ReducedBusDetails_StartIgnFuelCurve_Fragment
  | ReducedBusDetails_StartMainFuelCurve_Fragment
  | ReducedBusDetails_StartRampCurve_Fragment
  | ReducedBusDetails_StartupModel_Fragment
  | ReducedBusDetails_StaticVarCompensator_Fragment
  | ReducedBusDetails_Status_Fragment
  | ReducedBusDetails_SteamSendoutSchedule_Fragment
  | ReducedBusDetails_StreetAddress_Fragment
  | ReducedBusDetails_StreetDetail_Fragment
  | ReducedBusDetails_StringQuantity_Fragment
  | ReducedBusDetails_SubGeographicalRegion_Fragment
  | ReducedBusDetails_Substation_Fragment
  | ReducedBusDetails_Susceptance_Fragment
  | ReducedBusDetails_SusceptancePerLength_Fragment
  | ReducedBusDetails_SwitchInfo_Fragment
  | ReducedBusDetails_SwitchPhase_Fragment
  | ReducedBusDetails_SwitchSchedule_Fragment
  | ReducedBusDetails_SynchronousMachine_Fragment
  | ReducedBusDetails_SynchronousMachineKind_Fragment
  | ReducedBusDetails_SynchronousMachineOperatingMode_Fragment
  | ReducedBusDetails_TailbayLossCurve_Fragment
  | ReducedBusDetails_TapChangerControl_Fragment
  | ReducedBusDetails_TapChangerInfo_Fragment
  | ReducedBusDetails_TapSchedule_Fragment
  | ReducedBusDetails_TapeShieldCableInfo_Fragment
  | ReducedBusDetails_TargetLevelSchedule_Fragment
  | ReducedBusDetails_TelephoneNumber_Fragment
  | ReducedBusDetails_Temperature_Fragment
  | ReducedBusDetails_Terminal_Fragment
  | ReducedBusDetails_ThermalGeneratingUnit_Fragment
  | ReducedBusDetails_Time_Fragment
  | ReducedBusDetails_TimeInterval_Fragment
  | ReducedBusDetails_TimePoint_Fragment
  | ReducedBusDetails_TimeSchedule_Fragment
  | ReducedBusDetails_TopologicalIsland_Fragment
  | ReducedBusDetails_TopologicalNode_Fragment
  | ReducedBusDetails_TownDetail_Fragment
  | ReducedBusDetails_TransformerControlMode_Fragment
  | ReducedBusDetails_TransformerCoreAdmittance_Fragment
  | ReducedBusDetails_TransformerEndInfo_Fragment
  | ReducedBusDetails_TransformerMeshImpedance_Fragment
  | ReducedBusDetails_TransformerStarImpedance_Fragment
  | ReducedBusDetails_TransformerTank_Fragment
  | ReducedBusDetails_TransformerTankEnd_Fragment
  | ReducedBusDetails_TransformerTankInfo_Fragment
  | ReducedBusDetails_UnitMultiplier_Fragment
  | ReducedBusDetails_UnitSymbol_Fragment
  | ReducedBusDetails_UserAttribute_Fragment
  | ReducedBusDetails_Version_Fragment
  | ReducedBusDetails_Voltage_Fragment
  | ReducedBusDetails_VoltageControlZone_Fragment
  | ReducedBusDetails_VoltageLevel_Fragment
  | ReducedBusDetails_VoltageLimit_Fragment
  | ReducedBusDetails_VoltagePerReactivePower_Fragment
  | ReducedBusDetails_Volume_Fragment
  | ReducedBusDetails_VolumeFlowRate_Fragment
  | ReducedBusDetails_WaterLevel_Fragment
  | ReducedBusDetails_WindGenUnitKind_Fragment
  | ReducedBusDetails_WindGeneratingUnit_Fragment
  | ReducedBusDetails_WindingConnection_Fragment
  | ReducedBusDetails_WireAssemblyInfo_Fragment
  | ReducedBusDetails_WireInsulationKind_Fragment
  | ReducedBusDetails_WireMaterialKind_Fragment
  | ReducedBusDetails_WirePhaseInfo_Fragment
  | ReducedBusDetails_WirePosition_Fragment
  | ReducedBusDetails_WireSegment_Fragment
  | ReducedBusDetails_WireSegmentPhase_Fragment
  | ReducedBusDetails_WireSpacingInfo_Fragment
  | ReducedBusDetails_WireUsageKind_Fragment
;

export type FetchReducedBusDetailsByIdQueryVariables = Exact<{
  modelName: string;
  id: string | number;
}>;


export interface FetchReducedBusDetailsByIdQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', reducedBus: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit', id: string, name: string }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement', id: string, name: string }
      | { __typename: 'AirCompressor', id: string, name: string }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit', id: string, name: string }
      | { __typename: 'Appointment', id: string, name: string }
      | { __typename: 'Approver', id: string, name: string }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author', id: string, name: string }
      | { __typename: 'BaseFrequency', id: string, name: string }
      | { __typename: 'BasePower', id: string, name: string }
      | { __typename: 'BaseVoltage', id: string, name: string }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit', id: string, name: string }
      | { __typename: 'Bay', id: string, name: string }
      | { __typename: 'BranchGroup', id: string, name: string }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker', id: string, name: string }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'BusbarSectionInfo', id: string, name: string }
      | { __typename: 'BushingInfo', id: string, name: string }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant', id: string, name: string }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant', id: string, name: string }
      | { __typename: 'CombinedCyclePlant', id: string, name: string }
      | { __typename: 'CompositeSwitch', id: string, name: string }
      | { __typename: 'ConcentricNeutralCableInfo', id: string, name: string }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent', id: string, name: string }
      | { __typename: 'ConnectivityNode', id: string, name: string }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem', id: string, name: string }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew', id: string, name: string }
      | { __typename: 'CrewMember', id: string, name: string }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType', id: string, name: string }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit', id: string, name: string }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor', id: string, name: string }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount', id: string, name: string }
      | { __typename: 'EmissionCurve', id: string, name: string }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string }
      | { __typename: 'EnergySchedulingType', id: string, name: string }
      | { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergySourcePhase', id: string, name: string }
      | { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentNetwork', id: string, name: string }
      | { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Feeder', id: string, name: string }
      | { __typename: 'FieldDispatchHistory', id: string, name: string }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel', id: string, name: string }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'FuelAllocationSchedule', id: string, name: string }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GenUnitOpCostCurve', id: string, name: string }
      | { __typename: 'GenUnitOpSchedule', id: string, name: string }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion', id: string, name: string }
      | { __typename: 'GrossToNetActivePowerCurve', id: string, name: string }
      | { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Hazard', id: string, name: string }
      | { __typename: 'HeatInputCurve', id: string, name: string }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve', id: string, name: string }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant', id: string, name: string }
      | { __typename: 'HydroPump', id: string, name: string }
      | { __typename: 'HydroPumpOpSchedule', id: string, name: string }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve', id: string, name: string }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast', id: string, name: string }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo', id: string, name: string }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule', id: string, name: string }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer', id: string, name: string }
      | { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve', id: string, name: string }
      | { __typename: 'Line', id: string, name: string }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Location', id: string, name: string }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling', id: string, name: string }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string }
      | { __typename: 'OpenCircuitTest', id: string, name: string }
      | { __typename: 'OperatingMechanismInfo', id: string, name: string }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant', id: string, name: string }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet', id: string, name: string }
      | { __typename: 'OperationalLimitType', id: string, name: string }
      | { __typename: 'Operator', id: string, name: string }
      | { __typename: 'OrganisationRole', id: string, name: string }
      | { __typename: 'OverheadWireInfo', id: string, name: string }
      | { __typename: 'Ownership', id: string, name: string }
      | { __typename: 'PSRType', id: string, name: string }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization', id: string, name: string }
      | { __typename: 'PenstockLossCurve', id: string, name: string }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance', id: string, name: string }
      | { __typename: 'PerLengthSequenceImpedance', id: string, name: string }
      | { __typename: 'Person', id: string, name: string }
      | { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerTable', id: string, name: string }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
      | { __typename: 'Plant', id: string, name: string }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
      | { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerTransformerEnd', id: string, name: string }
      | { __typename: 'PowerTransformerInfo', id: string, name: string }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger', id: string, name: string }
      | { __typename: 'RatioTapChangerTable', id: string, name: string }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve', id: string, name: string }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule', id: string, name: string }
      | { __typename: 'ReportingGroup', id: string, name: string }
      | { __typename: 'ReportingSuperGroup', id: string, name: string }
      | { __typename: 'Reservoir', id: string, name: string }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent', id: string, name: string }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest', id: string, name: string }
      | { __typename: 'ShuntCompensatorInfo', id: string, name: string }
      | { __typename: 'ShutdownCurve', id: string, name: string }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve', id: string, name: string }
      | { __typename: 'StartMainFuelCurve', id: string, name: string }
      | { __typename: 'StartRampCurve', id: string, name: string }
      | { __typename: 'StartupModel', id: string, name: string }
      | { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule', id: string, name: string }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion', id: string, name: string }
      | { __typename: 'Substation', id: string, name: string }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo', id: string, name: string }
      | { __typename: 'SwitchPhase', id: string, name: string }
      | { __typename: 'SwitchSchedule', id: string, name: string }
      | { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve', id: string, name: string }
      | { __typename: 'TapChangerControl', id: string, name: string }
      | { __typename: 'TapChangerInfo', id: string, name: string }
      | { __typename: 'TapSchedule', id: string, name: string }
      | { __typename: 'TapeShieldCableInfo', id: string, name: string }
      | { __typename: 'TargetLevelSchedule', id: string, name: string }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal', id: string, name: string }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint', id: string, name: string }
      | { __typename: 'TimeSchedule', id: string, name: string }
      | { __typename: 'TopologicalIsland', id: string, name: string }
      | { __typename: 'TopologicalNode', id: string, name: string }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance', id: string, name: string }
      | { __typename: 'TransformerEndInfo', id: string, name: string }
      | { __typename: 'TransformerMeshImpedance', id: string, name: string }
      | { __typename: 'TransformerStarImpedance', id: string, name: string }
      | { __typename: 'TransformerTank', id: string, name: string }
      | { __typename: 'TransformerTankEnd', id: string, name: string }
      | { __typename: 'TransformerTankInfo', id: string, name: string }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone', id: string, name: string }
      | { __typename: 'VoltageLevel', id: string, name: string }
      | { __typename: 'VoltageLimit', id: string, name: string }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit', id: string, name: string }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo', id: string, name: string }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition', id: string, name: string }
      | { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'WireSegmentPhase', id: string, name: string }
      | { __typename: 'WireSpacingInfo', id: string, name: string }
      | { __typename: 'WireUsageKind' }
    > } }

export type FetchReducedBusDetailsQueryVariables = Exact<{
  modelName: string;
  types: Array<Types.CimType> | Types.CimType;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchReducedBusDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', reducedBus: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit', id: string, name: string }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement', id: string, name: string }
      | { __typename: 'AirCompressor', id: string, name: string }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit', id: string, name: string }
      | { __typename: 'Appointment', id: string, name: string }
      | { __typename: 'Approver', id: string, name: string }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author', id: string, name: string }
      | { __typename: 'BaseFrequency', id: string, name: string }
      | { __typename: 'BasePower', id: string, name: string }
      | { __typename: 'BaseVoltage', id: string, name: string }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit', id: string, name: string }
      | { __typename: 'Bay', id: string, name: string }
      | { __typename: 'BranchGroup', id: string, name: string }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker', id: string, name: string }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'BusbarSectionInfo', id: string, name: string }
      | { __typename: 'BushingInfo', id: string, name: string }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant', id: string, name: string }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant', id: string, name: string }
      | { __typename: 'CombinedCyclePlant', id: string, name: string }
      | { __typename: 'CompositeSwitch', id: string, name: string }
      | { __typename: 'ConcentricNeutralCableInfo', id: string, name: string }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent', id: string, name: string }
      | { __typename: 'ConnectivityNode', id: string, name: string }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem', id: string, name: string }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew', id: string, name: string }
      | { __typename: 'CrewMember', id: string, name: string }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType', id: string, name: string }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit', id: string, name: string }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Disconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor', id: string, name: string }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount', id: string, name: string }
      | { __typename: 'EmissionCurve', id: string, name: string }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string }
      | { __typename: 'EnergySchedulingType', id: string, name: string }
      | { __typename: 'EnergySource', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EnergySourcePhase', id: string, name: string }
      | { __typename: 'EquivalentBranch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'EquivalentNetwork', id: string, name: string }
      | { __typename: 'EquivalentShunt', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Feeder', id: string, name: string }
      | { __typename: 'FieldDispatchHistory', id: string, name: string }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel', id: string, name: string }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'FuelAllocationSchedule', id: string, name: string }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GenUnitOpCostCurve', id: string, name: string }
      | { __typename: 'GenUnitOpSchedule', id: string, name: string }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion', id: string, name: string }
      | { __typename: 'GrossToNetActivePowerCurve', id: string, name: string }
      | { __typename: 'Ground', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundDisconnector', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'GroundingImpedance', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Hazard', id: string, name: string }
      | { __typename: 'HeatInputCurve', id: string, name: string }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve', id: string, name: string }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant', id: string, name: string }
      | { __typename: 'HydroPump', id: string, name: string }
      | { __typename: 'HydroPumpOpSchedule', id: string, name: string }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve', id: string, name: string }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast', id: string, name: string }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo', id: string, name: string }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule', id: string, name: string }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer', id: string, name: string }
      | { __typename: 'Jumper', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Junction', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve', id: string, name: string }
      | { __typename: 'Line', id: string, name: string }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Location', id: string, name: string }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling', id: string, name: string }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string }
      | { __typename: 'OpenCircuitTest', id: string, name: string }
      | { __typename: 'OperatingMechanismInfo', id: string, name: string }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant', id: string, name: string }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet', id: string, name: string }
      | { __typename: 'OperationalLimitType', id: string, name: string }
      | { __typename: 'Operator', id: string, name: string }
      | { __typename: 'OrganisationRole', id: string, name: string }
      | { __typename: 'OverheadWireInfo', id: string, name: string }
      | { __typename: 'Ownership', id: string, name: string }
      | { __typename: 'PSRType', id: string, name: string }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization', id: string, name: string }
      | { __typename: 'PenstockLossCurve', id: string, name: string }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance', id: string, name: string }
      | { __typename: 'PerLengthSequenceImpedance', id: string, name: string }
      | { __typename: 'Person', id: string, name: string }
      | { __typename: 'PetersenCoil', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerTable', id: string, name: string }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
      | { __typename: 'Plant', id: string, name: string }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
      | { __typename: 'PowerTransformer', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'PowerTransformerEnd', id: string, name: string }
      | { __typename: 'PowerTransformerInfo', id: string, name: string }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger', id: string, name: string }
      | { __typename: 'RatioTapChangerTable', id: string, name: string }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve', id: string, name: string }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule', id: string, name: string }
      | { __typename: 'ReportingGroup', id: string, name: string }
      | { __typename: 'ReportingSuperGroup', id: string, name: string }
      | { __typename: 'Reservoir', id: string, name: string }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent', id: string, name: string }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SeriesCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest', id: string, name: string }
      | { __typename: 'ShuntCompensatorInfo', id: string, name: string }
      | { __typename: 'ShutdownCurve', id: string, name: string }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve', id: string, name: string }
      | { __typename: 'StartMainFuelCurve', id: string, name: string }
      | { __typename: 'StartRampCurve', id: string, name: string }
      | { __typename: 'StartupModel', id: string, name: string }
      | { __typename: 'StaticVarCompensator', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule', id: string, name: string }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion', id: string, name: string }
      | { __typename: 'Substation', id: string, name: string }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo', id: string, name: string }
      | { __typename: 'SwitchPhase', id: string, name: string }
      | { __typename: 'SwitchSchedule', id: string, name: string }
      | { __typename: 'SynchronousMachine', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve', id: string, name: string }
      | { __typename: 'TapChangerControl', id: string, name: string }
      | { __typename: 'TapChangerInfo', id: string, name: string }
      | { __typename: 'TapSchedule', id: string, name: string }
      | { __typename: 'TapeShieldCableInfo', id: string, name: string }
      | { __typename: 'TargetLevelSchedule', id: string, name: string }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal', id: string, name: string }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint', id: string, name: string }
      | { __typename: 'TimeSchedule', id: string, name: string }
      | { __typename: 'TopologicalIsland', id: string, name: string }
      | { __typename: 'TopologicalNode', id: string, name: string }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance', id: string, name: string }
      | { __typename: 'TransformerEndInfo', id: string, name: string }
      | { __typename: 'TransformerMeshImpedance', id: string, name: string }
      | { __typename: 'TransformerStarImpedance', id: string, name: string }
      | { __typename: 'TransformerTank', id: string, name: string }
      | { __typename: 'TransformerTankEnd', id: string, name: string }
      | { __typename: 'TransformerTankInfo', id: string, name: string }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone', id: string, name: string }
      | { __typename: 'VoltageLevel', id: string, name: string }
      | { __typename: 'VoltageLimit', id: string, name: string }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit', id: string, name: string }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo', id: string, name: string }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition', id: string, name: string }
      | { __typename: 'WireSegment', id: string, name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } } }
      | { __typename: 'WireSegmentPhase', id: string, name: string }
      | { __typename: 'WireSpacingInfo', id: string, name: string }
      | { __typename: 'WireUsageKind' }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

export type FetchSubstationDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchSubstationDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', substation: Array<
      | { __typename: 'ACLineSegment', id: string, name: string }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor', id: string, name: string }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine', id: string, name: string }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit', id: string, name: string }
      | { __typename: 'Bay', id: string, name: string }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', id: string, name: string }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant', id: string, name: string }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp', id: string, name: string }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant', id: string, name: string }
      | { __typename: 'CombinedCyclePlant', id: string, name: string }
      | { __typename: 'CompositeSwitch', id: string, name: string }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut', id: string, name: string }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string }
      | { __typename: 'Disconnector', id: string, name: string }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer', id: string, name: string }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource', id: string, name: string }
      | { __typename: 'EnergySourcePhase', id: string, name: string }
      | { __typename: 'EquivalentBranch', id: string, name: string }
      | { __typename: 'EquivalentInjection', id: string, name: string }
      | { __typename: 'EquivalentNetwork', id: string, name: string }
      | { __typename: 'EquivalentShunt', id: string, name: string }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string }
      | { __typename: 'Feeder', id: string, name: string }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter', id: string, name: string }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse', id: string, name: string }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground', id: string, name: string }
      | { __typename: 'GroundDisconnector', id: string, name: string }
      | { __typename: 'GroundingImpedance', id: string, name: string }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant', id: string, name: string }
      | { __typename: 'HydroPump', id: string, name: string }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper', id: string, name: string }
      | { __typename: 'Junction', id: string, name: string }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line', id: string, name: string }
      | { __typename: 'LinearShuntCompensator', id: string, name: string }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'LoadBreakSwitch', id: string, name: string }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil', id: string, name: string }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string }
      | { __typename: 'Plant', id: string, name: string }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string }
      | { __typename: 'PowerTransformer', id: string, name: string }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger', id: string, name: string }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser', id: string, name: string }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir', id: string, name: string }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser', id: string, name: string }
      | { __typename: 'SeriesCompensator', id: string, name: string }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator', id: string, name: string }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation', name: string, id: string, Region: { __typename: 'SubGeographicalRegion', id: string, name: string }, VoltageLevels: Array<{ __typename: 'VoltageLevel', name: string, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, Equipments: Array<
            | { __typename: 'ACLineSegment' }
            | { __typename: 'AsynchronousMachine' }
            | { __typename: 'BatteryUnit' }
            | { __typename: 'BusbarSection', name: string }
            | { __typename: 'Clamp' }
            | { __typename: 'CompositeSwitch' }
            | { __typename: 'Cut' }
            | { __typename: 'DisconnectingCircuitBreaker' }
            | { __typename: 'Disconnector' }
            | { __typename: 'EnergyConsumer' }
            | { __typename: 'EnergySource' }
            | { __typename: 'EquivalentBranch' }
            | { __typename: 'EquivalentInjection' }
            | { __typename: 'EquivalentShunt' }
            | { __typename: 'ExternalNetworkInjection' }
            | { __typename: 'FrequencyConverter' }
            | { __typename: 'Fuse' }
            | { __typename: 'Ground' }
            | { __typename: 'GroundDisconnector' }
            | { __typename: 'GroundingImpedance' }
            | { __typename: 'HydroGeneratingUnit' }
            | { __typename: 'HydroPump' }
            | { __typename: 'Jumper' }
            | { __typename: 'Junction' }
            | { __typename: 'LinearShuntCompensator' }
            | { __typename: 'LoadBreakSwitch' }
            | { __typename: 'NonlinearShuntCompensator' }
            | { __typename: 'NuclearGeneratingUnit' }
            | { __typename: 'PetersenCoil' }
            | { __typename: 'PhotoVoltaicUnit' }
            | { __typename: 'PowerElectronicsConnection' }
            | { __typename: 'PowerElectronicsWindUnit' }
            | { __typename: 'PowerTransformer' }
            | { __typename: 'Recloser' }
            | { __typename: 'Sectionaliser' }
            | { __typename: 'SeriesCompensator' }
            | { __typename: 'SolarGeneratingUnit' }
            | { __typename: 'StaticVarCompensator' }
            | { __typename: 'SynchronousMachine' }
            | { __typename: 'ThermalGeneratingUnit' }
            | { __typename: 'TransformerTank' }
            | { __typename: 'WindGeneratingUnit' }
            | { __typename: 'WireSegment' }
          >, connections: Array<{ __typename: 'ConnectivityNode', ConnectivityNodeContainer:
              | { __typename: 'Bay' }
              | { __typename: 'EquivalentNetwork' }
              | { __typename: 'Feeder' }
              | { __typename: 'Line' }
              | { __typename: 'Plant' }
              | { __typename: 'Substation' }
              | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
             }> }>, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase', id: string, name: string }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine', id: string, name: string }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl', id: string, name: string }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank', id: string, name: string }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone', id: string, name: string }
      | { __typename: 'VoltageLevel', id: string, name: string }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit', id: string, name: string }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment', id: string, name: string }
      | { __typename: 'WireSegmentPhase', id: string, name: string }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

export type FetchTransformerDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchTransformerDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', transformer: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AirCompressor', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Bay', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CAESPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Clamp', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Cut', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Disconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySource', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Feeder', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Fuse', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ground', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPump', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Jumper', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Junction', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Line', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoil', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Plant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformer', name: string, inService: boolean, id: string, container:
          | { __typename: 'Bay' }
          | { __typename: 'Feeder' }
          | { __typename: 'Line' }
          | { __typename: 'Plant' }
          | { __typename: 'Substation', name: string, VoltageLevels: Array<{ __typename: 'VoltageLevel', name: string }> }
          | { __typename: 'VoltageLevel' }
        , PowerTransformerEnd: Array<{ __typename: 'PowerTransformerEnd', id: string, endNumber: number, r: { __typename: 'Resistance', value: number }, x: { __typename: 'Reactance', value: number }, ratedS: { __typename: 'ApparentPower', value: number }, Terminal: { __typename: 'Terminal', opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
                | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
                | { __typename: 'ApparentPowerLimit' }
                | { __typename: 'CurrentLimit' }
                | { __typename: 'VoltageLimit' }
              > }>, cNode: { __typename: 'ConnectivityNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               }, tNode: { __typename: 'TopologicalNode', container:
                | { __typename: 'Bay' }
                | { __typename: 'EquivalentNetwork' }
                | { __typename: 'Feeder' }
                | { __typename: 'Line' }
                | { __typename: 'Plant' }
                | { __typename: 'Substation' }
                | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
               } }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }>, TransformerTanks: Array<{ __typename: 'TransformerTank', TransformerTankEnds: Array<{ __typename: 'TransformerTankEnd', BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } }, Terminal: { __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 }, tNode: { __typename: 'TopologicalNode', container:
                  | { __typename: 'Bay' }
                  | { __typename: 'EquivalentNetwork' }
                  | { __typename: 'Feeder' }
                  | { __typename: 'Line' }
                  | { __typename: 'Plant' }
                  | { __typename: 'Substation' }
                  | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
                 } } }>, asViewObject: { __typename: 'ViewObject', properties: Array<{ __typename: 'ViewObjectProperty', value:
                | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', asModelEntity:
                      | { __typename: 'ACLineSegment' }
                      | { __typename: 'ACLineSegmentPhase' }
                      | { __typename: 'ActivePower' }
                      | { __typename: 'ActivePowerChangeRate' }
                      | { __typename: 'ActivePowerLimit' }
                      | { __typename: 'ActivePowerPerCurrentFlow' }
                      | { __typename: 'ActivePowerPerFrequency' }
                      | { __typename: 'Admittance' }
                      | { __typename: 'Agreement' }
                      | { __typename: 'AirCompressor' }
                      | { __typename: 'AngleDegrees' }
                      | { __typename: 'AngleRadians' }
                      | { __typename: 'ApparentPower' }
                      | { __typename: 'ApparentPowerLimit' }
                      | { __typename: 'Appointment' }
                      | { __typename: 'Approver' }
                      | { __typename: 'Area' }
                      | { __typename: 'AsynchronousMachine' }
                      | { __typename: 'AsynchronousMachineKind' }
                      | { __typename: 'Author' }
                      | { __typename: 'BaseFrequency' }
                      | { __typename: 'BasePower' }
                      | { __typename: 'BaseVoltage' }
                      | { __typename: 'BatteryStateKind' }
                      | { __typename: 'BatteryUnit' }
                      | { __typename: 'Bay' }
                      | { __typename: 'BranchGroup' }
                      | { __typename: 'BranchGroupTerminal' }
                      | { __typename: 'BreakerConfiguration' }
                      | { __typename: 'BusNameMarker' }
                      | { __typename: 'BusbarConfiguration' }
                      | { __typename: 'BusbarSection' }
                      | { __typename: 'BusbarSectionInfo' }
                      | { __typename: 'BushingInfo' }
                      | { __typename: 'BushingInsulationKind' }
                      | { __typename: 'CAESPlant' }
                      | { __typename: 'CableConstructionKind' }
                      | { __typename: 'CableOuterJacketKind' }
                      | { __typename: 'CableShieldMaterialKind' }
                      | { __typename: 'Capacitance' }
                      | { __typename: 'CapacitancePerLength' }
                      | { __typename: 'Clamp' }
                      | { __typename: 'Classification' }
                      | { __typename: 'CogenerationPlant' }
                      | { __typename: 'CombinedCyclePlant' }
                      | { __typename: 'CompositeSwitch' }
                      | { __typename: 'ConcentricNeutralCableInfo' }
                      | { __typename: 'Conductance' }
                      | { __typename: 'ConductancePerLength' }
                      | { __typename: 'ConfigurationEvent' }
                      | { __typename: 'ConnectivityNode' }
                      | { __typename: 'CoolantType' }
                      | { __typename: 'CoordinateSystem' }
                      | { __typename: 'CostPerEnergyUnit' }
                      | { __typename: 'CostPerHeatUnit' }
                      | { __typename: 'CostPerVolume' }
                      | { __typename: 'CostRate' }
                      | { __typename: 'Crew' }
                      | { __typename: 'CrewMember' }
                      | { __typename: 'CrewStatusKind' }
                      | { __typename: 'CrewType' }
                      | { __typename: 'Currency' }
                      | { __typename: 'CurrentFlow' }
                      | { __typename: 'CurrentLimit' }
                      | { __typename: 'CurveData' }
                      | { __typename: 'CurveStyle' }
                      | { __typename: 'Cut' }
                      | { __typename: 'Damping' }
                      | { __typename: 'Date' }
                      | { __typename: 'DateInterval' }
                      | { __typename: 'DateTime' }
                      | { __typename: 'DateTimeInterval' }
                      | { __typename: 'DecimalQuantity' }
                      | { __typename: 'DisconnectingCircuitBreaker' }
                      | { __typename: 'Disconnector' }
                      | { __typename: 'Displacement' }
                      | { __typename: 'Duration' }
                      | { __typename: 'Editor' }
                      | { __typename: 'ElectronicAddress' }
                      | { __typename: 'Emission' }
                      | { __typename: 'EmissionAccount' }
                      | { __typename: 'EmissionCurve' }
                      | { __typename: 'EmissionType' }
                      | { __typename: 'EmissionValueSource' }
                      | { __typename: 'EnergyConsumer' }
                      | { __typename: 'EnergyConsumerPhase' }
                      | { __typename: 'EnergySchedulingType' }
                      | { __typename: 'EnergySource' }
                      | { __typename: 'EnergySourcePhase' }
                      | { __typename: 'EquivalentBranch' }
                      | { __typename: 'EquivalentInjection' }
                      | { __typename: 'EquivalentNetwork' }
                      | { __typename: 'EquivalentShunt' }
                      | { __typename: 'ExtensionItem' }
                      | { __typename: 'ExtensionsList' }
                      | { __typename: 'ExternalNetworkInjection' }
                      | { __typename: 'Feeder' }
                      | { __typename: 'FieldDispatchHistory' }
                      | { __typename: 'FieldDispatchStep' }
                      | { __typename: 'FloatQuantity' }
                      | { __typename: 'FossilFuel' }
                      | { __typename: 'Frequency' }
                      | { __typename: 'FrequencyConverter' }
                      | { __typename: 'FuelAllocationSchedule' }
                      | { __typename: 'FuelType' }
                      | { __typename: 'Fuse' }
                      | { __typename: 'GenUnitOpCostCurve' }
                      | { __typename: 'GenUnitOpSchedule' }
                      | { __typename: 'GeneratorControlMode' }
                      | { __typename: 'GeneratorControlSource' }
                      | { __typename: 'GeographicalRegion' }
                      | { __typename: 'GrossToNetActivePowerCurve' }
                      | { __typename: 'Ground' }
                      | { __typename: 'GroundDisconnector' }
                      | { __typename: 'GroundingImpedance' }
                      | { __typename: 'Hazard' }
                      | { __typename: 'HeatInputCurve' }
                      | { __typename: 'HeatRate' }
                      | { __typename: 'HeatRateCurve' }
                      | { __typename: 'Hours' }
                      | { __typename: 'HydroEnergyConversionKind' }
                      | { __typename: 'HydroGeneratingEfficiencyCurve' }
                      | { __typename: 'HydroGeneratingUnit' }
                      | { __typename: 'HydroPlantStorageKind' }
                      | { __typename: 'HydroPowerPlant' }
                      | { __typename: 'HydroPump' }
                      | { __typename: 'HydroPumpOpSchedule' }
                      | { __typename: 'Impedance' }
                      | { __typename: 'IncrementalHeatRateCurve' }
                      | { __typename: 'Inductance' }
                      | { __typename: 'InductancePerLength' }
                      | { __typename: 'InflowForecast' }
                      | { __typename: 'IntegerQuantity' }
                      | { __typename: 'InterrupterUnitInfo' }
                      | { __typename: 'InterruptingMediumKind' }
                      | { __typename: 'IrregularIntervalSchedule' }
                      | { __typename: 'IrregularTimePoint' }
                      | { __typename: 'Issuer' }
                      | { __typename: 'Jumper' }
                      | { __typename: 'Junction' }
                      | { __typename: 'KiloActivePower' }
                      | { __typename: 'Length' }
                      | { __typename: 'LevelVsVolumeCurve' }
                      | { __typename: 'Line' }
                      | { __typename: 'LinearShuntCompensator' }
                      | { __typename: 'LinearShuntCompensatorPhase' }
                      | { __typename: 'LoadBreakSwitch' }
                      | { __typename: 'Location' }
                      | { __typename: 'Mass' }
                      | { __typename: 'Minutes' }
                      | { __typename: 'Money' }
                      | { __typename: 'MonthDay' }
                      | { __typename: 'MonthDayInterval' }
                      | { __typename: 'MutualCoupling' }
                      | { __typename: 'Name' }
                      | { __typename: 'NameType' }
                      | { __typename: 'NameTypeAuthority' }
                      | { __typename: 'NoLoadTest' }
                      | { __typename: 'NonlinearShuntCompensator' }
                      | { __typename: 'NonlinearShuntCompensatorPhase' }
                      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
                      | { __typename: 'NonlinearShuntCompensatorPoint' }
                      | { __typename: 'NuclearGeneratingUnit' }
                      | { __typename: 'OpenCircuitTest' }
                      | { __typename: 'OperatingMechanismInfo' }
                      | { __typename: 'OperatingMechanismKind' }
                      | { __typename: 'OperatingParticipant' }
                      | { __typename: 'OperatingShare' }
                      | { __typename: 'OperationalLimitDirectionKind' }
                      | { __typename: 'OperationalLimitSet' }
                      | { __typename: 'OperationalLimitType' }
                      | { __typename: 'Operator' }
                      | { __typename: 'OrganisationRole' }
                      | { __typename: 'OverheadWireInfo' }
                      | { __typename: 'Ownership' }
                      | { __typename: 'PSRType' }
                      | { __typename: 'PU' }
                      | { __typename: 'ParentOrganization' }
                      | { __typename: 'PenstockLossCurve' }
                      | { __typename: 'PerCent' }
                      | { __typename: 'PerLengthPhaseImpedance' }
                      | { __typename: 'PerLengthSequenceImpedance' }
                      | { __typename: 'Person' }
                      | { __typename: 'PetersenCoil' }
                      | { __typename: 'PetersenCoilModeKind' }
                      | { __typename: 'PhaseCode' }
                      | { __typename: 'PhaseImpedanceData' }
                      | { __typename: 'PhaseShuntConnectionKind' }
                      | { __typename: 'PhaseTapChangerAsymmetrical' }
                      | { __typename: 'PhaseTapChangerLinear' }
                      | { __typename: 'PhaseTapChangerSymmetrical' }
                      | { __typename: 'PhaseTapChangerTable' }
                      | { __typename: 'PhaseTapChangerTablePoint' }
                      | { __typename: 'PhaseTapChangerTabular' }
                      | { __typename: 'PhotoVoltaicUnit' }
                      | { __typename: 'Plant' }
                      | { __typename: 'PositionPoint' }
                      | { __typename: 'PowerElectronicsConnection' }
                      | { __typename: 'PowerElectronicsConnectionPhase' }
                      | { __typename: 'PowerElectronicsWindUnit' }
                      | { __typename: 'PowerTransformer' }
                      | { __typename: 'PowerTransformerEnd' }
                      | { __typename: 'PowerTransformerInfo' }
                      | { __typename: 'Pressure' }
                      | { __typename: 'Priority' }
                      | { __typename: 'RatioTapChanger' }
                      | { __typename: 'RatioTapChangerTable' }
                      | { __typename: 'RatioTapChangerTablePoint' }
                      | { __typename: 'Reactance' }
                      | { __typename: 'ReactancePerLength' }
                      | { __typename: 'ReactiveCapabilityCurve' }
                      | { __typename: 'ReactivePower' }
                      | { __typename: 'RealEnergy' }
                      | { __typename: 'Recloser' }
                      | { __typename: 'RegularTimePoint' }
                      | { __typename: 'RegulatingControlModeKind' }
                      | { __typename: 'RegulationSchedule' }
                      | { __typename: 'ReportingGroup' }
                      | { __typename: 'ReportingSuperGroup' }
                      | { __typename: 'Reservoir' }
                      | { __typename: 'Resistance' }
                      | { __typename: 'ResistancePerLength' }
                      | { __typename: 'RotationSpeed' }
                      | { __typename: 'SVCControlMode' }
                      | { __typename: 'ScheduledEvent' }
                      | { __typename: 'ScheduledEventData' }
                      | { __typename: 'Seconds' }
                      | { __typename: 'Sectionaliser' }
                      | { __typename: 'SeriesCompensator' }
                      | { __typename: 'ShortCircuitRotorKind' }
                      | { __typename: 'ShortCircuitTest' }
                      | { __typename: 'ShuntCompensatorInfo' }
                      | { __typename: 'ShutdownCurve' }
                      | { __typename: 'SinglePhaseKind' }
                      | { __typename: 'SolarGeneratingUnit' }
                      | { __typename: 'Speed' }
                      | { __typename: 'StartIgnFuelCurve' }
                      | { __typename: 'StartMainFuelCurve' }
                      | { __typename: 'StartRampCurve' }
                      | { __typename: 'StartupModel' }
                      | { __typename: 'StaticVarCompensator' }
                      | { __typename: 'Status' }
                      | { __typename: 'SteamSendoutSchedule' }
                      | { __typename: 'StreetAddress' }
                      | { __typename: 'StreetDetail' }
                      | { __typename: 'StringQuantity' }
                      | { __typename: 'SubGeographicalRegion' }
                      | { __typename: 'Substation' }
                      | { __typename: 'Susceptance' }
                      | { __typename: 'SusceptancePerLength' }
                      | { __typename: 'SwitchInfo' }
                      | { __typename: 'SwitchPhase' }
                      | { __typename: 'SwitchSchedule' }
                      | { __typename: 'SynchronousMachine' }
                      | { __typename: 'SynchronousMachineKind' }
                      | { __typename: 'SynchronousMachineOperatingMode' }
                      | { __typename: 'TailbayLossCurve' }
                      | { __typename: 'TapChangerControl' }
                      | { __typename: 'TapChangerInfo' }
                      | { __typename: 'TapSchedule' }
                      | { __typename: 'TapeShieldCableInfo' }
                      | { __typename: 'TargetLevelSchedule' }
                      | { __typename: 'TelephoneNumber' }
                      | { __typename: 'Temperature' }
                      | { __typename: 'Terminal' }
                      | { __typename: 'ThermalGeneratingUnit' }
                      | { __typename: 'Time' }
                      | { __typename: 'TimeInterval' }
                      | { __typename: 'TimePoint' }
                      | { __typename: 'TimeSchedule' }
                      | { __typename: 'TopologicalIsland' }
                      | { __typename: 'TopologicalNode' }
                      | { __typename: 'TownDetail' }
                      | { __typename: 'TransformerControlMode' }
                      | { __typename: 'TransformerCoreAdmittance' }
                      | { __typename: 'TransformerEndInfo' }
                      | { __typename: 'TransformerMeshImpedance' }
                      | { __typename: 'TransformerStarImpedance' }
                      | { __typename: 'TransformerTank' }
                      | { __typename: 'TransformerTankEnd' }
                      | { __typename: 'TransformerTankInfo', TransformerEndInfos: Array<{ __typename: 'TransformerEndInfo', ratedS: { __typename: 'ApparentPower', value: number } }> }
                      | { __typename: 'UnitMultiplier' }
                      | { __typename: 'UnitSymbol' }
                      | { __typename: 'UserAttribute' }
                      | { __typename: 'Version' }
                      | { __typename: 'Voltage' }
                      | { __typename: 'VoltageControlZone' }
                      | { __typename: 'VoltageLevel' }
                      | { __typename: 'VoltageLimit' }
                      | { __typename: 'VoltagePerReactivePower' }
                      | { __typename: 'Volume' }
                      | { __typename: 'VolumeFlowRate' }
                      | { __typename: 'WaterLevel' }
                      | { __typename: 'WindGenUnitKind' }
                      | { __typename: 'WindGeneratingUnit' }
                      | { __typename: 'WindingConnection' }
                      | { __typename: 'WireAssemblyInfo' }
                      | { __typename: 'WireInsulationKind' }
                      | { __typename: 'WireMaterialKind' }
                      | { __typename: 'WirePhaseInfo' }
                      | { __typename: 'WirePosition' }
                      | { __typename: 'WireSegment' }
                      | { __typename: 'WireSegmentPhase' }
                      | { __typename: 'WireSpacingInfo' }
                      | { __typename: 'WireUsageKind' }
                     }> }
                | { __typename: 'StringValue' }
               }> } }>, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
            | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
            | { __typename: 'ApparentPowerLimit' }
            | { __typename: 'CurrentLimit' }
            | { __typename: 'VoltageLimit' }
          > }> }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Recloser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reservoir', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Sectionaliser', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Substation', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerControl', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTank', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLevel', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegment', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

type AssociatedVoltageLevel_Bay_Fragment = { __typename: 'Bay' };

type AssociatedVoltageLevel_EquivalentNetwork_Fragment = { __typename: 'EquivalentNetwork' };

type AssociatedVoltageLevel_Feeder_Fragment = { __typename: 'Feeder' };

type AssociatedVoltageLevel_Line_Fragment = { __typename: 'Line' };

type AssociatedVoltageLevel_Plant_Fragment = { __typename: 'Plant' };

type AssociatedVoltageLevel_Substation_Fragment = { __typename: 'Substation' };

type AssociatedVoltageLevel_VoltageLevel_Fragment = { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } };

export type AssociatedVoltageLevelFragment =
  | AssociatedVoltageLevel_Bay_Fragment
  | AssociatedVoltageLevel_EquivalentNetwork_Fragment
  | AssociatedVoltageLevel_Feeder_Fragment
  | AssociatedVoltageLevel_Line_Fragment
  | AssociatedVoltageLevel_Plant_Fragment
  | AssociatedVoltageLevel_Substation_Fragment
  | AssociatedVoltageLevel_VoltageLevel_Fragment
;

export type FetchTransmissionLineDetailsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  ids?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface FetchTransmissionLineDetailsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', line: Array<
      | { __typename: 'ACLineSegment', inService: boolean, name: string, id: string, length: { __typename: 'Length', value: number }, r: { __typename: 'Resistance', value: number }, x: { __typename: 'Reactance', value: number }, b0ch: { __typename: 'Susceptance', value: number }, BaseVoltage: { __typename: 'BaseVoltage', nominalVoltage: { __typename: 'Voltage', value: number } }, ACLineSegmentPhases: Array<{ __typename: 'ACLineSegmentPhase', sequenceNumber: number, phase: { __typename: 'SinglePhaseKind', id: string } }>, Terminals: Array<{ __typename: 'Terminal', sequenceNumber: number, opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
              | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
              | { __typename: 'ApparentPowerLimit' }
              | { __typename: 'CurrentLimit', value: { __typename: 'CurrentFlow', value: number } }
              | { __typename: 'VoltageLimit' }
            > }>, cNode: { __typename: 'ConnectivityNode', container:
              | { __typename: 'Bay' }
              | { __typename: 'EquivalentNetwork' }
              | { __typename: 'Feeder' }
              | { __typename: 'Line' }
              | { __typename: 'Plant' }
              | { __typename: 'Substation' }
              | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
             }, tNode: { __typename: 'TopologicalNode', container:
              | { __typename: 'Bay' }
              | { __typename: 'EquivalentNetwork' }
              | { __typename: 'Feeder' }
              | { __typename: 'Line' }
              | { __typename: 'Plant' }
              | { __typename: 'Substation' }
              | { __typename: 'VoltageLevel', name: string, Substation: { __typename: 'Substation', name: string }, BaseVoltage: { __typename: 'BaseVoltage', name: string, nominalVoltage: { __typename: 'Voltage', value: number } } }
             } }>, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> }, opLimit: Array<{ __typename: 'OperationalLimitSet', limitValue: Array<
            | { __typename: 'ActivePowerLimit', value: { __typename: 'ActivePower', value: number } }
            | { __typename: 'ApparentPowerLimit' }
            | { __typename: 'CurrentLimit' }
            | { __typename: 'VoltageLimit' }
          > }> }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Agreement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AirCompressor', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ApparentPowerLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Appointment', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Approver', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachine', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Author', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseFrequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BasePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BaseVoltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BatteryUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Bay', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusNameMarker', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSection', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BusbarSectionInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CAESPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Clamp', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CompositeSwitch', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConcentricNeutralCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConfigurationEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ConnectivityNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CoordinateSystem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Crew', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewMember', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CrewType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurrentLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Cut', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'DisconnectingCircuitBreaker', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Disconnector', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Editor', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionAccount', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumer', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySchedulingType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySource', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentBranch', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentInjection', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'EquivalentShunt', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ExternalNetworkInjection', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Feeder', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchHistory', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FossilFuel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FrequencyConverter', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelAllocationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Fuse', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpCostCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GenUnitOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GrossToNetActivePowerCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ground', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundDisconnector', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'GroundingImpedance', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hazard', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatInputCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroGeneratingUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPump', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'HydroPumpOpSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IncrementalHeatRateCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InflowForecast', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterrupterUnitInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularIntervalSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Issuer', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Jumper', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Junction', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LevelVsVolumeCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Line', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensator', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'LoadBreakSwitch', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Location', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'MutualCoupling', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NoLoadTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensator', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'NuclearGeneratingUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OpenCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingParticipant', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitSet', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OperationalLimitType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Operator', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OrganisationRole', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'OverheadWireInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Ownership', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PSRType', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ParentOrganization', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PenstockLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthPhaseImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PerLengthSequenceImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Person', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoil', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PhotoVoltaicUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Plant', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnection', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerElectronicsWindUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformer', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'PowerTransformerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTable', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactiveCapabilityCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Recloser', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RegulationSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ReportingSuperGroup', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Reservoir', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEvent', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Sectionaliser', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SeriesCompensator', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShortCircuitTest', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShuntCompensatorInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ShutdownCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SolarGeneratingUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartIgnFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartMainFuelCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartRampCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StartupModel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StaticVarCompensator', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SteamSendoutSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SubGeographicalRegion', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Substation', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SwitchSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachine', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TailbayLossCurve', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerControl', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapChangerInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TapeShieldCableInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TargetLevelSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Terminal', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'ThermalGeneratingUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimePoint', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TimeSchedule', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalIsland', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TopologicalNode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerCoreAdmittance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerEndInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerMeshImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerStarImpedance', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTank', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankEnd', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'TransformerTankInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLevel', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltageLimit', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindGeneratingUnit', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireAssemblyInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WirePosition', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegment', inService: boolean, id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireSpacingInfo', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', asset: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue' }
                              | { __typename: 'StringValue', values: Array<string> }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }>, assetDatasheet: Array<{ __typename: 'ViewObjectProperty', value:
              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', assetInfoAssets: Array<{ __typename: 'ViewObjectProperty', value:
                      | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', lifecycle: Array<{ __typename: 'ViewObjectProperty', value:
                              | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', installationDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }>, retiredDate: Array<{ __typename: 'ViewObjectProperty', value:
                                      | { __typename: 'ReferenceValue' }
                                      | { __typename: 'StringValue', values: Array<string> }
                                     }> }> }
                              | { __typename: 'StringValue' }
                             }> }> }
                      | { __typename: 'StringValue' }
                     }> }> }
              | { __typename: 'StringValue' }
             }> } }
    >, pageInfo: { __typename: 'PageInfo', nextPageToken: string } } }

export type SearchAssetsQueryVariables = Exact<{
  modelName: string;
  types?: Array<Types.CimType> | Types.CimType | null | undefined;
  fulltext: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface SearchAssetsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ACLineSegmentPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerChangeRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerLimit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerPerCurrentFlow', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ActivePowerPerFrequency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Admittance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Agreement', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AirCompressor', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AngleDegrees', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AngleRadians', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ApparentPower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ApparentPowerLimit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Appointment', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Approver', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Area', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AsynchronousMachine', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'AsynchronousMachineKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Author', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BaseFrequency', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BasePower', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BaseVoltage', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BatteryStateKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BatteryUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Bay', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BranchGroup', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BranchGroupTerminal', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BreakerConfiguration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusNameMarker', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarConfiguration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarSection', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BusbarSectionInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BushingInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'BushingInsulationKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CAESPlant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableConstructionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableOuterJacketKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CableShieldMaterialKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Capacitance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CapacitancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Clamp', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Classification', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CogenerationPlant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CombinedCyclePlant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CompositeSwitch', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConcentricNeutralCableInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Conductance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConductancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConfigurationEvent', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ConnectivityNode', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CoolantType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CoordinateSystem', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerEnergyUnit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerHeatUnit', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostPerVolume', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CostRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Crew', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewMember', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewStatusKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CrewType', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Currency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurrentFlow', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurrentLimit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurveData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'CurveStyle', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Cut', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Damping', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Date', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateTime', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DateTimeInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DecimalQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'DisconnectingCircuitBreaker', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Disconnector', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Displacement', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Duration', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Editor', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ElectronicAddress', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Emission', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionAccount', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EmissionValueSource', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergyConsumer', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergyConsumerPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySchedulingType', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySource', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EnergySourcePhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentBranch', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentInjection', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentNetwork', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'EquivalentShunt', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExtensionItem', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExtensionsList', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ExternalNetworkInjection', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Feeder', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FieldDispatchHistory', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FieldDispatchStep', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FloatQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FossilFuel', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Frequency', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FrequencyConverter', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FuelAllocationSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'FuelType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Fuse', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GenUnitOpCostCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GenUnitOpSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeneratorControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeneratorControlSource', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GeographicalRegion', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GrossToNetActivePowerCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Ground', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GroundDisconnector', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'GroundingImpedance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Hazard', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatInputCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HeatRateCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Hours', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroEnergyConversionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroGeneratingEfficiencyCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroGeneratingUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPlantStorageKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPowerPlant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPump', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'HydroPumpOpSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Impedance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IncrementalHeatRateCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Inductance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InductancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InflowForecast', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IntegerQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InterrupterUnitInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'InterruptingMediumKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IrregularIntervalSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'IrregularTimePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Issuer', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Jumper', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Junction', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'KiloActivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Length', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LevelVsVolumeCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Line', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LinearShuntCompensator', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LinearShuntCompensatorPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'LoadBreakSwitch', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Location', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Mass', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Minutes', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Money', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MonthDay', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MonthDayInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'MutualCoupling', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Name', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NameType', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NameTypeAuthority', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NoLoadTest', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensator', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NonlinearShuntCompensatorPoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'NuclearGeneratingUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OpenCircuitTest', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingMechanismInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingMechanismKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingParticipant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperatingShare', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitDirectionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitSet', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OperationalLimitType', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Operator', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OrganisationRole', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'OverheadWireInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Ownership', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PSRType', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PU', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ParentOrganization', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PenstockLossCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerCent', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerLengthPhaseImpedance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PerLengthSequenceImpedance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Person', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PetersenCoil', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PetersenCoilModeKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseCode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseImpedanceData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseShuntConnectionKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerAsymmetrical', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerLinear', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerSymmetrical', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTable', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhaseTapChangerTabular', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PhotoVoltaicUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Plant', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PositionPoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsConnection', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsConnectionPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerElectronicsWindUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformer', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformerEnd', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'PowerTransformerInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Pressure', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Priority', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChanger', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChangerTable', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RatioTapChangerTablePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Reactance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactiveCapabilityCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReactivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RealEnergy', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Recloser', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegularTimePoint', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegulatingControlModeKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RegulationSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReportingGroup', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ReportingSuperGroup', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Reservoir', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Resistance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ResistancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'RotationSpeed', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SVCControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ScheduledEvent', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ScheduledEventData', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Seconds', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Sectionaliser', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SeriesCompensator', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShortCircuitRotorKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShortCircuitTest', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShuntCompensatorInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ShutdownCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SinglePhaseKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SolarGeneratingUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Speed', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartIgnFuelCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartMainFuelCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartRampCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StartupModel', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StaticVarCompensator', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Status', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SteamSendoutSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StreetAddress', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StreetDetail', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'StringQuantity', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SubGeographicalRegion', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Substation', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Susceptance', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SusceptancePerLength', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SwitchSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachine', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachineKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'SynchronousMachineOperatingMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TailbayLossCurve', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapChangerControl', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapChangerInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TapeShieldCableInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TargetLevelSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TelephoneNumber', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Temperature', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Terminal', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'ThermalGeneratingUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Time', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimeInterval', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimePoint', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TimeSchedule', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TopologicalIsland', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TopologicalNode', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TownDetail', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerControlMode', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerCoreAdmittance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerEndInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerMeshImpedance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerStarImpedance', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTank', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTankEnd', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'TransformerTankInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UnitMultiplier', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UnitSymbol', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'UserAttribute', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Version', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Voltage', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageControlZone', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageLevel', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltageLimit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VoltagePerReactivePower', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'Volume', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'VolumeFlowRate', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WaterLevel', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindGenUnitKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindGeneratingUnit', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WindingConnection', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireAssemblyInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireInsulationKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireMaterialKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WirePhaseInfo', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WirePosition', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSegment', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSegmentPhase', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireSpacingInfo', id: string, name: string, description: string, asViewObject: { __typename: 'ViewObject', types: Array<string> } }
      | { __typename: 'WireUsageKind', asViewObject: { __typename: 'ViewObject', types: Array<string> } }
    > } }

export type SubGeographicalRegionsQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface SubGeographicalRegionsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection' }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion', id: string, name: string, Substations: Array<{ __typename: 'Substation', Location: { __typename: 'Location', PositionPoints: Array<{ __typename: 'PositionPoint', x: string, y: string }> } }> }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export type TapestryBranchInfoQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface TapestryBranchInfoQuery { __typename: 'Query', viewObjects: { __typename: 'ViewObjectsPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, viewObjects: Array<{ __typename: 'ViewObject', branch: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', iri: string }> }
          | { __typename: 'StringValue' }
         }>, isDc: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, numLossSections: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, maxTechnicalLimitForward: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, maxTechnicalLimitBackward: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }> }> } }

export type TapestryGenerationProfileInfoQueryVariables = Exact<{
  modelName: string;
  ids?: Array<string | number> | string | number | null | undefined;
}>;


export interface TapestryGenerationProfileInfoQuery { __typename: 'Query', viewObjects: { __typename: 'ViewObjectsPage', viewObjects: Array<{ __typename: 'ViewObject', iri: string, name: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }> }> } }

export type TapestryGeneratorInfoQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface TapestryGeneratorInfoQuery { __typename: 'Query', viewObjects: { __typename: 'ViewObjectsPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, viewObjects: Array<{ __typename: 'ViewObject', generator: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', iri: string }> }
          | { __typename: 'StringValue' }
         }>, profile: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', iri: string }> }
          | { __typename: 'StringValue' }
         }>, constantVariableGenerationCost: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, constantSpecificFuelConsumption: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, constantSpecificFuelConsumptionUnit: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }> }> } }

export type TapestryStorageInfoQueryVariables = Exact<{
  modelName: string;
  pageSize?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;


export interface TapestryStorageInfoQuery { __typename: 'Query', viewObjects: { __typename: 'ViewObjectsPage', pageInfo: { __typename: 'PageInfo', nextPageToken: string }, viewObjects: Array<{ __typename: 'ViewObject', chargeEfficiency: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, dischargeEfficiency: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }>, batteryUnit: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue', values: Array<{ __typename: 'ViewObject', iri: string }> }
          | { __typename: 'StringValue' }
         }>, batteryInfo: Array<{ __typename: 'ViewObjectProperty', value:
          | { __typename: 'ReferenceValue' }
          | { __typename: 'StringValue', values: Array<string> }
         }> }> } }

export type TransformersByBusbarsQueryVariables = Exact<{
  modelName: string;
  busbar1Id: string | number;
  busbar2Id: string | number;
}>;


export interface TransformersByBusbarsQuery { __typename: 'Query', energySystemEntities: { __typename: 'EnergySystemEntitiesPage', entities: Array<
      | { __typename: 'ACLineSegment' }
      | { __typename: 'ACLineSegmentPhase' }
      | { __typename: 'ActivePower' }
      | { __typename: 'ActivePowerChangeRate' }
      | { __typename: 'ActivePowerLimit' }
      | { __typename: 'ActivePowerPerCurrentFlow' }
      | { __typename: 'ActivePowerPerFrequency' }
      | { __typename: 'Admittance' }
      | { __typename: 'Agreement' }
      | { __typename: 'AirCompressor' }
      | { __typename: 'AngleDegrees' }
      | { __typename: 'AngleRadians' }
      | { __typename: 'ApparentPower' }
      | { __typename: 'ApparentPowerLimit' }
      | { __typename: 'Appointment' }
      | { __typename: 'Approver' }
      | { __typename: 'Area' }
      | { __typename: 'AsynchronousMachine' }
      | { __typename: 'AsynchronousMachineKind' }
      | { __typename: 'Author' }
      | { __typename: 'BaseFrequency' }
      | { __typename: 'BasePower' }
      | { __typename: 'BaseVoltage' }
      | { __typename: 'BatteryStateKind' }
      | { __typename: 'BatteryUnit' }
      | { __typename: 'Bay' }
      | { __typename: 'BranchGroup' }
      | { __typename: 'BranchGroupTerminal' }
      | { __typename: 'BreakerConfiguration' }
      | { __typename: 'BusNameMarker' }
      | { __typename: 'BusbarConfiguration' }
      | { __typename: 'BusbarSection', terminals: Array<{ __typename: 'Terminal', cNode: { __typename: 'ConnectivityNode', terminals: Array<{ __typename: 'Terminal', transformer:
                | { __typename: 'ACLineSegment' }
                | { __typename: 'AsynchronousMachine' }
                | { __typename: 'BusbarSection' }
                | { __typename: 'Clamp' }
                | { __typename: 'Cut' }
                | { __typename: 'DisconnectingCircuitBreaker' }
                | { __typename: 'Disconnector' }
                | { __typename: 'EnergyConsumer' }
                | { __typename: 'EnergySource' }
                | { __typename: 'EquivalentBranch' }
                | { __typename: 'EquivalentInjection' }
                | { __typename: 'EquivalentShunt' }
                | { __typename: 'ExternalNetworkInjection' }
                | { __typename: 'FrequencyConverter' }
                | { __typename: 'Fuse' }
                | { __typename: 'Ground' }
                | { __typename: 'GroundDisconnector' }
                | { __typename: 'GroundingImpedance' }
                | { __typename: 'Jumper' }
                | { __typename: 'Junction' }
                | { __typename: 'LinearShuntCompensator' }
                | { __typename: 'LoadBreakSwitch' }
                | { __typename: 'NonlinearShuntCompensator' }
                | { __typename: 'PetersenCoil' }
                | { __typename: 'PowerElectronicsConnection' }
                | { __typename: 'PowerTransformer', id: string }
                | { __typename: 'Recloser' }
                | { __typename: 'Sectionaliser' }
                | { __typename: 'SeriesCompensator' }
                | { __typename: 'StaticVarCompensator' }
                | { __typename: 'SynchronousMachine' }
                | { __typename: 'WireSegment' }
               }> } }> }
      | { __typename: 'BusbarSectionInfo' }
      | { __typename: 'BushingInfo' }
      | { __typename: 'BushingInsulationKind' }
      | { __typename: 'CAESPlant' }
      | { __typename: 'CableConstructionKind' }
      | { __typename: 'CableOuterJacketKind' }
      | { __typename: 'CableShieldMaterialKind' }
      | { __typename: 'Capacitance' }
      | { __typename: 'CapacitancePerLength' }
      | { __typename: 'Clamp' }
      | { __typename: 'Classification' }
      | { __typename: 'CogenerationPlant' }
      | { __typename: 'CombinedCyclePlant' }
      | { __typename: 'CompositeSwitch' }
      | { __typename: 'ConcentricNeutralCableInfo' }
      | { __typename: 'Conductance' }
      | { __typename: 'ConductancePerLength' }
      | { __typename: 'ConfigurationEvent' }
      | { __typename: 'ConnectivityNode' }
      | { __typename: 'CoolantType' }
      | { __typename: 'CoordinateSystem' }
      | { __typename: 'CostPerEnergyUnit' }
      | { __typename: 'CostPerHeatUnit' }
      | { __typename: 'CostPerVolume' }
      | { __typename: 'CostRate' }
      | { __typename: 'Crew' }
      | { __typename: 'CrewMember' }
      | { __typename: 'CrewStatusKind' }
      | { __typename: 'CrewType' }
      | { __typename: 'Currency' }
      | { __typename: 'CurrentFlow' }
      | { __typename: 'CurrentLimit' }
      | { __typename: 'CurveData' }
      | { __typename: 'CurveStyle' }
      | { __typename: 'Cut' }
      | { __typename: 'Damping' }
      | { __typename: 'Date' }
      | { __typename: 'DateInterval' }
      | { __typename: 'DateTime' }
      | { __typename: 'DateTimeInterval' }
      | { __typename: 'DecimalQuantity' }
      | { __typename: 'DisconnectingCircuitBreaker' }
      | { __typename: 'Disconnector' }
      | { __typename: 'Displacement' }
      | { __typename: 'Duration' }
      | { __typename: 'Editor' }
      | { __typename: 'ElectronicAddress' }
      | { __typename: 'Emission' }
      | { __typename: 'EmissionAccount' }
      | { __typename: 'EmissionCurve' }
      | { __typename: 'EmissionType' }
      | { __typename: 'EmissionValueSource' }
      | { __typename: 'EnergyConsumer' }
      | { __typename: 'EnergyConsumerPhase' }
      | { __typename: 'EnergySchedulingType' }
      | { __typename: 'EnergySource' }
      | { __typename: 'EnergySourcePhase' }
      | { __typename: 'EquivalentBranch' }
      | { __typename: 'EquivalentInjection' }
      | { __typename: 'EquivalentNetwork' }
      | { __typename: 'EquivalentShunt' }
      | { __typename: 'ExtensionItem' }
      | { __typename: 'ExtensionsList' }
      | { __typename: 'ExternalNetworkInjection' }
      | { __typename: 'Feeder' }
      | { __typename: 'FieldDispatchHistory' }
      | { __typename: 'FieldDispatchStep' }
      | { __typename: 'FloatQuantity' }
      | { __typename: 'FossilFuel' }
      | { __typename: 'Frequency' }
      | { __typename: 'FrequencyConverter' }
      | { __typename: 'FuelAllocationSchedule' }
      | { __typename: 'FuelType' }
      | { __typename: 'Fuse' }
      | { __typename: 'GenUnitOpCostCurve' }
      | { __typename: 'GenUnitOpSchedule' }
      | { __typename: 'GeneratorControlMode' }
      | { __typename: 'GeneratorControlSource' }
      | { __typename: 'GeographicalRegion' }
      | { __typename: 'GrossToNetActivePowerCurve' }
      | { __typename: 'Ground' }
      | { __typename: 'GroundDisconnector' }
      | { __typename: 'GroundingImpedance' }
      | { __typename: 'Hazard' }
      | { __typename: 'HeatInputCurve' }
      | { __typename: 'HeatRate' }
      | { __typename: 'HeatRateCurve' }
      | { __typename: 'Hours' }
      | { __typename: 'HydroEnergyConversionKind' }
      | { __typename: 'HydroGeneratingEfficiencyCurve' }
      | { __typename: 'HydroGeneratingUnit' }
      | { __typename: 'HydroPlantStorageKind' }
      | { __typename: 'HydroPowerPlant' }
      | { __typename: 'HydroPump' }
      | { __typename: 'HydroPumpOpSchedule' }
      | { __typename: 'Impedance' }
      | { __typename: 'IncrementalHeatRateCurve' }
      | { __typename: 'Inductance' }
      | { __typename: 'InductancePerLength' }
      | { __typename: 'InflowForecast' }
      | { __typename: 'IntegerQuantity' }
      | { __typename: 'InterrupterUnitInfo' }
      | { __typename: 'InterruptingMediumKind' }
      | { __typename: 'IrregularIntervalSchedule' }
      | { __typename: 'IrregularTimePoint' }
      | { __typename: 'Issuer' }
      | { __typename: 'Jumper' }
      | { __typename: 'Junction' }
      | { __typename: 'KiloActivePower' }
      | { __typename: 'Length' }
      | { __typename: 'LevelVsVolumeCurve' }
      | { __typename: 'Line' }
      | { __typename: 'LinearShuntCompensator' }
      | { __typename: 'LinearShuntCompensatorPhase' }
      | { __typename: 'LoadBreakSwitch' }
      | { __typename: 'Location' }
      | { __typename: 'Mass' }
      | { __typename: 'Minutes' }
      | { __typename: 'Money' }
      | { __typename: 'MonthDay' }
      | { __typename: 'MonthDayInterval' }
      | { __typename: 'MutualCoupling' }
      | { __typename: 'Name' }
      | { __typename: 'NameType' }
      | { __typename: 'NameTypeAuthority' }
      | { __typename: 'NoLoadTest' }
      | { __typename: 'NonlinearShuntCompensator' }
      | { __typename: 'NonlinearShuntCompensatorPhase' }
      | { __typename: 'NonlinearShuntCompensatorPhasePoint' }
      | { __typename: 'NonlinearShuntCompensatorPoint' }
      | { __typename: 'NuclearGeneratingUnit' }
      | { __typename: 'OpenCircuitTest' }
      | { __typename: 'OperatingMechanismInfo' }
      | { __typename: 'OperatingMechanismKind' }
      | { __typename: 'OperatingParticipant' }
      | { __typename: 'OperatingShare' }
      | { __typename: 'OperationalLimitDirectionKind' }
      | { __typename: 'OperationalLimitSet' }
      | { __typename: 'OperationalLimitType' }
      | { __typename: 'Operator' }
      | { __typename: 'OrganisationRole' }
      | { __typename: 'OverheadWireInfo' }
      | { __typename: 'Ownership' }
      | { __typename: 'PSRType' }
      | { __typename: 'PU' }
      | { __typename: 'ParentOrganization' }
      | { __typename: 'PenstockLossCurve' }
      | { __typename: 'PerCent' }
      | { __typename: 'PerLengthPhaseImpedance' }
      | { __typename: 'PerLengthSequenceImpedance' }
      | { __typename: 'Person' }
      | { __typename: 'PetersenCoil' }
      | { __typename: 'PetersenCoilModeKind' }
      | { __typename: 'PhaseCode' }
      | { __typename: 'PhaseImpedanceData' }
      | { __typename: 'PhaseShuntConnectionKind' }
      | { __typename: 'PhaseTapChangerAsymmetrical' }
      | { __typename: 'PhaseTapChangerLinear' }
      | { __typename: 'PhaseTapChangerSymmetrical' }
      | { __typename: 'PhaseTapChangerTable' }
      | { __typename: 'PhaseTapChangerTablePoint' }
      | { __typename: 'PhaseTapChangerTabular' }
      | { __typename: 'PhotoVoltaicUnit' }
      | { __typename: 'Plant' }
      | { __typename: 'PositionPoint' }
      | { __typename: 'PowerElectronicsConnection' }
      | { __typename: 'PowerElectronicsConnectionPhase' }
      | { __typename: 'PowerElectronicsWindUnit' }
      | { __typename: 'PowerTransformer' }
      | { __typename: 'PowerTransformerEnd' }
      | { __typename: 'PowerTransformerInfo' }
      | { __typename: 'Pressure' }
      | { __typename: 'Priority' }
      | { __typename: 'RatioTapChanger' }
      | { __typename: 'RatioTapChangerTable' }
      | { __typename: 'RatioTapChangerTablePoint' }
      | { __typename: 'Reactance' }
      | { __typename: 'ReactancePerLength' }
      | { __typename: 'ReactiveCapabilityCurve' }
      | { __typename: 'ReactivePower' }
      | { __typename: 'RealEnergy' }
      | { __typename: 'Recloser' }
      | { __typename: 'RegularTimePoint' }
      | { __typename: 'RegulatingControlModeKind' }
      | { __typename: 'RegulationSchedule' }
      | { __typename: 'ReportingGroup' }
      | { __typename: 'ReportingSuperGroup' }
      | { __typename: 'Reservoir' }
      | { __typename: 'Resistance' }
      | { __typename: 'ResistancePerLength' }
      | { __typename: 'RotationSpeed' }
      | { __typename: 'SVCControlMode' }
      | { __typename: 'ScheduledEvent' }
      | { __typename: 'ScheduledEventData' }
      | { __typename: 'Seconds' }
      | { __typename: 'Sectionaliser' }
      | { __typename: 'SeriesCompensator' }
      | { __typename: 'ShortCircuitRotorKind' }
      | { __typename: 'ShortCircuitTest' }
      | { __typename: 'ShuntCompensatorInfo' }
      | { __typename: 'ShutdownCurve' }
      | { __typename: 'SinglePhaseKind' }
      | { __typename: 'SolarGeneratingUnit' }
      | { __typename: 'Speed' }
      | { __typename: 'StartIgnFuelCurve' }
      | { __typename: 'StartMainFuelCurve' }
      | { __typename: 'StartRampCurve' }
      | { __typename: 'StartupModel' }
      | { __typename: 'StaticVarCompensator' }
      | { __typename: 'Status' }
      | { __typename: 'SteamSendoutSchedule' }
      | { __typename: 'StreetAddress' }
      | { __typename: 'StreetDetail' }
      | { __typename: 'StringQuantity' }
      | { __typename: 'SubGeographicalRegion' }
      | { __typename: 'Substation' }
      | { __typename: 'Susceptance' }
      | { __typename: 'SusceptancePerLength' }
      | { __typename: 'SwitchInfo' }
      | { __typename: 'SwitchPhase' }
      | { __typename: 'SwitchSchedule' }
      | { __typename: 'SynchronousMachine' }
      | { __typename: 'SynchronousMachineKind' }
      | { __typename: 'SynchronousMachineOperatingMode' }
      | { __typename: 'TailbayLossCurve' }
      | { __typename: 'TapChangerControl' }
      | { __typename: 'TapChangerInfo' }
      | { __typename: 'TapSchedule' }
      | { __typename: 'TapeShieldCableInfo' }
      | { __typename: 'TargetLevelSchedule' }
      | { __typename: 'TelephoneNumber' }
      | { __typename: 'Temperature' }
      | { __typename: 'Terminal' }
      | { __typename: 'ThermalGeneratingUnit' }
      | { __typename: 'Time' }
      | { __typename: 'TimeInterval' }
      | { __typename: 'TimePoint' }
      | { __typename: 'TimeSchedule' }
      | { __typename: 'TopologicalIsland' }
      | { __typename: 'TopologicalNode' }
      | { __typename: 'TownDetail' }
      | { __typename: 'TransformerControlMode' }
      | { __typename: 'TransformerCoreAdmittance' }
      | { __typename: 'TransformerEndInfo' }
      | { __typename: 'TransformerMeshImpedance' }
      | { __typename: 'TransformerStarImpedance' }
      | { __typename: 'TransformerTank' }
      | { __typename: 'TransformerTankEnd' }
      | { __typename: 'TransformerTankInfo' }
      | { __typename: 'UnitMultiplier' }
      | { __typename: 'UnitSymbol' }
      | { __typename: 'UserAttribute' }
      | { __typename: 'Version' }
      | { __typename: 'Voltage' }
      | { __typename: 'VoltageControlZone' }
      | { __typename: 'VoltageLevel' }
      | { __typename: 'VoltageLimit' }
      | { __typename: 'VoltagePerReactivePower' }
      | { __typename: 'Volume' }
      | { __typename: 'VolumeFlowRate' }
      | { __typename: 'WaterLevel' }
      | { __typename: 'WindGenUnitKind' }
      | { __typename: 'WindGeneratingUnit' }
      | { __typename: 'WindingConnection' }
      | { __typename: 'WireAssemblyInfo' }
      | { __typename: 'WireInsulationKind' }
      | { __typename: 'WireMaterialKind' }
      | { __typename: 'WirePhaseInfo' }
      | { __typename: 'WirePosition' }
      | { __typename: 'WireSegment' }
      | { __typename: 'WireSegmentPhase' }
      | { __typename: 'WireSpacingInfo' }
      | { __typename: 'WireUsageKind' }
    > } }

export const NextPageInfoFragmentDoc = gql`
    fragment nextPageInfo on EnergySystemEntitiesPage {
  pageInfo {
    nextPageToken
  }
}
    `;
export const ActivePowerLimitFragmentDoc = gql`
    fragment activePowerLimit on Equipment {
  opLimit: OperationalLimitSet {
    limitValue: OperationalLimitValue {
      ... on ActivePowerLimit {
        value {
          value
        }
      }
    }
  }
}
    `;
export const AssetLifecycleFragmentDoc = gql`
    fragment assetLifecycle on ViewObject {
  asset: properties(
    iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PowerSystemResource.Assets"]
  ) {
    value {
      ... on ReferenceValue {
        values {
          lifecycle: properties(
            iris: [
              "http://iec.ch/TC57/2016/CIM-schema-cim17#Asset.lifecycle"
              "http://iec.ch/TC57/2016/CIM-schema-cim17#Asset.lifecycleDate"
            ]
          ) {
            value {
              ... on ReferenceValue {
                values {
                  installationDate: properties(
                    iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.installationDate"]
                  ) {
                    value {
                      ... on StringValue {
                        values
                      }
                    }
                  }
                  retiredDate: properties(
                    iris: [
                      "http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.removalDate"
                      "http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.retiredDate"
                    ]
                  ) {
                    value {
                      ... on StringValue {
                        values
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  assetDatasheet: properties(
    iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PowerSystemResource.AssetDatasheet"]
  ) {
    value {
      ... on ReferenceValue {
        values {
          assetInfoAssets: properties(
            iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#AssetInfo.Assets"]
          ) {
            value {
              ... on ReferenceValue {
                values {
                  lifecycle: properties(
                    iris: [
                      "http://iec.ch/TC57/2016/CIM-schema-cim17#Asset.lifecycle"
                      "http://iec.ch/TC57/2016/CIM-schema-cim17#Asset.lifecycleDate"
                    ]
                  ) {
                    value {
                      ... on ReferenceValue {
                        values {
                          installationDate: properties(
                            iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.installationDate"]
                          ) {
                            value {
                              ... on StringValue {
                                values
                              }
                            }
                          }
                          retiredDate: properties(
                            iris: [
                              "http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.removalDate"
                              "http://iec.ch/TC57/2016/CIM-schema-cim17#LifecycleDate.retiredDate"
                            ]
                          ) {
                            value {
                              ... on StringValue {
                                values
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const AssociatedVoltageLevelFragmentDoc = gql`
    fragment associatedVoltageLevel on ConnectivityNodeContainer {
  ... on VoltageLevel {
    name
    Substation {
      name
    }
    BaseVoltage {
      name
      nominalVoltage {
        value
      }
    }
  }
}
    `;
export const ConnectionTerminalsFragmentDoc = gql`
    fragment connectionTerminals on Terminal {
  cNode: ConnectivityNode {
    container: ConnectivityNodeContainer {
      __typename
      ...associatedVoltageLevel
    }
  }
  tNode: TopologicalNode {
    container: ConnectivityNodeContainer {
      __typename
      ...associatedVoltageLevel
    }
  }
}
    ${AssociatedVoltageLevelFragmentDoc}`;
export const GeneratingUnitCommonFieldsFragmentDoc = gql`
    fragment generatingUnitCommonFields on GeneratingUnit {
  name
  id
  inService
  maxOperatingP {
    value
  }
  minOperatingP {
    value
  }
  rotatingMachines: RotatingMachine {
    Terminals {
      ...connectionTerminals
    }
  }
}
    ${ConnectionTerminalsFragmentDoc}`;
export const IdentificationFragmentDoc = gql`
    fragment identification on IdentifiedObject {
  id
  name
}
    `;
export const BaseVoltageFragmentDoc = gql`
    fragment baseVoltage on ConductingEquipment {
  BaseVoltage {
    nominalVoltage {
      value
    }
  }
}
    `;
export const ReducedBranchDetailsFragmentDoc = gql`
    fragment reducedBranchDetails on ModelEntity {
  ...identification
  ...baseVoltage
}
    ${IdentificationFragmentDoc}
${BaseVoltageFragmentDoc}`;
export const ReducedBusDetailsFragmentDoc = gql`
    fragment reducedBusDetails on ModelEntity {
  ...identification
  ...baseVoltage
}
    ${IdentificationFragmentDoc}
${BaseVoltageFragmentDoc}`;
export const BaseVoltagesDocument = gql`
    query baseVoltages($modelName: String!, $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: [BaseVoltage] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on BaseVoltage {
        nominalVoltage {
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BaseVoltagesGQL extends Apollo.Query<BaseVoltagesQuery, BaseVoltagesQueryVariables> {
    override document = BaseVoltagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusbarSectionsByIdsDocument = gql`
    query busbarSectionsByIds($modelName: String!, $ids: [ID!]!, $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: [BusbarSection], ids: $ids }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on BusbarSection {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusbarSectionsByIdsGQL extends Apollo.Query<BusbarSectionsByIdsQuery, BusbarSectionsByIdsQueryVariables> {
    override document = BusbarSectionsByIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusbarSectionsBySubstationsDocument = gql`
    query busbarSectionsBySubstations($modelName: String!, $substationIds: [ID!], $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: [Substation], ids: $substationIds }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on Substation {
        id
        name
        Region {
          id
          name
        }
        voltageLevels: VoltageLevels {
          busbars: Equipments {
            ... on BusbarSection {
              id
              name
            }
          }
          baseVoltage: BaseVoltage {
            nominalVoltage {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusbarSectionsBySubstationsGQL extends Apollo.Query<BusbarSectionsBySubstationsQuery, BusbarSectionsBySubstationsQueryVariables> {
    override document = BusbarSectionsBySubstationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchMapTypedObjectsDocument = gql`
    query fetchMapTypedObjects($modelName: String!, $geoBoundary: GeoBoundary, $types: [CimType!], $ids: [ID!], $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { geoBoundary: $geoBoundary, types: $types, ids: $ids }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities: entities {
      asViewObject {
        types
      }
      ... on PowerSystemResource {
        id
        name
        Location {
          PositionPoints {
            x: xPosition
            y: yPosition
            index: sequenceNumber
          }
        }
      }
      ... on ConductingEquipment {
        BaseVoltage {
          nominalVoltage {
            value
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchMapTypedObjectsGQL extends Apollo.Query<FetchMapTypedObjectsQuery, FetchMapTypedObjectsQueryVariables> {
    override document = FetchMapTypedObjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchViewObjectsByIdDocument = gql`
    query fetchViewObjectsById($modelName: String!, $ids: [ID!]!) {
  viewObjects(version: { modelName: $modelName }, filter: { iris: $ids }) {
    viewObjects {
      iri
      types
      name: properties(
        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#IdentifiedObject.name"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      location: properties(
        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PowerSystemResource.Location"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              positionPoints: properties(
                iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#Location.PositionPoints"]
              ) {
                value {
                  ... on ReferenceValue {
                    values {
                      x: properties(
                        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PositionPoint.xPosition"]
                      ) {
                        value {
                          ... on StringValue {
                            values
                          }
                        }
                      }
                      y: properties(
                        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PositionPoint.yPosition"]
                      ) {
                        value {
                          ... on StringValue {
                            values
                          }
                        }
                      }
                      sequenceNumber: properties(
                        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PositionPoint.sequenceNumber"]
                      ) {
                        value {
                          ... on StringValue {
                            values
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      baseVoltage: properties(
        iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#ConductingEquipment.BaseVoltage"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              name: properties(
                iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#IdentifiedObject.name"]
              ) {
                value {
                  ... on StringValue {
                    values
                  }
                }
              }
            }
          }
        }
      }
      properties {
        iri
        value {
          ... on StringValue {
            string_values: values
          }
          ... on ReferenceValue {
            reference_values: values {
              iri
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchViewObjectsByIdGQL extends Apollo.Query<FetchViewObjectsByIdQuery, FetchViewObjectsByIdQueryVariables> {
    override document = FetchViewObjectsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratorsByBusbarSectionsDocument = gql`
    query generatorsByBusbarSections($modelName: String!, $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: [BusbarSection] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on BusbarSection {
        id
        name
        Terminals: Terminals {
          ConnectivityNode: ConnectivityNode {
            Terminals: Terminals {
              ConductingEquipment: ConductingEquipment {
                ... on PowerElectronicsConnection {
                  PowerElectronicsUnit: PowerElectronicsUnit {
                    ... on PhotoVoltaicUnit {
                      id
                      name
                    }
                    ... on PowerElectronicsWindUnit {
                      id
                      name
                    }
                  }
                }
                ... on RotatingMachine {
                  GeneratingUnit: GeneratingUnit {
                    ... on HydroGeneratingUnit {
                      id
                      name
                      HydroPowerPlant: HydroPowerPlant {
                        hydroPlantStorageType {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratorsByBusbarSectionsGQL extends Apollo.Query<GeneratorsByBusbarSectionsQuery, GeneratorsByBusbarSectionsQueryVariables> {
    override document = GeneratorsByBusbarSectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAcLineSegmentByIriDocument = gql`
    query getACLineSegmentByIri($modelName: String!, $iri: ID!) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { ids: [$iri], types: [ACLineSegment] }
  ) {
    entities {
      ... on ACLineSegment {
        x {
          value
        }
        r {
          value
        }
        length {
          value
        }
        name
        OperationalLimitSet {
          OperationalLimitValue {
            ... on ActivePowerLimit {
              value {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAcLineSegmentByIriGQL extends Apollo.Query<GetAcLineSegmentByIriQuery, GetAcLineSegmentByIriQueryVariables> {
    override document = GetAcLineSegmentByIriDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchAssetLimitsDetailsDocument = gql`
    query fetchAssetLimitsDetails($modelName: String!, $types: [CimType!], $fulltext: String, $ids: [ID!], $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, fulltext: $fulltext, ids: $ids }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on PowerSystemResource {
        id
        name
      }
      ... on Equipment {
        inService
      }
      asViewObject {
        ...assetLifecycle
      }
      ... on ACLineSegment {
        name
        Terminals {
          sequenceNumber
          ...connectionTerminals
          opLimit: OperationalLimitSet {
            limitValue: OperationalLimitValue {
              ... on ActivePowerLimit {
                value {
                  value
                }
              }
              ... on ApparentPowerLimit {
                value {
                  value
                }
              }
              ... on CurrentLimit {
                value {
                  value
                }
              }
            }
          }
        }
      }
      ... on PowerTransformer {
        name
        container: EquipmentContainer {
          ... on Substation {
            name
            VoltageLevels {
              name
            }
          }
        }
        PowerTransformerEnd {
          endNumber
          Terminal {
            sequenceNumber
            ...connectionTerminals
            opLimit: OperationalLimitSet {
              limitValue: OperationalLimitValue {
                ... on ActivePowerLimit {
                  value {
                    value
                  }
                }
                ... on ApparentPowerLimit {
                  value {
                    value
                  }
                }
                ... on CurrentLimit {
                  value {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${AssetLifecycleFragmentDoc}
${ConnectionTerminalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchAssetLimitsDetailsGQL extends Apollo.Query<FetchAssetLimitsDetailsQuery, FetchAssetLimitsDetailsQueryVariables> {
    override document = FetchAssetLimitsDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchEnergyStorageDetailsDocument = gql`
    query fetchEnergyStorageDetails($modelName: String!, $types: [CimType!], $ids: [ID!], $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, ids: $ids }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    storage: entities {
      ... on BatteryUnit {
        name
        inService
        maxP {
          value
        }
        ratedE {
          value
        }
        storedE {
          value
        }
        connection: PowerElectronicsConnection {
          Terminals {
            ...connectionTerminals
          }
        }
      }
      ... on PowerSystemResource {
        id
        name
      }
      asViewObject {
        ...assetLifecycle
      }
    }
    pageInfo {
      nextPageToken
    }
  }
}
    ${ConnectionTerminalsFragmentDoc}
${AssetLifecycleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchEnergyStorageDetailsGQL extends Apollo.Query<FetchEnergyStorageDetailsQuery, FetchEnergyStorageDetailsQueryVariables> {
    override document = FetchEnergyStorageDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchGeneratorDetailsDocument = gql`
    query fetchGeneratorDetails($modelName: String!, $types: [CimType!], $ids: [ID!], $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, ids: $ids }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    generator: entities {
      __typename
      ... on GeneratingUnit {
        ...generatingUnitCommonFields
      }
      ... on HydroPowerPlant {
        HydroGeneratingUnits {
          ...generatingUnitCommonFields
          rotatingMachines: RotatingMachine {
            Terminals {
              ...connectionTerminals
            }
          }
        }
        hydroPlantStorageType {
          id
        }
      }
      ... on ThermalGeneratingUnit {
        FossilFuels {
          ... on FossilFuel {
            fossilFuelType {
              id
            }
          }
        }
        rotatingMachines: RotatingMachine {
          Terminals {
            ...connectionTerminals
          }
        }
      }
      ... on PhotoVoltaicUnit {
        name
        inService
        maxP {
          value
        }
        minP {
          value
        }
      }
      ... on PowerElectronicsUnit {
        maxP {
          value
        }
        minP {
          value
        }
        peConnection: PowerElectronicsConnection {
          Terminals {
            ...connectionTerminals
          }
        }
      }
      ... on PowerSystemResource {
        id
        name
      }
      asViewObject {
        ...assetLifecycle
      }
    }
    pageInfo {
      nextPageToken
    }
  }
}
    ${GeneratingUnitCommonFieldsFragmentDoc}
${ConnectionTerminalsFragmentDoc}
${AssetLifecycleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchGeneratorDetailsGQL extends Apollo.Query<FetchGeneratorDetailsQuery, FetchGeneratorDetailsQueryVariables> {
    override document = FetchGeneratorDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReducedBranchDetailsByIdDocument = gql`
    query fetchReducedBranchDetailsById($modelName: String!, $id: ID!) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { ids: [$id] }
    pagination: { limit: 1 }
  ) {
    reducedBranch: entities {
      ...reducedBranchDetails
    }
  }
}
    ${ReducedBranchDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReducedBranchDetailsByIdGQL extends Apollo.Query<FetchReducedBranchDetailsByIdQuery, FetchReducedBranchDetailsByIdQueryVariables> {
    override document = FetchReducedBranchDetailsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReducedBranchDetailsDocument = gql`
    query fetchReducedBranchDetails($modelName: String!, $types: [CimType!]!, $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    reducedBranch: entities {
      ...reducedBranchDetails
    }
    ...nextPageInfo
  }
}
    ${ReducedBranchDetailsFragmentDoc}
${NextPageInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReducedBranchDetailsGQL extends Apollo.Query<FetchReducedBranchDetailsQuery, FetchReducedBranchDetailsQueryVariables> {
    override document = FetchReducedBranchDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReducedBusDetailsByIdDocument = gql`
    query fetchReducedBusDetailsById($modelName: String!, $id: ID!) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { ids: [$id] }
    pagination: { limit: 1 }
  ) {
    reducedBus: entities {
      ...reducedBusDetails
    }
  }
}
    ${ReducedBusDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReducedBusDetailsByIdGQL extends Apollo.Query<FetchReducedBusDetailsByIdQuery, FetchReducedBusDetailsByIdQueryVariables> {
    override document = FetchReducedBusDetailsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReducedBusDetailsDocument = gql`
    query fetchReducedBusDetails($modelName: String!, $types: [CimType!]!, $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    reducedBus: entities {
      ...reducedBusDetails
    }
    ...nextPageInfo
  }
}
    ${ReducedBusDetailsFragmentDoc}
${NextPageInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReducedBusDetailsGQL extends Apollo.Query<FetchReducedBusDetailsQuery, FetchReducedBusDetailsQueryVariables> {
    override document = FetchReducedBusDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchSubstationDetailsDocument = gql`
    query fetchSubstationDetails($modelName: String!, $types: [CimType!], $ids: [ID!], $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, ids: $ids }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    substation: entities {
      ... on Substation {
        name
        Region {
          id
          name
        }
        VoltageLevels {
          name
          BaseVoltage {
            nominalVoltage {
              value
            }
          }
          Equipments {
            ... on BusbarSection {
              name
            }
          }
          connections: ConnectivityNodes {
            ConnectivityNodeContainer {
              __typename
              ...associatedVoltageLevel
            }
          }
        }
        asViewObject {
          ...assetLifecycle
        }
      }
      ... on PowerSystemResource {
        id
        name
      }
    }
    pageInfo {
      nextPageToken
    }
  }
}
    ${AssociatedVoltageLevelFragmentDoc}
${AssetLifecycleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSubstationDetailsGQL extends Apollo.Query<FetchSubstationDetailsQuery, FetchSubstationDetailsQueryVariables> {
    override document = FetchSubstationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransformerDetailsDocument = gql`
    query fetchTransformerDetails($modelName: String!, $types: [CimType!], $ids: [ID!], $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, ids: $ids }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    transformer: entities {
      ... on PowerTransformer {
        name
        inService
        ...activePowerLimit
        container: EquipmentContainer {
          ... on Substation {
            name
            VoltageLevels {
              name
            }
          }
        }
        PowerTransformerEnd {
          id
          r {
            value
          }
          x {
            value
          }
          ratedS {
            value
          }
          endNumber
          Terminal {
            ...connectionTerminals
            opLimit: OperationalLimitSet {
              limitValue: OperationalLimitValue {
                ... on ActivePowerLimit {
                  value {
                    value
                  }
                }
              }
            }
          }
          BaseVoltage {
            name
            nominalVoltage {
              value
            }
          }
        }
        TransformerTanks {
          TransformerTankEnds {
            BaseVoltage {
              name
              nominalVoltage {
                value
              }
            }
            Terminal {
              ...connectionTerminals
            }
          }
          asViewObject {
            properties(
              iris: ["http://iec.ch/TC57/2016/CIM-schema-cim17#PowerSystemResource.AssetDatasheet"]
            ) {
              value {
                ... on ReferenceValue {
                  values {
                    asModelEntity {
                      ... on TransformerTankInfo {
                        TransformerEndInfos {
                          ratedS {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      ... on PowerSystemResource {
        id
        name
      }
      asViewObject {
        ...assetLifecycle
      }
    }
    pageInfo {
      nextPageToken
    }
  }
}
    ${ActivePowerLimitFragmentDoc}
${ConnectionTerminalsFragmentDoc}
${AssetLifecycleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransformerDetailsGQL extends Apollo.Query<FetchTransformerDetailsQuery, FetchTransformerDetailsQueryVariables> {
    override document = FetchTransformerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransmissionLineDetailsDocument = gql`
    query fetchTransmissionLineDetails($modelName: String!, $types: [CimType!], $ids: [ID!], $limit: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, ids: $ids }
    pagination: { limit: $limit, pageToken: $pageToken }
  ) {
    line: entities {
      ... on Equipment {
        inService
      }
      ... on ACLineSegment {
        name
        inService
        length {
          value
        }
        r {
          value
        }
        x {
          value
        }
        b0ch {
          value
        }
        BaseVoltage {
          nominalVoltage {
            value
          }
        }
        ACLineSegmentPhases {
          sequenceNumber
          phase {
            id
          }
        }
        Terminals {
          sequenceNumber
          ...connectionTerminals
          opLimit: OperationalLimitSet {
            limitValue: OperationalLimitValue {
              ... on CurrentLimit {
                value {
                  value
                }
              }
              ... on ActivePowerLimit {
                value {
                  value
                }
              }
            }
          }
        }
        ...activePowerLimit
      }
      ... on PowerSystemResource {
        id
        name
      }
      asViewObject {
        ...assetLifecycle
      }
    }
    pageInfo {
      nextPageToken
    }
  }
}
    ${ConnectionTerminalsFragmentDoc}
${ActivePowerLimitFragmentDoc}
${AssetLifecycleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransmissionLineDetailsGQL extends Apollo.Query<FetchTransmissionLineDetailsQuery, FetchTransmissionLineDetailsQueryVariables> {
    override document = FetchTransmissionLineDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAssetsDocument = gql`
    query searchAssets($modelName: String!, $types: [CimType!], $fulltext: String!, $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: $types, fulltext: $fulltext }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities: entities {
      asViewObject {
        types
      }
      ... on IdentifiedObject {
        id
        name
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAssetsGQL extends Apollo.Query<SearchAssetsQuery, SearchAssetsQueryVariables> {
    override document = SearchAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubGeographicalRegionsDocument = gql`
    query subGeographicalRegions($modelName: String!, $pageSize: Int, $pageToken: String) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { types: [SubGeographicalRegion] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    entities {
      ... on SubGeographicalRegion {
        id
        name
        Substations {
          Location {
            PositionPoints {
              x: xPosition
              y: yPosition
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubGeographicalRegionsGQL extends Apollo.Query<SubGeographicalRegionsQuery, SubGeographicalRegionsQueryVariables> {
    override document = SubGeographicalRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TapestryBranchInfoDocument = gql`
    query tapestryBranchInfo($modelName: String!, $pageSize: Int, $pageToken: String) {
  viewObjects(
    version: { modelName: $modelName }
    filter: { types: ["http://iec.ch/TC57/2016/CIM-schema-cim17#TapestryBranchInfo"] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    viewObjects {
      branch: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryBranchInfo.Branch"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              iri
            }
          }
        }
      }
      isDc: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryBranchInfo.IsDC"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      numLossSections: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryBranchInfo.NumLossSections"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      maxTechnicalLimitForward: properties(
        iris: [
          "https://tapestry.energy/cim/v0#TapestryBranchInfo.MaxTechnicalLimitForwardMva"
        ]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      maxTechnicalLimitBackward: properties(
        iris: [
          "https://tapestry.energy/cim/v0#TapestryBranchInfo.MaxTechnicalLimitBackwardMva"
        ]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TapestryBranchInfoGQL extends Apollo.Query<TapestryBranchInfoQuery, TapestryBranchInfoQueryVariables> {
    override document = TapestryBranchInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TapestryGenerationProfileInfoDocument = gql`
    query tapestryGenerationProfileInfo($modelName: String!, $ids: [ID!]) {
  viewObjects(version: { modelName: $modelName }, filter: { iris: $ids }) {
    viewObjects {
      iri
      name: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryGenerationProfileInfo.Name"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TapestryGenerationProfileInfoGQL extends Apollo.Query<TapestryGenerationProfileInfoQuery, TapestryGenerationProfileInfoQueryVariables> {
    override document = TapestryGenerationProfileInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TapestryGeneratorInfoDocument = gql`
    query tapestryGeneratorInfo($modelName: String!, $pageSize: Int, $pageToken: String) {
  viewObjects(
    version: { modelName: $modelName }
    filter: { types: ["http://iec.ch/TC57/2016/CIM-schema-cim17#TapestryGeneratorInfo"] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    viewObjects {
      generator: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryGeneratorInfo.Generator"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              iri
            }
          }
        }
      }
      profile: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryGeneratorInfo.Profile"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              iri
            }
          }
        }
      }
      constantVariableGenerationCost: properties(
        iris: [
          "https://tapestry.energy/cim/v0#TapestryGeneratorInfo.ConstantVariableGenerationCost.value"
        ]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      constantSpecificFuelConsumption: properties(
        iris: [
          "https://tapestry.energy/cim/v0#TapestryGeneratorInfo.ConstantSpecificFuelConsumption"
        ]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      constantSpecificFuelConsumptionUnit: properties(
        iris: [
          "https://tapestry.energy/cim/v0#TapestryGeneratorInfo.ConstantSpecificFuelConsumptionUnit"
        ]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TapestryGeneratorInfoGQL extends Apollo.Query<TapestryGeneratorInfoQuery, TapestryGeneratorInfoQueryVariables> {
    override document = TapestryGeneratorInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TapestryStorageInfoDocument = gql`
    query tapestryStorageInfo($modelName: String!, $pageSize: Int, $pageToken: String) {
  viewObjects(
    version: { modelName: $modelName }
    filter: { types: ["http://iec.ch/TC57/2016/CIM-schema-cim17#TapestryStorageInfo"] }
    pagination: { limit: $pageSize, pageToken: $pageToken }
  ) {
    pageInfo {
      nextPageToken
    }
    viewObjects {
      chargeEfficiency: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryStorageInfo.ChargeEfficiency"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      dischargeEfficiency: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryStorageInfo.DischargeEfficiency"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
      batteryUnit: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryStorageInfo.BatteryUnit"]
      ) {
        value {
          ... on ReferenceValue {
            values {
              iri
            }
          }
        }
      }
      batteryInfo: properties(
        iris: ["https://tapestry.energy/cim/v0#TapestryStorageInfo.BatteryInfo"]
      ) {
        value {
          ... on StringValue {
            values
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TapestryStorageInfoGQL extends Apollo.Query<TapestryStorageInfoQuery, TapestryStorageInfoQueryVariables> {
    override document = TapestryStorageInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransformersByBusbarsDocument = gql`
    query transformersByBusbars($modelName: String!, $busbar1Id: ID!, $busbar2Id: ID!) {
  energySystemEntities(
    version: { modelName: $modelName }
    filter: { ids: [$busbar1Id, $busbar2Id] }
  ) {
    entities {
      ... on BusbarSection {
        terminals: Terminals {
          cNode: ConnectivityNode {
            terminals: Terminals {
              transformer: ConductingEquipment {
                ... on PowerTransformer {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransformersByBusbarsGQL extends Apollo.Query<TransformersByBusbarsQuery, TransformersByBusbarsQueryVariables> {
    override document = TransformersByBusbarsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ACDCTerminal": [
      "Terminal"
    ],
    "ActivityRecord": [
      "ConfigurationEvent"
    ],
    "BasicIntervalSchedule": [
      "GenUnitOpSchedule",
      "HydroPumpOpSchedule",
      "InflowForecast",
      "IrregularIntervalSchedule",
      "RegulationSchedule",
      "SteamSendoutSchedule",
      "SwitchSchedule",
      "TapSchedule"
    ],
    "Breaker": [
      "DisconnectingCircuitBreaker"
    ],
    "CableInfo": [
      "ConcentricNeutralCableInfo",
      "TapeShieldCableInfo"
    ],
    "ConductingEquipment": [
      "ACLineSegment",
      "AsynchronousMachine",
      "BusbarSection",
      "Clamp",
      "Cut",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "EnergyConsumer",
      "EnergySource",
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentShunt",
      "ExternalNetworkInjection",
      "FrequencyConverter",
      "Fuse",
      "Ground",
      "GroundDisconnector",
      "GroundingImpedance",
      "Jumper",
      "Junction",
      "LinearShuntCompensator",
      "LoadBreakSwitch",
      "NonlinearShuntCompensator",
      "PetersenCoil",
      "PowerElectronicsConnection",
      "PowerTransformer",
      "Recloser",
      "Sectionaliser",
      "SeriesCompensator",
      "StaticVarCompensator",
      "SynchronousMachine",
      "WireSegment"
    ],
    "Conductor": [
      "ACLineSegment",
      "WireSegment"
    ],
    "ConnectivityNodeContainer": [
      "Bay",
      "EquivalentNetwork",
      "Feeder",
      "Line",
      "Plant",
      "Substation",
      "VoltageLevel"
    ],
    "Connector": [
      "BusbarSection",
      "Junction"
    ],
    "Curve": [
      "EmissionAccount",
      "EmissionCurve",
      "FuelAllocationSchedule",
      "GenUnitOpCostCurve",
      "GrossToNetActivePowerCurve",
      "HeatInputCurve",
      "HeatRateCurve",
      "HydroGeneratingEfficiencyCurve",
      "IncrementalHeatRateCurve",
      "LevelVsVolumeCurve",
      "PenstockLossCurve",
      "ReactiveCapabilityCurve",
      "ShutdownCurve",
      "StartIgnFuelCurve",
      "StartMainFuelCurve",
      "StartRampCurve",
      "TailbayLossCurve",
      "TargetLevelSchedule"
    ],
    "Document": [
      "Agreement",
      "TimeSchedule"
    ],
    "DocumentPersonRole": [
      "Approver",
      "Author",
      "Editor",
      "Issuer"
    ],
    "EarthFaultCompensator": [
      "GroundingImpedance",
      "PetersenCoil"
    ],
    "EnergyConnection": [
      "AsynchronousMachine",
      "EnergyConsumer",
      "EnergySource",
      "ExternalNetworkInjection",
      "FrequencyConverter",
      "LinearShuntCompensator",
      "NonlinearShuntCompensator",
      "PowerElectronicsConnection",
      "StaticVarCompensator",
      "SynchronousMachine"
    ],
    "Equipment": [
      "ACLineSegment",
      "AsynchronousMachine",
      "BatteryUnit",
      "BusbarSection",
      "Clamp",
      "CompositeSwitch",
      "Cut",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "EnergyConsumer",
      "EnergySource",
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentShunt",
      "ExternalNetworkInjection",
      "FrequencyConverter",
      "Fuse",
      "Ground",
      "GroundDisconnector",
      "GroundingImpedance",
      "HydroGeneratingUnit",
      "HydroPump",
      "Jumper",
      "Junction",
      "LinearShuntCompensator",
      "LoadBreakSwitch",
      "NonlinearShuntCompensator",
      "NuclearGeneratingUnit",
      "PetersenCoil",
      "PhotoVoltaicUnit",
      "PowerElectronicsConnection",
      "PowerElectronicsWindUnit",
      "PowerTransformer",
      "Recloser",
      "Sectionaliser",
      "SeriesCompensator",
      "SolarGeneratingUnit",
      "StaticVarCompensator",
      "SynchronousMachine",
      "ThermalGeneratingUnit",
      "TransformerTank",
      "WindGeneratingUnit",
      "WireSegment"
    ],
    "EquipmentContainer": [
      "Bay",
      "Feeder",
      "Line",
      "Plant",
      "Substation",
      "VoltageLevel"
    ],
    "EquivalentEquipment": [
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentShunt"
    ],
    "GeneratingUnit": [
      "HydroGeneratingUnit",
      "NuclearGeneratingUnit",
      "SolarGeneratingUnit",
      "ThermalGeneratingUnit",
      "WindGeneratingUnit"
    ],
    "IdentifiedObject": [
      "ACLineSegment",
      "ACLineSegmentPhase",
      "ActivePowerLimit",
      "Agreement",
      "AirCompressor",
      "ApparentPowerLimit",
      "Appointment",
      "Approver",
      "AsynchronousMachine",
      "Author",
      "BaseFrequency",
      "BasePower",
      "BaseVoltage",
      "BatteryUnit",
      "Bay",
      "BranchGroup",
      "BusNameMarker",
      "BusbarSection",
      "BusbarSectionInfo",
      "BushingInfo",
      "CAESPlant",
      "Clamp",
      "CogenerationPlant",
      "CombinedCyclePlant",
      "CompositeSwitch",
      "ConcentricNeutralCableInfo",
      "ConfigurationEvent",
      "ConnectivityNode",
      "CoordinateSystem",
      "Crew",
      "CrewMember",
      "CrewType",
      "CurrentLimit",
      "Cut",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "Editor",
      "EmissionAccount",
      "EmissionCurve",
      "EnergyConsumer",
      "EnergyConsumerPhase",
      "EnergySchedulingType",
      "EnergySource",
      "EnergySourcePhase",
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentNetwork",
      "EquivalentShunt",
      "ExternalNetworkInjection",
      "Feeder",
      "FieldDispatchHistory",
      "FossilFuel",
      "FrequencyConverter",
      "FuelAllocationSchedule",
      "Fuse",
      "GenUnitOpCostCurve",
      "GenUnitOpSchedule",
      "GeographicalRegion",
      "GrossToNetActivePowerCurve",
      "Ground",
      "GroundDisconnector",
      "GroundingImpedance",
      "Hazard",
      "HeatInputCurve",
      "HeatRateCurve",
      "HydroGeneratingEfficiencyCurve",
      "HydroGeneratingUnit",
      "HydroPowerPlant",
      "HydroPump",
      "HydroPumpOpSchedule",
      "IncrementalHeatRateCurve",
      "InflowForecast",
      "InterrupterUnitInfo",
      "IrregularIntervalSchedule",
      "Issuer",
      "Jumper",
      "Junction",
      "LevelVsVolumeCurve",
      "Line",
      "LinearShuntCompensator",
      "LinearShuntCompensatorPhase",
      "LoadBreakSwitch",
      "Location",
      "MutualCoupling",
      "NoLoadTest",
      "NonlinearShuntCompensator",
      "NonlinearShuntCompensatorPhase",
      "NuclearGeneratingUnit",
      "OpenCircuitTest",
      "OperatingMechanismInfo",
      "OperatingParticipant",
      "OperationalLimitSet",
      "OperationalLimitType",
      "Operator",
      "OrganisationRole",
      "OverheadWireInfo",
      "Ownership",
      "PSRType",
      "ParentOrganization",
      "PenstockLossCurve",
      "PerLengthPhaseImpedance",
      "PerLengthSequenceImpedance",
      "Person",
      "PetersenCoil",
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerLinear",
      "PhaseTapChangerSymmetrical",
      "PhaseTapChangerTable",
      "PhaseTapChangerTabular",
      "PhotoVoltaicUnit",
      "Plant",
      "PowerElectronicsConnection",
      "PowerElectronicsConnectionPhase",
      "PowerElectronicsWindUnit",
      "PowerTransformer",
      "PowerTransformerEnd",
      "PowerTransformerInfo",
      "RatioTapChanger",
      "RatioTapChangerTable",
      "ReactiveCapabilityCurve",
      "Recloser",
      "RegulationSchedule",
      "ReportingGroup",
      "ReportingSuperGroup",
      "Reservoir",
      "ScheduledEvent",
      "Sectionaliser",
      "SeriesCompensator",
      "ShortCircuitTest",
      "ShuntCompensatorInfo",
      "ShutdownCurve",
      "SolarGeneratingUnit",
      "StartIgnFuelCurve",
      "StartMainFuelCurve",
      "StartRampCurve",
      "StartupModel",
      "StaticVarCompensator",
      "SteamSendoutSchedule",
      "SubGeographicalRegion",
      "Substation",
      "SwitchInfo",
      "SwitchPhase",
      "SwitchSchedule",
      "SynchronousMachine",
      "TailbayLossCurve",
      "TapChangerControl",
      "TapChangerInfo",
      "TapSchedule",
      "TapeShieldCableInfo",
      "TargetLevelSchedule",
      "Terminal",
      "ThermalGeneratingUnit",
      "TimePoint",
      "TimeSchedule",
      "TopologicalIsland",
      "TopologicalNode",
      "TransformerCoreAdmittance",
      "TransformerEndInfo",
      "TransformerMeshImpedance",
      "TransformerStarImpedance",
      "TransformerTank",
      "TransformerTankEnd",
      "TransformerTankInfo",
      "VoltageControlZone",
      "VoltageLevel",
      "VoltageLimit",
      "WindGeneratingUnit",
      "WireAssemblyInfo",
      "WirePosition",
      "WireSegment",
      "WireSegmentPhase",
      "WireSpacingInfo"
    ],
    "ModelEntity": [
      "ACLineSegment",
      "ACLineSegmentPhase",
      "ActivePower",
      "ActivePowerChangeRate",
      "ActivePowerLimit",
      "ActivePowerPerCurrentFlow",
      "ActivePowerPerFrequency",
      "Admittance",
      "Agreement",
      "AirCompressor",
      "AngleDegrees",
      "AngleRadians",
      "ApparentPower",
      "ApparentPowerLimit",
      "Appointment",
      "Approver",
      "Area",
      "AsynchronousMachine",
      "AsynchronousMachineKind",
      "Author",
      "BaseFrequency",
      "BasePower",
      "BaseVoltage",
      "BatteryStateKind",
      "BatteryUnit",
      "Bay",
      "BranchGroup",
      "BranchGroupTerminal",
      "BreakerConfiguration",
      "BusNameMarker",
      "BusbarConfiguration",
      "BusbarSection",
      "BusbarSectionInfo",
      "BushingInfo",
      "BushingInsulationKind",
      "CAESPlant",
      "CableConstructionKind",
      "CableOuterJacketKind",
      "CableShieldMaterialKind",
      "Capacitance",
      "CapacitancePerLength",
      "Clamp",
      "Classification",
      "CogenerationPlant",
      "CombinedCyclePlant",
      "CompositeSwitch",
      "ConcentricNeutralCableInfo",
      "Conductance",
      "ConductancePerLength",
      "ConfigurationEvent",
      "ConnectivityNode",
      "CoolantType",
      "CoordinateSystem",
      "CostPerEnergyUnit",
      "CostPerHeatUnit",
      "CostPerVolume",
      "CostRate",
      "Crew",
      "CrewMember",
      "CrewStatusKind",
      "CrewType",
      "Currency",
      "CurrentFlow",
      "CurrentLimit",
      "CurveData",
      "CurveStyle",
      "Cut",
      "Damping",
      "Date",
      "DateInterval",
      "DateTime",
      "DateTimeInterval",
      "DecimalQuantity",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "Displacement",
      "Duration",
      "Editor",
      "ElectronicAddress",
      "Emission",
      "EmissionAccount",
      "EmissionCurve",
      "EmissionType",
      "EmissionValueSource",
      "EnergyConsumer",
      "EnergyConsumerPhase",
      "EnergySchedulingType",
      "EnergySource",
      "EnergySourcePhase",
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentNetwork",
      "EquivalentShunt",
      "ExtensionItem",
      "ExtensionsList",
      "ExternalNetworkInjection",
      "Feeder",
      "FieldDispatchHistory",
      "FieldDispatchStep",
      "FloatQuantity",
      "FossilFuel",
      "Frequency",
      "FrequencyConverter",
      "FuelAllocationSchedule",
      "FuelType",
      "Fuse",
      "GenUnitOpCostCurve",
      "GenUnitOpSchedule",
      "GeneratorControlMode",
      "GeneratorControlSource",
      "GeographicalRegion",
      "GrossToNetActivePowerCurve",
      "Ground",
      "GroundDisconnector",
      "GroundingImpedance",
      "Hazard",
      "HeatInputCurve",
      "HeatRate",
      "HeatRateCurve",
      "Hours",
      "HydroEnergyConversionKind",
      "HydroGeneratingEfficiencyCurve",
      "HydroGeneratingUnit",
      "HydroPlantStorageKind",
      "HydroPowerPlant",
      "HydroPump",
      "HydroPumpOpSchedule",
      "Impedance",
      "IncrementalHeatRateCurve",
      "Inductance",
      "InductancePerLength",
      "InflowForecast",
      "IntegerQuantity",
      "InterrupterUnitInfo",
      "InterruptingMediumKind",
      "IrregularIntervalSchedule",
      "IrregularTimePoint",
      "Issuer",
      "Jumper",
      "Junction",
      "KiloActivePower",
      "Length",
      "LevelVsVolumeCurve",
      "Line",
      "LinearShuntCompensator",
      "LinearShuntCompensatorPhase",
      "LoadBreakSwitch",
      "Location",
      "Mass",
      "Minutes",
      "Money",
      "MonthDay",
      "MonthDayInterval",
      "MutualCoupling",
      "Name",
      "NameType",
      "NameTypeAuthority",
      "NoLoadTest",
      "NonlinearShuntCompensator",
      "NonlinearShuntCompensatorPhase",
      "NonlinearShuntCompensatorPhasePoint",
      "NonlinearShuntCompensatorPoint",
      "NuclearGeneratingUnit",
      "OpenCircuitTest",
      "OperatingMechanismInfo",
      "OperatingMechanismKind",
      "OperatingParticipant",
      "OperatingShare",
      "OperationalLimitDirectionKind",
      "OperationalLimitSet",
      "OperationalLimitType",
      "Operator",
      "OrganisationRole",
      "OverheadWireInfo",
      "Ownership",
      "PSRType",
      "PU",
      "ParentOrganization",
      "PenstockLossCurve",
      "PerCent",
      "PerLengthPhaseImpedance",
      "PerLengthSequenceImpedance",
      "Person",
      "PetersenCoil",
      "PetersenCoilModeKind",
      "PhaseCode",
      "PhaseImpedanceData",
      "PhaseShuntConnectionKind",
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerLinear",
      "PhaseTapChangerSymmetrical",
      "PhaseTapChangerTable",
      "PhaseTapChangerTablePoint",
      "PhaseTapChangerTabular",
      "PhotoVoltaicUnit",
      "Plant",
      "PositionPoint",
      "PowerElectronicsConnection",
      "PowerElectronicsConnectionPhase",
      "PowerElectronicsWindUnit",
      "PowerTransformer",
      "PowerTransformerEnd",
      "PowerTransformerInfo",
      "Pressure",
      "Priority",
      "RatioTapChanger",
      "RatioTapChangerTable",
      "RatioTapChangerTablePoint",
      "Reactance",
      "ReactancePerLength",
      "ReactiveCapabilityCurve",
      "ReactivePower",
      "RealEnergy",
      "Recloser",
      "RegularTimePoint",
      "RegulatingControlModeKind",
      "RegulationSchedule",
      "ReportingGroup",
      "ReportingSuperGroup",
      "Reservoir",
      "Resistance",
      "ResistancePerLength",
      "RotationSpeed",
      "SVCControlMode",
      "ScheduledEvent",
      "ScheduledEventData",
      "Seconds",
      "Sectionaliser",
      "SeriesCompensator",
      "ShortCircuitRotorKind",
      "ShortCircuitTest",
      "ShuntCompensatorInfo",
      "ShutdownCurve",
      "SinglePhaseKind",
      "SolarGeneratingUnit",
      "Speed",
      "StartIgnFuelCurve",
      "StartMainFuelCurve",
      "StartRampCurve",
      "StartupModel",
      "StaticVarCompensator",
      "Status",
      "SteamSendoutSchedule",
      "StreetAddress",
      "StreetDetail",
      "StringQuantity",
      "SubGeographicalRegion",
      "Substation",
      "Susceptance",
      "SusceptancePerLength",
      "SwitchInfo",
      "SwitchPhase",
      "SwitchSchedule",
      "SynchronousMachine",
      "SynchronousMachineKind",
      "SynchronousMachineOperatingMode",
      "TailbayLossCurve",
      "TapChangerControl",
      "TapChangerInfo",
      "TapSchedule",
      "TapeShieldCableInfo",
      "TargetLevelSchedule",
      "TelephoneNumber",
      "Temperature",
      "Terminal",
      "ThermalGeneratingUnit",
      "Time",
      "TimeInterval",
      "TimePoint",
      "TimeSchedule",
      "TopologicalIsland",
      "TopologicalNode",
      "TownDetail",
      "TransformerControlMode",
      "TransformerCoreAdmittance",
      "TransformerEndInfo",
      "TransformerMeshImpedance",
      "TransformerStarImpedance",
      "TransformerTank",
      "TransformerTankEnd",
      "TransformerTankInfo",
      "UnitMultiplier",
      "UnitSymbol",
      "UserAttribute",
      "Version",
      "Voltage",
      "VoltageControlZone",
      "VoltageLevel",
      "VoltageLimit",
      "VoltagePerReactivePower",
      "Volume",
      "VolumeFlowRate",
      "WaterLevel",
      "WindGenUnitKind",
      "WindGeneratingUnit",
      "WindingConnection",
      "WireAssemblyInfo",
      "WireInsulationKind",
      "WireMaterialKind",
      "WirePhaseInfo",
      "WirePosition",
      "WireSegment",
      "WireSegmentPhase",
      "WireSpacingInfo",
      "WireUsageKind"
    ],
    "OperationPersonRole": [
      "CrewMember",
      "Operator"
    ],
    "OperationalLimit": [
      "ActivePowerLimit",
      "ApparentPowerLimit",
      "CurrentLimit",
      "VoltageLimit"
    ],
    "Organisation": [
      "ParentOrganization"
    ],
    "PerLengthImpedance": [
      "PerLengthPhaseImpedance",
      "PerLengthSequenceImpedance"
    ],
    "PerLengthLineParameter": [
      "PerLengthPhaseImpedance",
      "PerLengthSequenceImpedance"
    ],
    "PersonRole": [
      "Approver",
      "Author",
      "CrewMember",
      "Editor",
      "Issuer",
      "Operator"
    ],
    "PhaseTapChanger": [
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerLinear",
      "PhaseTapChangerSymmetrical",
      "PhaseTapChangerTabular"
    ],
    "PhaseTapChangerNonLinear": [
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerSymmetrical"
    ],
    "PowerElectronicsUnit": [
      "BatteryUnit",
      "PhotoVoltaicUnit",
      "PowerElectronicsWindUnit"
    ],
    "PowerSystemResource": [
      "ACLineSegment",
      "ACLineSegmentPhase",
      "AirCompressor",
      "AsynchronousMachine",
      "BatteryUnit",
      "Bay",
      "BusbarSection",
      "CAESPlant",
      "Clamp",
      "CogenerationPlant",
      "CombinedCyclePlant",
      "CompositeSwitch",
      "Cut",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "EnergyConsumer",
      "EnergyConsumerPhase",
      "EnergySource",
      "EnergySourcePhase",
      "EquivalentBranch",
      "EquivalentInjection",
      "EquivalentNetwork",
      "EquivalentShunt",
      "ExternalNetworkInjection",
      "Feeder",
      "FrequencyConverter",
      "Fuse",
      "Ground",
      "GroundDisconnector",
      "GroundingImpedance",
      "HydroGeneratingUnit",
      "HydroPowerPlant",
      "HydroPump",
      "Jumper",
      "Junction",
      "Line",
      "LinearShuntCompensator",
      "LinearShuntCompensatorPhase",
      "LoadBreakSwitch",
      "NonlinearShuntCompensator",
      "NonlinearShuntCompensatorPhase",
      "NuclearGeneratingUnit",
      "PetersenCoil",
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerLinear",
      "PhaseTapChangerSymmetrical",
      "PhaseTapChangerTabular",
      "PhotoVoltaicUnit",
      "Plant",
      "PowerElectronicsConnection",
      "PowerElectronicsConnectionPhase",
      "PowerElectronicsWindUnit",
      "PowerTransformer",
      "RatioTapChanger",
      "Recloser",
      "Reservoir",
      "Sectionaliser",
      "SeriesCompensator",
      "SolarGeneratingUnit",
      "StaticVarCompensator",
      "Substation",
      "SwitchPhase",
      "SynchronousMachine",
      "TapChangerControl",
      "ThermalGeneratingUnit",
      "TransformerTank",
      "VoltageControlZone",
      "VoltageLevel",
      "WindGeneratingUnit",
      "WireSegment",
      "WireSegmentPhase"
    ],
    "ProtectedSwitch": [
      "DisconnectingCircuitBreaker",
      "LoadBreakSwitch",
      "Recloser"
    ],
    "RegularIntervalSchedule": [
      "GenUnitOpSchedule",
      "HydroPumpOpSchedule",
      "InflowForecast",
      "RegulationSchedule",
      "SteamSendoutSchedule",
      "SwitchSchedule",
      "TapSchedule"
    ],
    "RegulatingCondEq": [
      "AsynchronousMachine",
      "ExternalNetworkInjection",
      "FrequencyConverter",
      "LinearShuntCompensator",
      "NonlinearShuntCompensator",
      "PowerElectronicsConnection",
      "StaticVarCompensator",
      "SynchronousMachine"
    ],
    "RegulatingControl": [
      "TapChangerControl"
    ],
    "RotatingMachine": [
      "AsynchronousMachine",
      "SynchronousMachine"
    ],
    "ShuntCompensator": [
      "LinearShuntCompensator",
      "NonlinearShuntCompensator"
    ],
    "ShuntCompensatorPhase": [
      "LinearShuntCompensatorPhase",
      "NonlinearShuntCompensatorPhase"
    ],
    "Switch": [
      "Cut",
      "DisconnectingCircuitBreaker",
      "Disconnector",
      "Fuse",
      "GroundDisconnector",
      "Jumper",
      "LoadBreakSwitch",
      "Recloser",
      "Sectionaliser"
    ],
    "TapChanger": [
      "PhaseTapChangerAsymmetrical",
      "PhaseTapChangerLinear",
      "PhaseTapChangerSymmetrical",
      "PhaseTapChangerTabular",
      "RatioTapChanger"
    ],
    "TapChangerTablePoint": [
      "PhaseTapChangerTablePoint",
      "RatioTapChangerTablePoint"
    ],
    "TransformerEnd": [
      "PowerTransformerEnd",
      "TransformerTankEnd"
    ],
    "TransformerTest": [
      "NoLoadTest",
      "OpenCircuitTest",
      "ShortCircuitTest"
    ],
    "ViewObjectPropertyValue": [
      "ReferenceValue",
      "StringValue"
    ],
    "WireInfo": [
      "ConcentricNeutralCableInfo",
      "OverheadWireInfo",
      "TapeShieldCableInfo"
    ]
  }
};
      export default result;
    